module.exports = {
  login: {
    'UserName': 'Nama pengguna',
    'PassWord': '\xa0\xa0\xa0\xa0\xa0\xa0Kata sandi\xa0\xa0\xa0\xa0\xa0\xa0',
    'Login': 'Login',
    'Account cannot be empty': 'Akun tidak boleh kosong'
  },
  homePage: {
    'Policy': 'Kebijakan',
    'Product': 'Produk',
    'Order': 'Pesan',
    'After-sales': 'After-sales',
    'Audit': 'Audit',
    'Finance and taxation': 'Keuangan dan perpajakan',
    'Settings': 'Pengaturan',
    'Announcement': 'Pengumuman',
    'Please enter a keyword': 'Silakan masukkan kata kunci',
    'Publisher': 'Penerbit',
    'Confirm deletion of selected records?': 'Konfirmasi penghapusan catatan yang dipilih?',
    'Notification': 'Pemberitahuan',
    'Processed': 'Olahan',
    'Personal Information': 'Informasi Pribadi',
    'Change Password': 'Ganti Kata Sandi',
    'Edit Profile': 'Edit Profil',
    'Please enter the correct email format': 'Silakan masukkan format email yang benar',
    'Phone': 'Telepon',
    'Phone number must be a number': 'Nomor telepon harus nomor',
    'Original password': 'Kata sandi asli',
    'New password': 'Kata sandi baru',
    'Inconsistent password entered twice!': 'Kata sandi tidak konsisten dimasukkan dua kali!',
    'Mobile phone number cannot be empty': 'Nomor ponsel tidak boleh kosong',
    'Please enter the correct mobile phone number': 'Silakan masukkan nomor ponsel yang benar',
    'Please enter your real name': 'Silakan masukkan nama asli Anda',
    'Mailbox format input error': 'Kesalahan input format kotak surat',
    'Personal data modified successfully': 'Data pribadi berhasil dimodifikasi',
    'Failed to modify state': 'Gagal memodifikasi keadaan',
    'Password change is successful, please log in to the system again': 'Jika perubahan kata sandi berhasil, silakan masuk ke sistem lagi',
    'Pass': 'Lulus',
    'Exit the system, whether to continue?': 'Keluar dari sistem, apakah akan melanjutkan?',
    'Please change the login password first': 'Silakan ubah kata sandi login terlebih dahulu',
    'ws I was destroyed, remove monitor > > >': 'ws saya dihancurkan, lepaskan monitor >>>'
  },
  forgotPassword: {
    'Login': 'Login',
    'Enter login name': 'Masukkan nama login',
    'Verify identity': 'Verifikasi identitas',
    'Next step': 'Langkah selanjutnya',
    'Retrieve password method': 'Metode pengambilan kata sandi',
    'Mailbox Retrieval': 'Mailbox Retrieval',
    'Sent verification email': 'Kirim email verifikasi',
    'Sent verification email To': 'Mengirim email verifikasi Ke',
    'The verification email is valid for 48 hours please log in to the mailbox ASAP to complete the verification': 'Email verifikasi berlaku selama 48 jam, silakan masuk ke kotak surat secepatnya untuk menyelesaikan verifikasi.',
    'Password changed successfully, please re': 'Kata sandi berhasil diubah, silakan ulang',
    'Automatically jump to the login page after seconds': 'Secara otomatis melompat ke halaman login setelah detik',
    'Inconsistent password entered twice !': ' Kata sandi tidak konsisten dimasukkan dua kali!',
    'Secret protection recovery': 'Pemulihan Aman',
    'If the password cannot be retrieved please contact the administrator': 'Jika kata sandi tidak dapat diambil, silakan hubungi administrator'
  },
  account: {
    'Login must be letters or numbers': 'Login harus berupa huruf atau angka',
    'Confidentiality': 'Kerahasiaan',
    'Department': 'Departemen',
    'Position': 'Posisi',
    'Please select a position': 'Silakan pilih posisi',
    'Character Name': 'Nama Karakter',
    'Please select a role': 'Silakan pilih peran',
    'Please fill in the account number': 'Silahkan isi nomor rekening',
    'The account number must be a combination of numbers and letters': 'Nomor rekening harus kombinasi angka dan huruf',
    'Please fill in the mobile phone number': 'Silakan isi nomor ponsel',
    'Please fill in the correct mobile phone number': 'Silakan isi nomor ponsel yang benar',
    'Please fill in the password': 'Silakan isi kata sandi',
    'Please fill in the password again': 'Silakan isi kata sandi lagi',
    'Inconsistent password filled in twice': 'Kata sandi tidak konsisten diisi dua kali',
    'Please fill in your real name': 'Silakan isi nama asli Anda',
    'Please select a department name': 'Silakan pilih nama departemen',
    'Please select a job title': 'Silakan pilih jabatan',
    'Please select a role name': 'Silakan pilih nama peran',
    'Enabled': 'Diaktifkan',
    'Deleted': 'Dihapus',
    'Operation failed': 'Operasi gagal',
    'The mailbox format is incorrect': 'Format kotak surat salah',
    'Added/modified account successfully': 'Akun yang berhasil ditambahkan / dimodifikasi',
    'New account': 'Akun baru',
    'Edit account': 'Edit akun',
    'Article': 'Artikel',
    ',Failed: ': ',Kegagalan :',
    'Status Success': 'Status Sukses',
    'Status Failed': 'Status Gagal',
    'Are you sure the reset password is 123456 ?': 'Apakah Anda yakin kata sandi reset adalah 123456?',
    'Reset password to 123456': 'Setel ulang kata sandi ke 123456',
    'Failed to reset password': 'Gagal mengatur ulang kata sandi',
    'Administrator account management': 'Manajemen akun administrator'
  },
  configuration: {
    'New system configuration': 'Konfigurasi sistem baru',
    'Configuration name': 'Nama konfigurasi',
    'Configuration code': 'Kode konfigurasi',
    'Configuration value': 'Nilai konfigurasi'
  },
  operatelog: {
    'Operation date': 'Tanggal operasi',
    'Clear data': 'Data yang jelas',
    'Please select start date and end date': 'Silakan pilih tanggal mulai dan tanggal akhir',
    'Confirm that the data is cleared according to the query conditions?': 'Konfirmasikan bahwa data dibersihkan sesuai dengan kondisi kueri?',
    'Deleted successfully': 'Berhasil dihapus',
    'Bar data': 'Data bar'
  },
  orderlist: {
    'System pending': 'Sistem tertunda',
    'System processing': 'Pemrosesan sistem',
    'Abnormal order': 'Urutan abnormal',
    'Manual pending payment': 'Pembayaran tertunda manual',
    'Manual pending processing': 'Pemrosesan tertunda manual',
    'Order status': 'Status pesanan',
    'Start taking orders': 'Mulai menerima pesanan',
    'Stop taking orders': 'Berhenti menerima perintah',
    'Platform': 'Platform',
    'Please select a platform': 'Silakan pilih platform',
    'Departure Date': 'Tanggal mulai penerbangan',
    'Arrival Date': 'Tanggal akhir penerbangan',
    'ID number': 'Nomor ID',
    'Order Start': 'Waktu mulai pesanan',
    'Creation start time': 'Waktu mulai pembuatan',
    'Order End': 'Waktu akhir pesanan',
    'Creation end time': 'Waktu akhir penciptaan',
    'Lock order type': 'Jenis pesanan kunci',
    'Lock single person': 'Kunci satu orang',
    'Auditor': 'Auditor',
    'Verification status': 'Status verifikasi',
    'Platform refund has been settled': 'Pengembalian dana platform telah diselesaikan',
    'Purchase rebate settled': 'Rabat pembelian diselesaikan',
    'Settlement completed': 'Penyelesaian selesai',
    'Audit start date': 'Tanggal mulai audit',
    'Audit end date': 'Tanggal akhir audit',
    'Auto refresh': 'Penyegaran otomatis',
    'Enter ticket': 'Tiket masuk',
    'Batch Re-Occupy': 'Batch Re-Occupy',
    'Bulk Ticket Reset': 'Set Ulang Tiket Massal',
    'Batch modification class': 'Kelas modifikasi batch',
    'Bulk Booking Instructions': 'Instruksi Pemesanan Massal',
    'Batch platform collection verification account': 'Akun verifikasi pengumpulan platform batch',
    'Bulk Purchase Payment Verification': 'Verifikasi Pembayaran Pembelian Massal',
    'Latest Ticketing Time/Order Date': 'Waktu / Tarikh Perintah',
    'Platform Information': 'Informasi Platform',
    'Platform order number': 'Nomor pesanan platform',
    'Exception': 'Pengecualian',
    'Appeal': 'Banding',
    'Urge': 'dorongan',
    'Order Status/Sub-Status': 'Status Order',
    'Flight information': 'Informasi penerbangan',
    'Purchasing Information': 'Informasi Pembelian',
    'Expenditure Amount': 'Jumlah Pengeluaran',
    'PNR/AV status': 'PNR',
    'Total price/number of people': 'Total harga / jumlah orang',
    'Unlock': 'Buka kunci',
    'Drawer': 'Laci',
    'Ticketing efficiency': 'Efisiensi tiket',
    'Auditor/Audit status': 'Status Audit / Audit',
    'Platform collection has been settled': 'Pengumpulan platform telah diselesaikan',
    'Purchase payment settled': 'Pembayaran pembelian diselesaikan',
    'Are you sure to retake your seat?': 'Apakah Anda yakin untuk merebut kembali kursi Anda?',
    'Repay': 'Balas',
    'View': 'Pemandangan',
    'Processing': 'Pemrosesan',
    'Are you sure to cancel the top?': 'Apakah Anda yakin untuk membatalkan bagian atas?',
    'Journal': 'Jurnal',
    'Cancel the top': 'Batalkan bagian atas',
    'Order Details': 'Detail Pesanan',
    'Order Information :': 'Informasi Pesanan:',
    'Original order number': 'Nomor pesanan asli',
    'Parent order number': 'Nomor pesanan orang tua',
    'Sub-order number': 'Nomor sub-order',
    'Brother order number': 'Abang pesan nomor',
    'Small code': 'kode kecil',
    'Child Code': 'Kode Anak',
    'Order Type': 'Jenis Pesanan',
    'Order source': 'Sumber pesanan',
    'Total price': 'Harga total',
    'Contact phone number': 'Nomor telepon kontak',
    'Voyage': 'Voyage',
    'Nationality': 'Kebangsaan',
    'Certificate valid period': 'Masa berlaku sertifikat',
    'Purchase Records': 'Catatan Pembelian',
    'Procurement channel': 'Saluran pengadaan',
    'Automatic': 'Otomatis',
    'Labor': 'Buruh',
    'Transaction record': 'Catatan transaksi',
    'Transaction Channel': 'Saluran Transaksi',
    'Transaction Amount': 'Jumlah Transaksi',
    'Trading hours': 'Jam perdagangan',
    'Ticket Log': 'Log Tiket',
    'Dispatch': 'Dispatch',
    'Account number': 'Nomor rekening',
    'Upload file': 'Upload file',
    'Ticket channel': 'Saluran tiket',
    'Purchase payment verification details': 'Detail verifikasi pembayaran pembelian',
    'Purchase payment verification import': 'Impor verifikasi pembayaran pembelian',
    'Audit account type': 'Jenis akun audit',
    'Purchase Receipt Audit Account': 'Rekening Audit Tanda Terima Pembelian',
    'Platform refund verification account': 'Akun verifikasi pengembalian dana platform',
    'Platform collection verification account': 'Akun verifikasi pengumpulan platform',
    'Purchase payment verification': 'Verifikasi pembayaran pembelian',
    'Number of orders': 'Jumlah pesanan',
    'Time consuming': 'Memakan Waktu',
    'File path': 'Jalur file',
    'Export': 'Ekspor',
    'Upload purchase payment verification details': 'Unggah detail verifikasi pembayaran pembelian',
    'Directive': 'Petunjuk',
    'Platform collection verification account details': 'Detail akun verifikasi pengumpulan platform',
    'Platform collection and verification account import': 'Impor akun pengumpulan dan verifikasi platform',
    'Upload platform collection verification details': 'Detail verifikasi pengumpulan platform unggah',
    'Class Code': 'Kode Kelas',
    'Shared flights': 'Penerbangan bersama',
    'Child Booking Instructions': 'Petunjuk Pemesanan Anak',
    'Please fill in the class': 'Silahkan isi kelas',
    'Please select the verification type': 'Silakan pilih jenis verifikasi',
    'Please select an account': 'Silakan pilih akun',
    'Designated cabin code cannot be empty': 'Kode kabin yang ditunjuk tidak boleh kosong',
    'Please select a reason for cancellation': 'Silakan pilih alasan pembatalan',
    'Please select a store': 'Silakan pilih toko',
    'Batch booking codes cannot be booked for different flight segments': 'Kode pemesanan batch tidak dapat dipesan untuk segmen penerbangan yang berbeda',
    'Please select at least one order': 'Silakan pilih setidaknya satu pesanan',
    'The maximum number of people in the batch booking code can only be 9 people': 'Jumlah maksimum orang dalam kode pemesanan batch hanya dapat 9 orang',
    'Reservation code successful': 'Kode reservasi berhasil',
    'Bulk booking instructions cannot be made for different flight segments': 'Instruksi pemesanan massal tidak dapat dibuat untuk segmen penerbangan yang berbeda',
    'The maximum number of bulk booking orders can only be 9 people': 'Jumlah maksimum pesanan pemesanan massal hanya dapat 9 orang',
    'Different airlines cannot modify in batches': 'Maskapai yang berbeda tidak dapat memodifikasi secara batch',
    'Failed to cancel the order, reason :': 'Gagal membatalkan pesanan, alasan:',
    'Added successfully View scan results later': 'Ditambahkan berhasil Lihat hasil pindaian nanti',
    'Are you sure to export the data?': 'Apakah Anda yakin untuk mengekspor data?',
    'Passenger Information not found': 'Informasi penumpang tidak ditemukan',
    'Failed to query purchase records': 'Gagal menanyakan catatan pembelian',
    'Airline code configuration not found': 'Konfigurasi kode maskapai tidak ditemukan',
    'Updated order remarks successfully!': 'Komentar pesanan yang diperbarui berhasil!',
    'Failed to fill': 'Gagal mengisi',
    'Ticket issued has been approved': 'Tiket yang dikeluarkan telah disetujui',
    'There are orders that do not meet the conditions for re-occupation because they are not ticketed and cancelled': 'Ada pesanan yang tidak memenuhi syarat untuk pendudukan kembali karena tidak ditilang dan dibatalkan.',
    'The platform ticket number is:': 'Nomor tiket platformnya adalah:',
    'There are orders that do not meet the conditions for re-occupation,': 'Ada perintah yang tidak memenuhi syarat untuk pendudukan kembali,',
    'There are orders that do not meet the conditions for ticketing reset because they are not ticketed and cancelled': 'Ada pesanan yang tidak memenuhi syarat untuk reset tiket karena tidak ditilang dan dibatalkan.',
    'There are orders that do not meet the conditions for ticket reset,': 'Ada pesanan yang tidak memenuhi syarat untuk reset tiket,',
    'Different airlines cannot reset in batches': 'Maskapai yang berbeda tidak dapat mengatur ulang secara berkelompok',
    'System lock order': 'Urutan kunci sistem',
    'My lock list': 'Daftar kunci saya',
    'Unlocked order': 'Urutan tidak terkunci',
    'The verification end date must be greater than or equal to the start date': 'Tanggal akhir verifikasi harus lebih besar dari atau sama dengan tanggal mulai',
    'The current limit selects 2 files, this time it is selected': 'Batas saat ini memilih 2 file, kali ini dipilih',
    'Please select upload file': 'Silakan pilih file unggahan',
    'Confirm that the data is exported according to the condition?': 'Konfirmasikan bahwa data diekspor sesuai dengan kondisi?',
    'Day': 'Hari',
    'hours': 'jam',
    'seconds': 'kedua',
    'Remaining': 'Sisa',
    'Beyond': 'Beyond',
    'Number of exceptions:': 'Jumlah pengecualian:',
    'Are you sure you want to start taking orders?': 'Apakah Anda yakin ingin mulai menerima pesanan?',
    'Query employee dispatch abnormality': 'Pertanyaan karyawan pengiriman kelainan.',
    'Processing the refund order is full and cannot be dispatched': 'Pemrosesan pesanan pengembalian dana penuh dan tidak dapat di kirim',
    'Are you sure you want to stop taking orders?': 'Apakah Anda yakin ingin berhenti menerima pesanan?',
    'Successful delivery of the order': 'Keberhasilan pengiriman pesanan',
    'Cancel the top successfully': 'Batalkan bagian atas dengan sukses',
    'ws I was destroyed, vue lifecycle>>>': 'Keberhasilan pengiriman pesanan>>>'
  },
  '首页': 'Beranda',
  '出票': 'Tiket',
  '机票': 'Flight',
  '出票单查询': 'Pertanyaan Tiket',
  '待筛单': 'Untuk disaring',
  '已锁待处理': ' Pemrosesan Pending Terkunci',
  '全部待处理': ' Pemrosesan Pending Terkunci',
  '出票完成': 'Tiket selesai',
  '订单取消': 'Pembatalan Pesanan',
  '票号验证': 'Verifikasi nomor tiket',
  '异常客票': ' Tiket abnormal',
  'OPEN票': 'Tiket BUKA',
  '航变信息': 'Informasi perubahan penerbangan',
  '行程单': 'Itinerary',
  '刷票订单': 'Itinerary',
  '辅助下单': 'Penempatan pesanan tambahan',
  '航变订阅': 'Langganan Airchange',
  '航班动态': 'Berita Penerbangan',
  '改签': 'Perubahan',
  '改签单查询': 'Ganti pertanyaan pesanan',
  '已锁结算异常': 'Pengecualian pemukiman terkunci',
  '改签取消': 'Perubahan Batal',
  '退票': 'Refund',
  '退票单查询': 'Penyelidikan formulir pengembalian dana',
  '已锁退票异常': 'Pengecualian pengembalian dana terkunci',
  '全部退票异常': 'Semua pengembalian uang tidak normal',
  '全部结算异常': 'Semua pengecualian pemukiman',
  '核销异常待处理': 'Pengecualian verifikasi tertunda',
  '退票取消': 'Pembatalan Pengembalian Dana',
  '辅助退票': 'Pengembalian dana tambahan',
  '退票费确认': 'Konfirmasi biaya pengembalian dana',
  '异常单': 'Exception order',
  '异常单查询': 'Permintaan tunggal eksepsi',
  '已锁异常回款': 'Pengembalian dana abnormal terkunci',
  '全部异常回款': 'Semua pengembalian uang yang tidak normal',
  '异常取消': 'Pembatalan Abnormal',
  '申诉单': 'Formulir Banding',
  '申诉订单': 'Perintah Banding',
  '报表': 'Laporan',
  '出票订单报表': 'Laporan Pemesanan Tiket',
  '改签订单报表': 'Ganti laporan pesanan',
  '退票订单报表': 'Laporan Perintah Pengembalian Dana',
  '异常订单报表': 'Laporan Perintah Abnormal',
  '出票实时汇总报表': 'Laporan ringkasan tiket real-time',
  '稽核': 'Audit',
  '改签待结算': 'Perubahan yang harus diselesaikan',
  '改签已结算': 'Perubahan diselesaikan',
  '退票待结算': 'Pengembalian dana menunggu penyelesaian',
  '退票已结算': 'Refund menetap',
  '异常待结算': 'Penyelesaian Pending Luar Biasa',
  '异常已结算': 'Pengecualian diselesaikan',
  '运价政策': 'Kebijakan Tarif',
  '公布运价': 'Tarif Diterbitkan',
  '官网运价': 'Pengiriman situs web resmi',
  '官网运价NEW': 'Pengiriman situs web resmi BARU',
  '航班周期管理': 'Manajemen Siklus Penerbangan',
  '公布运价扫描': 'Publish Tariff Scan',
  'Eterm数据扫描': 'Pemindaian Data Eterm',
  'Eterm指令查询': 'Eterm command query',
  '疫情订单匹配': 'Pencocokan pesanan epidemi',
  '外部运价查询': 'Permintaan pengiriman eksternal',
  '出票规则': 'Aturan Tiket',
  '出票设置': 'Pengaturan Tiket',
  '出票账号管理': 'Manajemen akun tiket',
  '出票过滤': 'Pemfilteran tiket',
  '出票自动AV订座': 'AV / reservasi otomatis tiket',
  '出票渠道管理': 'Manajemen saluran tiket',
  '付款渠道管理': 'Manajemen saluran pembayaran',
  '派单设置': 'Pengaturan Pengiriman',
  '退票规则': 'Aturan Pengembalian Dana',
  '退票提醒时间设置': 'Refund reminder time setting',
  '退票提醒信息设置': 'Refund reminder information setting',
  '退票处理时限设置': 'Pengaturan batas waktu pemrosesan pengembalian dana',
  '航司退改规则': 'Aturan pengembalian uang maskapai',
  '自动退票规则': 'Aturan pengembalian dana otomatis',
  '产品管理': 'Manajemen Produk',
  '航司调价': 'Penyesuaian harga maskapai',
  '航线调价': 'Penyesuaian harga rute',
  '产品日志': 'Log Produk',
  '投放日志': 'Drop log',
  '航变国航': 'Air China',
  '航变东航': 'Penerbangan ke China Eastern Airlines',
  '系统监控': 'Pemantauan Sistem',
  '报价接口查询': 'Quotation interface query',
  '直连接口状态': 'Status Antarmuka Sambungan Langsung',
  '比价查询': 'Pertanyaan perbandingan harga',
  '短信查询': 'Kueri SMS',
  '系统配置': 'Konfigurasi sistem',
  '店铺管理': 'Manajemen Toko',
  '系统设置': 'Pengaturan Sistem',
  '代理费管理': 'Manajemen biaya agensi',
  '机场信息': 'Informasi Bandara',
  '设置': 'Pengaturan',
  '账号管理': 'Manajemen akun',
  '角色管理': 'Manajemen Peran',
  '部门管理': 'Manajemen Departemen',
  '岗位管理': 'Manajemen Pos',
  '公告管理': 'Manajemen pengumuman',
  '操作日志': 'Log operasi',
  '渠道': 'Saluran',
  '扫舱政策': 'Kebijakan',
  '产品': 'Produk',
  '调价设置': 'Pengaturan penyesuaian harga',
  '产品监控': 'Pemantauan Produk',
  '直连监控': 'Pemantauan koneksi langsung',
  '订单': 'Pesan',
  '出票订单': 'Perintah Tiket',
  '国际机票': 'Tiket Internasional',
  '售后': 'After-sales',
  '退票订单': 'Perintah Pembayaran',
  '改签订单': 'Ubah urutan',
  '异常订单': 'Urutan abnormal',
  '账单': 'Bill',
  '商户现金明细': 'Detail Kas Pedagang',
  '资金交易明细': 'Rincian transaksi modal',
  '财税': 'Keuangan dan perpajakan',
  '业务报表': 'Laporan Bisnis',
  '财务报表': 'Laporan Keuangan',
  '权限控制': 'Kontrol Izin',
  '基础配置': 'Konfigurasi dasar',
  '导出': 'Ekspor',
  '查看': 'View',
  '日志': 'Log',
  '解锁': 'Buka kunci',
  '导入': 'Impor',
  '处理': 'Pengolahan',
  '重新占座': 'kembali menempati kursi',
  '重新支付': 'Re-pay',
  '核账': 'Akun audit',
  '订单详情': 'Detail Pesanan',
  '标记验证通过': 'Verifikasi tanda lulus',
  '标记验证不通过': 'Verifikasi Mark gagal',
  '忽略验证': 'Abaikan validasi',
  '核实通过': 'Diverifikasi melalui',
  '重新回填': 'Backfill',
  '已打印': 'Dicetak',
  '已快递': 'Express',
  '已取消': 'Dibatalkan',
  '已退票': 'Dikembalikan',
  'Eterm指令': 'Eterm directive',
  '详情': 'Detail',
  '编辑': 'Sunting',
  '重新刷票': 'Gesek ulang tiketnya',
  '已出票': 'Tiket diterbitkan',
  '取消刷票': 'Batalkan gesekan',
  '开启': 'Buka',
  '暂停': 'Jeda',
  '删除': 'Hapus',
  '清除数据': 'Data yang jelas',
  '新增': 'Baru',
  '付款': 'Pembayaran',
  '解压': 'Unzip',
  '取消置顶': 'Batalkan overhead',
  '派单': 'delivery order',
  '账号规则': 'Aturan Akun',
  '产品设置': 'Pengaturan Produk',
  '航线过滤': 'Filter rute',
  '航线白名单': 'Daftar putih rute',
  '拉单规则': 'Tarik aturan pesanan',
  '重置密码': 'Setel Ulang Kata Sandi',
  '新增角色': 'Peran baru',
  '指定用户': 'Pengguna yang ditunjuk',
  '新增部门': 'Departemen baru',
  '删除部门': 'Hapus departemen',
  '保存': 'Simpan',
  '添加': 'Tambahkan',
  '启用': 'Aktifkan',
  '禁用': 'Nonaktifkan',
  '上线': 'On-line',
  '录入出票单': 'Tiket masuk',
  '录入退票单': 'Masukkan formulir pengembalian dana',
  '改签申请': 'Masukkan dan ubah tanda terima',
  '导出报表': 'Laporan ekspor',
  '核销异常待结算': 'Pengecualian verifikasi menunggu penyelesaian',
  '核销异常已结算': 'Pengecualian verifikasi diselesaikan',
  '待结算': 'Penyelesaian tertunda',
  '已结算': 'Menetap',
  '已锁核销异常待处理': 'Pengecualian verifikasi terkunci tertunda',
  '全部核销异常待处理': 'Semua pengecualian verifikasi tertunda',
  '销售报表': 'Laporan Penjualan',
  '利润报表': 'Pernyataan Laba',
  '交易报表': 'Pernyataan Transaksi',
  '出票单乘机人报表': 'Laporan penumpang tiket',
  '复制': 'Salin',
  '系统日志': 'log sistem',
  '订单乘机人人电话CTM': 'Pesan telepon renren penerbangan CTM',
  '订单联系人电话CTCT': 'Pesan kontak telepon CTCT',
  '去哪儿票号验证接口': 'Antarmuka verifikasi nomor tiket Qunar',
  '航变监控': 'Pemantauan penerbangan',
  '售后订单推送': 'Dorongan pesanan purna jual',
  '异常自动重试': 'Exception auto retry',
  '退票单票号验证': 'Refund verifikasi nomor tiket tunggal',
  '出票利润群推送': 'Dorongan grup laba tiket',
  '订单统计': 'Statistik Pesanan',
  '运营': 'Operasi',
  '菜单管理': 'Manajemen menu',
  '数据字典': 'Kamus data',
  '资源管理': 'Manajemen sumber daya',
  '商家管理': 'Merchant management',
  '任务调度': 'Penjadwalan Tugas',
  '政策爬虫': 'kebijakan python',
  '占座爬虫': 'Menempati kursi python',
  '缓存管理': 'Cache management',
  '商家账号管理': 'Manajemen akun pedagang',
  '常旅客页面': 'Halaman Frequent Flyer',
  '数据': 'Data',
  '财务': 'Keuangan',
  '对账': 'Rekonsiliasi',
  '身份证': 'KTP',
  '护照': 'Paspor',
  '成人': 'Adult',
  '儿童': 'Child',
  '婴儿': 'Infant',
  '语言': 'Bahasa',
  'Please enter username': 'Silakan masukkan nama pengguna',
  'Please enter password': 'Silakan masukkan kata sandi',
  'Error': 'Kesalahan',
  'Password cannot be empty': 'Kata sandi tidak boleh kosong',
  'Success': 'Lulus',
  'Home': 'Rumah',
  'Channel': 'Saluran',
  'Inquiry': 'Pertanyaan',
  'Title': 'Judul',
  'Release time': 'Waktu rilis',
  'Operation': 'Operasi',
  'Delete': 'Hapus',
  'Announcement details': 'Detail Pengumuman',
  'Attachment': 'Lampiran',
  'Tip': 'Tip',
  'Login Name': 'Nama Login',
  'Real Name': 'Nama Asli',
  'Gender': 'Gender',
  'Male': 'Pria',
  'Female': 'Perempuan',
  'Role Name': 'Nama Peran',
  'Job Number': 'Nomor Kerja',
  'Please fill in the job number': 'Silahkan isi nomor pekerjaan',
  'Mail': 'Mail',
  'Cancel': 'Batalkan',
  'Save': 'Simpan',
  'Confirm Password': 'Konfirmasi Kata Sandi',
  'Please enter the password again': 'Silakan masukkan kata sandi lagi',
  'Modified status successfully': 'Modifikasi status berhasil',
  'Yes': 'Oke',
  'Reset-pw': 'Setel Ulang Kata Sandi',
  'Password': 'Kata Sandi',
  'Reset': 'Set ulang',
  'Failed': 'Kegagalan',
  'Contact information': 'Informasi kontak',
  'Import': 'Impor',
  'Added': 'Ditambahkan',
  'Status': 'Status',
  'administrator': 'Nomor Kerja',
  'No': 'Tidak',
  'Department Name': 'Nama Departemen',
  'Job Title': 'Jabatan',
  'Creation time': 'Waktu penciptaan',
  'Edit': 'Sunting',
  'Are you sure to delete?': 'Apakah Anda yakin untuk menghapus?',
  'Please select a department': 'Silakan pilih departemen',
  'Normal': 'Normal',
  'Disable': 'Nonaktifkan',
  'Click to upload': 'Klik untuk mengunggah',
  'Only xlsx files can be uploaded': 'Hanya file xlsx yang dapat diunggah',
  'Download Template': 'Download Template',
  'The current limit selects 1 file, this time it is selected': 'Batas saat ini memilih 1 file, kali ini dipilih',
  'Files selected': 'File dipilih',
  'files': 'File',
  'Please select a file to upload': 'Silakan pilih file untuk diunggah',
  'Modify': 'Modifikasi',
  'OK': 'Oke',
  'Remarks': 'Keterangan',
  'Role Description': 'Deskripsi Karakter',
  'Permission': 'Seleksi izin',
  'Operator': 'Operator',
  'Start date': 'Tanggal mulai',
  'End date': 'Tanggal akhir',
  'End date must be greater than or equal to start date': 'Tanggal akhir harus lebih besar dari atau sama dengan tanggal mulai',
  'Merchant': 'Pedagang',
  'Shop': 'Toko',
  'Order Status': 'Status Order',
  'Policy Code': 'Kode Kebijakan',
  'Platform ticket number': 'Nomor tiket platform',
  'Arrival airport code': 'Kode bandara kedatangan',
  'Flight number': 'Nomor penerbangan',
  'Class': 'Kelas',
  'Passenger Name': 'Nama Penumpang',
  'Ticket number': 'Nomor tiket',
  'Purchase Order Number': 'Nomor Pesanan Pembelian',
  'Change': 'Perubahan',
  'Refund': 'Refund',
  'Share': 'Bagikan',
  'Profit': 'Keuntungan',
  'Passenger': 'Penumpang',
  'Re-occupy the seat': 'Kembali menempati kursi',
  'Ticket Reset': 'Set Ulang Tiket',
  'Are you sure to pay again?': 'Apakah Anda yakin untuk membayar lagi?',
  'Audit account': 'Akun audit',
  'Order number': 'Nomor pesanan',
  'Big Code': 'Kode Besar',
  'Policy Type': 'Jenis Kebijakan',
  'Order Date': 'Tanggal Pesan',
  'Contact Name': 'Nama Kontak',
  'Exception information': 'Informasi eksepsi',
  'Order Remarks': 'Keterangan Perintah',
  'Segment Information': 'Informasi Segmen',
  'Segment': 'Informasi Segmen',
  'Type': 'Ketik',
  'Departure time': 'Waktu keberangkatan',
  'Arrival time': 'Waktu kedatangan',
  'Passenger Information': 'Informasi Penumpang',
  'Birthday': 'Ulang Tahun',
  'Fare': 'Harga Par',
  'Sales Price': 'Harga jual',
  'Taxes': 'Pajak',
  'Purchase method': 'Metode pembelian',
  'Purchase account number': 'Beli nomor rekening',
  'Purchase password': 'Beli kata sandi',
  'Payment Amount': 'Jumlah Pembayaran',
  'Offer Type': 'Jenis Penawaran',
  'Discount Amount': 'Jumlah Diskon',
  'Offer logo': 'Logo penawaran',
  'Purchase time': 'Waktu pembelian',
  'Trading serial number': 'Nomor seri perdagangan',
  'Change Information': 'Ubah informasi',
  'Refund information': 'Refund information',
  'Order Log': 'Log Order',
  'Payment Channel': 'Saluran Pembayaran',
  'Ticketing office': 'Kantor tiket',
  'Ticketing Class': 'Kelas Tiket',
  'Please select': 'Silakan pilih',
  'Lowest cabin': 'Kabin terendah',
  'Same cabin': 'Kabin yang sama',
  'Downgrade': 'Downgrade',
  'Designated class': 'Kelas yang ditunjuk',
  'Designated cabin code': 'Kode kabin yang ditunjuk',
  'Maximum loss amount': 'Jumlah kerugian maksimum',
  'None': 'Tidak ada',
  'Direct subtraction': 'Pengurangan langsung',
  'Coupon': 'Kupon',
  'Red Packet': 'Paket Merah',
  'Coupon has no face value': 'Kupon tidak memiliki nilai nominal',
  'Coupon Rules': 'Aturan Kupon',
  'Product Type': 'Jenis Produk',
  'Select All': 'Pilih Semua',
  'Modify order status': 'Ubah status pesanan',
  'Reason for cancellation': 'Alasan pembatalan',
  'Payment timeout cancellation': 'Pembatalan batas waktu pembayaran',
  'Intercept Ticket Cancellation': 'Cegat Pembatalan Tiket',
  'Unticketed Refund Cancellation': 'Pembatalan Pengembalian Dana Tanpa Tiket',
  'Manual Cancellation': 'Pembatalan Manual',
  'Unticketed Refund Purchased': 'Unticketed Refund Purchased',
  'Rejected Cancellation': 'Pembatalan Ditolak',
  'Booking Instructions': 'Petunjuk Pemesanan',
  'Main flight': 'Penerbangan utama',
  'Adult Booking Instructions': 'Petunjuk Pemesanan Dewasa',
  'Copy': 'Salin',
  'Please enter content': 'Silakan masukkan konten',
  'Please select the ticketing class': 'Silakan pilih kelas tiket',
  'Please select the ticket channel': 'Silakan pilih saluran tiket',
  'Please select a payment channel': 'Silakan pilih saluran pembayaran',
  'Maximum loss amount cannot be empty': 'Jumlah kerugian maksimum tidak dapat dikosongkan',
  'Please select the offer type': 'Silakan pilih jenis penawaran',
  'Please select the coupon rule': 'Silakan pilih aturan kupon',
  'Confirm cancellation of order?': 'Konfirmasi pembatalan pesanan?',
  'Submit': 'Kirim',
  'Cancel the order successfully': 'Batalkan pesanan berhasil',
  'Children': 'Anak-anak',
  'There is a purchase record in processing, try again later': 'Ada catatan pembelian dalam pemrosesan, coba lagi nanti',
  'Copied to paste board': ' Disalin untuk tempel papan',
  'To be screened': 'Untuk disaring',
  'Waiting for seat confirmation': 'Menunggu konfirmasi kursi',
  'noPay': 'noPay',
  'Waiting for ticket': 'Waiting for ticket',
  'Ticketing': 'Ticketing',
  'Purchasing': 'Pembelian',
  'Purchase Completed': 'Pembelian Selesai',
  'Purchase Failed': 'Pembelian Gagal',
  'Ticket issued successfully': 'Ticket issued successfully',
  'Cancelled': 'Cancel',
  'Pending': 'tertunda',
  'Wait for system payment': 'Tunggu pembayaran sistem',
  'Waiting for manual payment': 'Menunggu pembayaran manual',
  'Ticket swiping': 'Gesek tiket',
  'Successful ticket swiping': 'Penggesek tiket yang berhasil',
  'Failed to swipe tickets': 'Gagal menggesek tiket',
  'Filling in': 'Mengisi',
  'Successful filling': 'Pengisian berhasil',
  'Pending appeal': 'Banding tertunda',
  'In appeal': 'Dalam banding',
  'Appeal successful': 'Banding berhasil',
  'Appeal failed': 'Banding gagal',
  'Gambling on the change': 'Perjudian pada perubahan',
  'Betting on the success of the flight': 'Bertaruh pada keberhasilan penerbangan',
  'Betting on the flight to fail': 'Bertaruh pada penerbangan untuk gagal',
  'Tickets issued': 'Tiket diterbitkan',
  'Downgraded': 'Diturunkan',
  'Refunded': 'Dikembalikan',
  'Changed': 'Berubah',
  'Intercepting ticket issuance': 'Mencegat penerbitan tiket',
  'Failed to intercept ticket issuance': 'Gagal mencegat penerbitan tiket',
  'Backfill failed': 'Backfill gagal',
  'Asynchronous ticketing': 'Tiket asinkron',
  'Asynchronous Seat Occupancy': 'Tiket asinkron',
  'Asynchronous payment in progress': 'Pembayaran asinkron sedang berlangsung',
  'Settlement': 'Penyelesaian',
  'Lock': 'Kunci',
  'Unlocked successfully': 'Berhasil dibuka',
  'Unlock failed': 'Buka kunci gagal',
  'Unticketed Cancellation': 'Pembatalan Tanpa Tiket',
  'Re-payment successful': 'Pembayaran ulang berhasil',
  'Re-payment failure': 'kegagalan pembayaran ulang',
  'Youth Special': 'Spesial Pemuda',
  'Multi-person special offer': 'Penawaran khusus multi-orang',
  'Self-selling price': 'Harga jual sendiri',
  'Domestic surprise price': 'Harga kejutan domestik',
  'Economy Class': 'Kelas Ekonomi',
  'Please fill in the correct number': 'Silakan isi nomor yang benar',
  'Please select a passenger': 'Silakan pilih penumpang',
  'Start and end dates cannot be empty': 'Tanggal mulai dan berakhir tidak boleh kosong',
  'Ticket number can only be 13 digits': 'Format nomor tiket yang salah hanya bisa 6 digit, 7 digit, 13 digit',
  'minutes': 'menit',
  'Order source configuration not found': 'Konfigurasi sumber pesanan tidak ditemukan',
  'Query': 'Pertanyaan',
  'All': 'Semua',
  'Special Offer': 'Penawaran Khusus',
  'New': 'Baru',
  '充值余额': 'Dompet',
  '资金变动': 'Detail Dompet',
  '充提审核': 'Formulir Catatan Setoran dan Penarikan',
  '供应商': 'Supplier General',
  '采购商': 'Membeli Jenderal',
  '一级': 'Tingkat pertama',
  '二级': 'Tingkat kedua',
  '三级': 'Tingkat ketiga',
  '异常': 'Kecualian',
  '正常': 'Normal',
  '授信': 'Kredit',
  '宝易': 'Baoyi',
  '微信': 'WeChat',
  '易宝': 'Yibao',
  '支付宝': 'Alipay',
  '平安': 'Ping An',
  '免审': 'Exemption from review',
  '待审核': 'Ulasan tertunda',
  '审核成功': 'Dipersetujui dengan sukses',
  '审核失败': 'Audit gagal',
  '充值': 'Memuatkan kembali',
  '提现': 'Pengunduran',
  '收款': 'Reception',
  '冻结': 'Freeze',
  '解冻': 'Unreeze',
  '追加保证金': 'Margin tambahan',
  '退款': 'Kembali',
  '授信还款': 'Pembayaran kredit',
  '授信变更': 'Credit Change',
  '默认值': 'Nilai piawai',
  '已支付未销账': 'Dibayar dan ditulis',
  '已支付已销账': 'Pengembalian telah dibatalkan',
  '退款未销账': 'Kembalian tidak ditutup',
  '退款已销账': 'Kembalian dibatalkan',
  '收入': 'Penghasilan',
  '支出': 'Pengeluaran',
  '交易中': 'Trading',
  '交易成功': 'Transaksi berhasil',
  '交易失败': 'Transaksi gagal',
  '政策表': 'Tabel Kebijakan',
  '国内始发': 'Asal domestik',
  '直飞SOTO程': 'Perjalanan SOTO Langsung',
  '国内始发Add-On': 'Pengaya Asal Domestik',
  '国外始发Add-On': 'Pengaya Asal Asing',
  '境外到境外': 'Luar Negeri ke Luar Negeri',
  '国内始发中转': 'Transit asal domestik',
  '国外始发中转': 'Transit asal asing',
  '境外境外境外': 'Luar Negeri Luar Negeri Luar Negeri',
  '境外境内境外': 'Luar negeri, dalam dan luar negeri',
  '全球到全球': 'Global to Global',
  '全球中转全球': 'Global transit global',
  '单程': 'One way',
  '往返': 'Perjalanan pulang pergi',
  '单程/往返': 'Sekali jalan / pulang pergi',
  '挂起': 'Suspend',
  '系统挂起': 'Sistem ditangguhkan',
  '无法使用': 'Tidak dapat menggunakan',
  '正在审核': 'Meninjau',
  '境外电子': 'Elektronik Luar Negeri',
  '无需换编码': 'Tidak perlu mengubah kode',
  '换编码出票': 'Ubah kode untuk mengeluarkan tiket',
  '大编出票(无需换编)': 'Tiket skala besar (tidak perlu diubah) ',
  '大编出票(需换编)': 'Tiket skala besar (perlu diubah) ',
  '无需换编出票(外放无位)': 'Tidak perlu mengganti tiket (tidak ada tempat untuk meletakkannya) ',
  '原编出票': 'Tiket asli dikeluarkan',
  '换编出票': 'Tukar tiket',
  '相同地区配置可原编出票': 'Konfigurasi regional yang sama awalnya dapat diprogram untuk mengeluarkan tiket',
  '是': 'Ya',
  '否': 'Tidak',
  '现金': 'Uang Tunai',
  '支票': 'Cek',
  '信用卡': 'Kartu Kredit',
  'Abacus或Sabre': 'Abacus atau Sabre',
  '留学生': 'Mahasiswa internasional',
  '移民': 'Imigran',
  '劳工': 'Buruh',
  '海员': 'Seaman',
  '青年': 'Pemuda',
  '老年': 'Usia tua',
  '探亲': 'Mengunjungi kerabat',
  '港澳台': 'Hong Kong, Makau dan Taiwan',
  '外籍': 'Ekspatriat',
  '非汉字姓名': 'Nama karakter non-Cina',
  'Add-On': 'Add-On',
  '境外中转': 'Transit luar negeri',
  'OPEN': 'BUKA',
  '三方协议': 'Perjanjian Tripartit',
  '套票': 'Paket',
  '整团': 'Seluruh kelompok',
  '小团': 'Kelompok kecil',
  '政策信息': 'Informasi Kebijakan',
  '政策': 'Kebijakan',
  '政策管理': 'Manajemen Kebijakan',
  '供应商订单': 'Pesanan Pemasok',
  '出票单报表': 'Laporan Tiket',
  '改签单报表': 'Ubah Laporan',
  '采购商订单': 'Pesanan Pembeli',
  '退票单报表': 'Refund Form',
  '交易记录': 'Catatan transaksi',
  '订单支付页': 'Order Payment Page',
  '核账日期类型': 'Jenis tanggal audit',
  '采购付款核账时间': 'Beli waktu verifikasi pembayaran',
  '成功': 'Sukses',
  '待处理': 'tertunda',
  '等待系统支付': 'Tunggu pembayaran sistem',
  '等待人工支付': 'Tunggu pembayaran manual',
  '采购中': 'Pembelian',
  '采购完成': 'Pengadaan selesai',
  '采购失败': 'Pembelian gagal',
  '刷票中': 'Gesek tiket',
  '刷票成功': 'Penggesek tiket berhasil',
  '刷票失败': 'Gagal gesek tiket',
  '补位中': 'Mengisi',
  '补位成功': 'Berhasil mengisi',
  '补位失败': 'Isi gagal',
  '待申诉': 'Banding tertunda',
  '申诉中': 'Dalam banding',
  '申诉成功': 'Banding berhasil',
  '申诉失败': 'Banding gagal',
  '赌航变': 'Perjudian pada perubahan',
  '赌航变成功': 'Bertaruh pada keberhasilan penerbangan',
  '赌航变失败': 'Gagal bertaruh pada perubahan pengiriman',
  '已降舱': 'Diturunkan',
  '支付超时取消': 'Pembatalan batas waktu pembayaran',
  '拦截出票取消': 'Cegat Pembatalan Tiket',
  '未出票退款取消': 'Unticketed Refund Cancellation',
  '人工取消': 'Pembatalan manual',
  '已改签': 'Berubah',
  '拦截出票中': 'Mencegat tiket',
  '拦截出票失败': 'Gagal mencegat penerbitan tiket',
  '未出票退款已采购': 'Unticketed refund telah dibeli',
  '回填失败': 'Backfill gagal',
  '驳回取消': 'Tolak Pembatalan',
  '异步出票中': 'Tiket sinkron',
  '异步占座中': 'Hunian asinkron',
  '异步支付中': 'Dalam pembayaran asinkron',
  '我的锁单': 'Daftar kunci saya',
  '系统锁单': 'Urutan kunci sistem',
  '未锁单': 'Urutan tidak terkunci',
  '等待座位确认': 'Menunggu konfirmasi kursi',
  '待支付': 'Reservasi berhasil menunggu pembayaran',
  '待出票': 'Pembayaran berhasil dan menunggu tiket dikeluarkan',
  '出票中': 'Tiket',
  '出票失败': 'Gagal mengeluarkan tiket',
  '测试商家': 'Pedagang Uji',
  '联程': 'Koneksi',
  '多程': 'Multi-way',
  '核账日期类型不为空': 'Jenis tanggal verifikasi tidak kosong',
  '币种': 'Mata Uang',
  '人民币': 'CNY-Renminbi',
  '马币': 'MYR-Ringgit',
  '美元': 'USD-Dollar',
  '请选择币种': 'Silakan pilih mata uang',
  '更换币种成功': 'Perubahan mata uang yang berhasil',
  '去程': 'go',
  '返程': 'back',
  '中转': 'transfer',
  '未查询到': 'Tidak ditemukan',
  '汇率': 'Nilai tukar',
  '汇率表': 'Tabel Nilai Tukar',
  '关闭': 'Tutup',
  '机票预订': 'Reservasi tiket',
  '供应出票单查询': 'Penyelidikan faktur pasokan',
  '采购出票单查询': 'Faktu pembelian',
  '去支付': 'Pergi bayar',
  '国际机票查询': 'Pertanyaan Tiket Internasional',
  '出票单详情': 'Detail tiket',
  '国际机票预订': 'Reservasi tiket',
  '北京': 'Beijing',
  '巴黎': 'Paris',
  '东京': 'Tokyo',
  '首尔': 'Seoul',
  '纽约': 'New York',
  '中国香港': 'Hong Kong, Cina',
  '中国澳门': 'Makau, Cina',
  '深圳': 'Shenzhen',
  '广州': 'Guangzhou',
  '上海': 'Shanghai',
  '阿伯丁': 'Aberdeen',
  '阿布贾': 'Abuja',
  '阿比让': 'Abidjan',
  '阿布扎比': 'Abu Dhabi',
  '爱丁堡': 'Edinburgh',
  '阿德莱德': 'Adelaide',
  '埃德蒙顿': 'Edmonton',
  '阿尔及尔': 'Aljir',
  '阿尔山': 'Arshan',
  '阿瓜迪亚': 'Aguadia',
  '艾哈迈达巴德': 'Ahmedabad',
  '安康': 'Kesejahteraan',
  '阿克拉': 'Accra',
  '奥克兰': 'Oakland',
  '安克雷奇': 'Pelabuhan',
  '阿克苏': 'Aksu',
  '埃克塞特': 'Lebih luar',
  '阿里': 'Ali',
  '奥兰多': 'orlando',
  '阿拉尔': 'Aral',
  '阿拉木图': 'Almaty',
  '阿拉善盟': 'Liga Alxa',
  '阿勒泰': 'Altay',
  '安曼': 'Amman',
  '埃默拉尔德': 'Zamrud',
  '阿姆利则': 'Amritsar',
  '阿姆斯特丹': 'Amsterdam',
  '阿皮亚': 'Apia',
  '安庆': 'Anqing',
  '鞍山': 'Anshan',
  '安顺': 'Anshun',
  '奥什': 'Osh',
  '阿什哈巴德': 'Ashgabat',
  '奥斯陆': 'Oslo',
  '奥斯汀': 'Austin',
  '安特卫普': 'Antwerpen',
  '安阳': 'Anyang',
  '博鳌': 'Boao',
  '蚌埠': 'Bengbu',
  '槟城': 'Penang',
  '保定': 'Baoding',
  '班达伯格': 'Bundaberg',
  '布达佩斯': 'Budapest',
  '波尔多': 'Bordeaux',
  '贝尔法斯特': 'Belfast',
  '贝尔格莱德': 'Beograd',
  '伯恩茅斯': 'Bournemouth',
  '布尔诺': 'Brno',
  '波尔图': 'Porto',
  '布法罗': 'Kerbau',
  '波哥大': 'Bogota',
  '巴格多格拉': 'Bagdogra',
  '北海': 'Laut Utara',
  '宝鸡': 'Baoji',
  '毕节': 'Bijie',
  '班吉': 'Bangui',
  '班加罗尔': 'Bangalore',
  '布加勒斯特': 'Bukares',
  '北九州': 'Kitakyushu',
  '巴库': 'Baku',
  '别克斯': 'Vieques',
  '巴林': 'Bahrain',
  '巴里': 'Barry',
  '柏林': 'Berlin',
  '博乐': 'Lubang',
  '巴厘巴板': 'Balikpapan',
  '布拉柴维尔': 'Brazzaville',
  '巴罗达': 'Baroda',
  '布莱顿': 'Brighton',
  '巴厘岛': 'Bali',
  '布拉格': 'Praha',
  '不来梅': 'Bremen',
  '博洛尼亚': 'Bologna',
  '布里斯班': 'Brisbane',
  '布鲁塞尔': 'Brussel',
  '布里斯托尔': 'Bristol',
  '贝鲁特': 'Beirut',
  '巴伦西亚': 'Valencia',
  '伯明翰': 'Birmingham',
  '巴马科': 'Bamako',
  '巴拿马城': 'Kota Panama',
  '博帕尔': 'Sahabat',
  '百色': 'Baise',
  '保山': 'Baoshan',
  '比绍': 'Bissau',
  '比萨': 'Pizza',
  '巴斯': 'Mandi',
  '波士顿': 'Boston',
  '巴塞尔巴登': 'Basel-Baden',
  '比什凯克': 'Bishkek',
  '巴塞罗那': 'Barcelona',
  '包头': 'Baotou',
  '波特兰': 'Portland',
  '巴特那': 'Patna',
  '芭提雅': 'Pattaya',
  '本溪': 'Benxi',
  '巴亚尔塔港': 'Puerto Vallarta',
  '巴彦淖尔': 'Bayannaoer',
  '布宜诺斯艾利斯': 'Buenos Aires',
  '滨州': 'Binzhou',
  '亳州': 'Bozhou',
  '巴中': 'Bazhong',
  '博兹曼': 'Bozeman',
  '赤壁': 'Chibi',
  '茨城': 'Ibaraki',
  '昌都': 'Qamdo',
  '承德': 'Chengde',
  '常德': 'Berubah',
  '成都': 'Chengdu',
  '昌迪加尔': 'Chandigarh',
  '赤峰': 'Chifeng',
  '冲绳': 'Okinawa',
  '楚雄': 'Chu Xiong',
  '朝阳': 'Chaoyang',
  '沧源': 'Cangyuan',
  '滁州': 'Chuzhou',
  '潮州': 'Chaozhou',
  '常州': 'Changzhou',
  '沧州': 'Cangzhou',
  '池州': 'Chizhou',
  '郴州': 'Chenzhou',
  '大安': 'Dan',
  '杜阿拉': 'Douala',
  '德班': 'Durban',
  '迪拜': 'Dubai',
  '大阪': 'Osaka',
  '都柏林': 'Dublin',
  '第比利斯': 'Tbilisi',
  '稻城': 'Daocheng',
  '丹东': 'Dandong',
  '达尔文': 'Darwin',
  '丹佛': 'Denver',
  '东莞': 'Dongguan',
  '敦煌': 'Dunhuang',
  '多哈': 'Doha',
  '敦化': 'Dunhua',
  '德黑兰': 'Teheran',
  '达卡': 'Dhaka',
  '达喀尔': 'Dakar',
  '德里': 'Delhi',
  '大连': 'Dalian',
  '大理': 'Dali',
  '都灵': 'Turin',
  '多伦多': 'Toronto',
  '德令哈': 'Delingha',
  '德勒斯登': 'Berpakaian',
  '达累斯萨拉姆': 'Dar es Salaam',
  '达拉斯-沃斯堡': 'Dallas-Fort Worth',
  '达曼': 'Dukun',
  '达尼丁': 'Mencelupkan',
  '迪庆': 'Diqing',
  '大庆': 'Daqing',
  '大邱': 'Daegu',
  '杜尚别': 'Dushanbe',
  '杜塞尔多夫': 'D眉sseldorf',
  '大石桥': 'Jembatan Dashi',
  '大同': 'Datong',
  '底特律': 'Detroit',
  '德兴': 'Dexing',
  '德阳': 'Deyang',
  '东营': 'Dongying',
  '都匀': 'Semua seragam',
  '达州': 'Dazhou',
  '儋州': 'Danzhou',
  '德州': 'Texas',
  '恩德培': 'Entebbe',
  '鄂尔多斯': 'Ordos',
  '恩贾梅纳': 'N Djamena',
  '额济纳旗': 'Panji Ejin',
  '二连浩特': 'Erenhot',
  '恩施': 'Enshi',
  '鄂州': 'Ezhou',
  '费城': 'Filadelfia',
  '防城港': 'Fangchenggang',
  '福岛': 'Fukushima',
  '福鼎': 'Fuding',
  '福冈': 'Fukuoka',
  '富国岛': 'Pulau Phu Quoc',
  '奉化': 'Fenghua',
  '凤凰城': 'Phoenix',
  '费里敦': 'Kota bebas',
  '符拉迪沃斯托克': 'Vladivostok',
  '法兰克福': 'Frankfurt',
  '佛罗伦萨': 'Florence',
  '法罗群岛': 'Kepulauan Faroe',
  '弗雷斯诺': 'Fresno',
  '福清': 'Fuqing',
  '佛山': 'Foshan',
  '釜山': 'Busan',
  '富山': 'Toyama',
  '阜新': 'Fuxin',
  '阜阳': 'Fuyang',
  '抚远': 'Fuyuan',
  '富蕴': 'Fuyun',
  '福州': 'Fuzhou',
  '抚州': 'Fuzhou',
  '广安': 'Guang',
  '哥本哈根': 'Kopenhagen',
  '关岛': 'Guam',
  '广岛': 'Hiroshima',
  '关丹': 'Kuantan',
  '哥德堡': 'Gothenburg',
  '哥打巴鲁': 'Kota Bharu',
  '哥打基纳巴卢': 'Kota Kinabalu',
  '瓜达拉哈拉': 'Guadalajara',
  '格尔木': 'Golmud',
  '贵港': 'Guigang',
  '广汉': 'Guanghan',
  '古晋': 'Kuching',
  '果洛': 'Golo',
  '桂林': 'Guilin',
  '哥伦布': 'Columbus',
  '格拉茨': 'Graz',
  '瓜拉丁加奴': 'Kuala Terengganu',
  '格莱斯顿': 'Gladstone',
  '格拉斯哥': 'Glasgow',
  '桂平': 'Memoles',
  '冈山': 'Okayama',
  '古瓦哈蒂': 'Guwahati',
  '高邮': 'Gaoyou',
  '广元': 'Guangyuan',
  '固原': 'Guyuan',
  '贵阳': 'Guiyang',
  '瓜亚基尔': 'Guayaquil',
  '甘孜': 'Ganzi',
  '赣州': 'Ganzhou',
  '光州': 'Gwangju',
  '淮安': 'Huai',
  '汉堡': 'Burger',
  '鹤壁': 'Hebi',
  '淮北': 'Huaibei',
  '哈巴罗夫斯克': 'Khabarovsk',
  '哈博罗内': 'Gabon',
  '霍巴特': 'Hobart',
  '汉川': 'Hanchuan',
  '河池': 'Kolam Sungai',
  '海参崴': 'Vladivostok',
  '邯郸': 'Handan',
  '海得拉巴': 'Hyderabad',
  '哈尔滨': 'Harbin',
  '赫尔辛基': 'Helsinki',
  '合肥': 'Hefei',
  '黄冈': 'Huanggang',
  '黑河': 'Sungai Hitam',
  '怀化': 'Huaihua',
  '呼和浩特': 'Hohhot',
  '皇后镇': 'Ratu',
  '黑角': 'Tanduk Hitam',
  '黄金海岸': 'Pantai Emas',
  '海口': 'Haikou',
  '哈科特港': 'Pelabuhan Harcourt',
  '葫芦岛': 'Huludao',
  '惠灵顿': 'Wellington',
  '海拉尔': 'tersedia',
  '哈里法克斯': 'Halifax',
  '哈拉雷': 'Harare',
  '哈密': 'Hami',
  '海曼岛': 'Pulau Hayman',
  '哈密尔顿': 'Hamilton',
  '汉密尔顿岛': 'Pulau Hamilton',
  '海宁': 'Haining',
  '河内': 'Hanoi',
  '淮南': 'Huainan',
  '火奴鲁鲁': 'Honolulu',
  '汉诺威': 'Hannover',
  '黄石': 'Batu kuning',
  '衡水': 'Hengshui',
  '黄山': 'Huangshan',
  '华沙': 'Warsawa',
  '华盛顿': 'Washington',
  '和田': 'Panas',
  '哈特福德': 'Hartford',
  '红原': 'Dataran Merah',
  '海阳': 'Haiyang',
  '衡阳': 'Hengyang',
  '华阴': 'Huay',
  '杭州': 'Hangzhou',
  '惠州': 'Huizhou',
  '菏泽': 'Panas',
  '汉中': 'Hanzhong',
  '贺州': 'Hezhou',
  '湖州': 'Huzhou',
  '胡占德': 'Huzhande',
  '胡志明市': 'Kota Ho Chi Minh',
  '吉安': 'Ji an',
  '金边': 'Phnom Penh',
  '贾巴尔普尔': 'Jabalpur',
  '吉布提': 'Djibouti',
  '金昌': 'Jinchang',
  '晋城': 'Jincheng',
  '吉达': 'Jeddah',
  '基多': 'Quito',
  '基督城': 'Christchurch',
  '加的夫': 'Cardiff',
  '吉大港': 'Chittagong',
  '加德满都': 'Kathmandu',
  '景德镇': 'Jingdezhen',
  '杰尔': 'Jerry',
  '加尔各答': 'Kalkuta',
  '基辅': 'Kiev',
  '静冈': 'Shizuoka',
  '巨港': 'Palembang',
  '加格达奇': 'Gagah',
  '井冈山': 'Jinggangshan',
  '金华': 'Jinhua',
  '景洪': 'Jinghong',
  '九江': 'Jiujiang',
  '晋江': 'Jinjiang',
  '基加利': 'Kigali',
  '旧金山': 'San Francisco',
  '杰克逊维尔': 'Jacksonville',
  '吉林': 'Jilin',
  '加拉加斯': 'Caracas',
  '基隆拿': 'Kelowna',
  '吉隆坡': 'Kuala Lumpur',
  '甲米': 'Krabi',
  '佳木斯': 'Jiamusi',
  '济宁': 'Ya',
  '金奈': 'Chennai',
  '济南': 'Jinan',
  '建瓯': 'Jian ou',
  '剑桥': 'Cambridge',
  '酒泉': 'Jiuquan',
  '句容': 'Jurong',
  '金斯顿': 'Kingston',
  '建三江': 'Membangun Sanjiang',
  '金沙萨': 'Kinshasa',
  '焦特布尔': 'Jodhpur',
  '鸡西': 'Jixi',
  '嘉兴': 'Jiaxing',
  '江油': 'Jiangyou',
  '揭阳潮汕': 'Jieyang Chaoshan',
  '嘉峪关': 'Jiayuguan',
  '济州': 'Jeju',
  '晋州': 'Jinzhou',
  '锦州': 'Jinzhou',
  '晋中': 'Jinzhong',
  '焦作': 'Jiaozuo',
  '荆州': 'Jingzhou',
  '九寨沟': 'Jiuzhaigou',
  '喀布尔': 'Kabul',
  '库车': 'Kuqa',
  '康定': 'Kangding',
  '卡迪夫': 'Cardiff',
  '卡尔加里': 'Calgary',
  '库尔勒': 'Korla',
  '凯恩斯': 'Cairns',
  '开封': 'Kaifeng',
  '科夫斯港': 'Pelabuhan Coffs',
  '卡胡卢伊': 'Kahului',
  '克久拉霍': 'Khajuraho',
  '坎昆': 'Cancun',
  '科克': 'Gabus',
  '开罗': 'Kairo',
  '科隆': 'Cologne',
  '凯里': 'Peduli',
  '库莱布拉': 'Culebra',
  '克利夫兰': 'Cleveland',
  '克拉根福': 'Klagenfurt',
  '克拉克': 'Clark',
  '克拉科夫': 'Krakow',
  '卡利刻特': 'Kalis',
  '克莱蒙费朗': 'Clermont Ferrand',
  '克拉玛依': 'Karamay',
  '科伦坡': 'Kolombo',
  '库拉索': 'Curacao',
  '昆明': 'Kunming',
  '卡诺': 'Kano',
  '科纳克里': 'Conakry',
  '喀纳斯': 'Kanas',
  '开普敦': 'Cape Town',
  '堪培拉': 'Canberra',
  '科钦': 'Cochin',
  '喀什': 'Kashgar',
  '昆山': 'Kunshan',
  '卡萨布兰卡': 'Casablanca',
  '奎屯': 'Kuitun',
  '喀土穆': 'Khartoum',
  '科托努': 'Cotonou',
  '卡塔尼亚': 'Catania',
  '考文垂': 'Coventry',
  '科威特': 'Kuwait',
  '六安': 'Luk',
  '里昂': 'Lyon',
  '罗安达': 'Luanda',
  '来宾': 'Tamu',
  '荔波': 'Libo',
  '赖布尔': 'Raipur',
  '卢布尔亚那': 'Lubljana',
  '拉巴特': 'Rabat',
  '利伯维尔': 'Libreville',
  '莱比锡': 'Leipzig',
  '列城': 'Leh',
  '澜沧': 'Lancang',
  '临沧': 'Lincang',
  '林茨': 'Linz',
  '娄底': 'Loudi',
  '伦敦': 'London',
  '罗德岱堡': 'Benteng Lauderdale',
  '伦敦(加拿大）': 'London (Kanada)',
  '鹿儿岛': 'Kagoshima',
  '廊坊': 'Langfang',
  '临汾': 'Linfen',
  '泸沽湖': 'Danau Lugu',
  '拉各斯': 'Lagos',
  '临海': 'Linhai',
  '漯河': 'Luohe',
  '拉合尔': 'Lahore',
  '丽江': 'Lijiang',
  '里加': 'Riga',
  '雷焦卡拉布里亚': 'Reggio Calabria',
  '里贾纳': 'Regina',
  '罗克汉普顿': 'Rockhampton',
  '勒克瑙': 'Lucknow',
  '兰卡威': 'Langkawi',
  '雷克雅未克': 'Reykjavik',
  '吕梁': 'Lu Liang',
  '罗利': 'Raleigh',
  '拉罗汤加': 'Langka',
  '洛美': 'Lome',
  '利马': 'Lima',
  '罗马': 'Roma',
  '拉梅齐亚': 'Lamezia',
  '陇南': 'Longnan',
  '拉纳卡': 'Larnaca',
  '黎平': 'Li Ping',
  '六盘水': 'Liupanshui',
  '乐清': 'Yueqing',
  '兰契': 'Ranchi',
  '列日': 'Liege',
  '乐山': 'Leshan',
  '拉萨': 'Lhasa',
  '丽水': 'Yeosu',
  '里斯本': 'Lisboa',
  '卢森堡': 'Luksemburg',
  '洛杉矶': 'Los Angeles',
  '卢萨卡': 'Lusaka',
  '里士满': 'Richmond',
  '莱斯特': 'Lester',
  '拉斯维加斯': 'Las Vegas',
  '莱阳': 'Laiyang',
  '龙岩': 'Longyan',
  '辽阳': 'Liaoyang',
  '洛阳': 'Luoyang',
  '临沂': 'Linyi',
  '溧阳': 'Liyang',
  '耒阳': 'Leiyang',
  '利雅得': 'Riyadh',
  '里雅恩姆卡拉': 'Riam Mkala',
  '连云港': 'Lianyungang',
  '里约热内卢': 'Rio de Janeiro',
  '利兹': 'Leeds',
  '兰州': 'Lanzhou',
  '柳州': 'Liuzhou',
  '泸州': 'Luzhou',
  '林芝': 'Nyingchi',
  '迈阿密': 'Miami',
  '蒙彼利埃': 'Montpellier',
  '麻城': 'Macheng',
  '曼彻斯特': 'Manchester',
  '梅德福': 'Medford',
  '牡丹江': 'Mudanjiang',
  '马德里': 'Madrid',
  '麦地那': 'Madinah',
  '墨尔本': 'Melbourne',
  '米尔迪拉': 'Mildura',
  '莫尔斯比港': 'Pelabuhan Moresby',
  '密尔沃基': 'Milwaukee',
  '孟菲斯': 'Memphis',
  '曼谷': 'Bangkok',
  '名古屋': 'Nagoya',
  '漠河': 'Mohe',
  '麦凯': 'McKay',
  '麦夸里港': 'Port Macquarie',
  '棉兰': 'Medan',
  '米兰': 'Milan',
  '马累': 'Laki-laki',
  '马拉博': 'Malabo',
  '马拉加': 'Malaga',
  '马六甲': 'Malaka',
  '马拉喀什': 'Marrakech',
  '毛里求斯': 'Mauritius',
  '蒙罗维亚': 'Monrovia',
  '孟买': 'Mumbai',
  '茂名': 'Maoming',
  '明尼阿波利斯': 'Minneapolis',
  '慕尼黑': 'Munich',
  '马尼拉': 'Manila',
  '木浦': 'Mokpo',
  '眉山': 'Meishan',
  '芒市': 'Mangshi',
  '马赛': 'Marseille',
  '莫斯科': 'Moskow',
  '明斯克': 'Minsk',
  '马斯喀特': 'Muscat',
  '明斯特': 'M眉nster',
  '芒特艾萨': 'Gunung Isa',
  '蒙特雷': 'Monterey',
  '蒙特利尔': 'Montreal',
  '蒙特雷(墨西哥)': 'Monterrey (Meksiko)',
  '墨西哥城': 'Kota Meksiko',
  '绵阳': 'Mianyang',
  '梅州': 'Meizhou',
  '满洲里': 'Manzhouli',
  '南安普顿': 'Southampton',
  '宁波': 'Ningbo',
  '内比都': 'Naypyidaw',
  '那不勒斯': 'Napoli',
  '纽波特': 'Newport',
  '南昌': 'Nanchang',
  '南充': 'Nanchong',
  '纳迪': 'Nadi',
  '宁德': 'Ningde',
  '诺丁汉': 'Nottingham',
  '努尔苏丹（阿斯塔纳）': 'Nur-Sultan (Astana)',
  '那格浦尔': 'Nagpur',
  '内江': 'Neijiang',
  '南京': 'Nanjing',
  '牛津': 'Oxford',
  '努库阿洛法': 'Nuku alofa',
  '纽卡斯尔(澳大利亚)': 'Newcastle (Australia)',
  '纽卡斯尔(英国)': 'Newcastle (Inggris)',
  '宁蒗': 'Ninglang',
  '内罗毕': 'Nairobi',
  '纽伦堡': 'Nuremberg',
  '诺里奇': 'Norwich',
  '那拉提': 'Nalati',
  '南宁': 'Nanning',
  '南平': 'Nanping',
  '尼斯': 'Bagus',
  '纳什维尔': 'Nashville',
  '南通': 'Nantong',
  '努瓦克肖特': 'Nouakchott',
  '诺维奇': 'Norwich',
  '南阳': 'Nanyang',
  '尼亚美': 'Niamey',
  '平度': 'Kerataan',
  '平顶山': 'Pingdingshan',
  '普洱': 'Pu er',
  '普吉': 'Phuket',
  '盘锦': 'Panjin',
  '帕拉马里博': 'Paramaribo',
  '普利茅斯': 'Plymouth',
  '普罗瑟派恩': 'Protherpin',
  '浦那': 'Pune',
  '普宁': 'Menghukum',
  '平壤': 'Pyongyang',
  '珀斯': 'Perth',
  '蓬塞': 'Ponce',
  '莆田': 'Putian',
  '浦项': 'Pohang',
  '萍乡': 'Pingxiang',
  '匹兹堡': 'Pittsburgh',
  '攀枝花': 'Panzhihua',
  '青岛': 'Qingdao',
  '琼海': 'Qionghai',
  '秦皇岛': 'Qinhuangdao',
  '黔江': 'Qianjiang',
  '潜江': 'Qianjiang',
  '曲靖': 'Berteriak',
  '清莱': 'Chiang Rai',
  '乞力马扎罗': 'Kilimanjaro',
  '清迈': 'Chiang Mai',
  '且末': 'Di akhir',
  '齐齐哈尔': 'Qiqihar',
  '庆阳': 'Qingyang',
  '清远': 'Qingyuan',
  '清州': 'Cheongju',
  '衢州': 'Quzhou',
  '青州': 'Qingzhou',
  '泉州': 'Quanzhou',
  '钦州': 'Qinzhou',
  '乔治王子城': 'Pangeran George',
  '瑞安': 'Ryan',
  '日喀则': 'Sial',
  '日内瓦': 'Jenewa',
  '若羌': 'Ruoqiang',
  '荣市': 'Rongshi',
  '日照': 'Sinar matahari',
  '沙巴': 'Sabah',
  '塞班': 'Symbian',
  '圣芭芭拉': 'Santa Barbara',
  '圣彼得堡': 'St. Petersburg',
  '斯波坎': 'Spokane',
  '圣保罗': 'Santo Paulus',
  '莎车': 'Sakit',
  '斯德哥尔摩': 'Stockholm',
  '圣地亚哥(美国)': 'San Diego (AS)',
  '圣地亚哥(智利)': 'Santiago (Chili)',
  '萨尔斯堡': 'Salzburg',
  '索非亚': 'Sofia',
  '韶关': 'Shaoguan',
  '萨格勒布': 'Zagreb',
  '四会': 'Empat Pertemuan',
  '圣胡安': 'San Juan',
  '圣何塞': 'San Jose',
  '石河子': 'Shihezi',
  '沙迦': 'Sharjah',
  '石家庄': 'Shijiazhuang',
  '萨克拉门托': 'Sacramento',
  '圣克鲁斯岛': 'Pulau Santa Cruz',
  '萨勒诺': 'Salerno',
  '斯利那加': 'Srinagar',
  '苏黎世': 'Zurich',
  '圣路易斯': 'St. Louis',
  '三明': 'Sanming',
  '厦门': 'Xiamen',
  '苏梅岛': 'Koh Samui',
  '三门峡': 'Sanmenxia',
  '萨那': 'Sana',
  '神农架': 'Shennongjia',
  '圣珀尔滕': 'St Pelten',
  '商丘': 'Shangqiu',
  '宿迁': 'Suqian',
  '上饶': 'Shangrao',
  '松山': 'Matsuyama',
  '泗水': 'Surabaya',
  '汕头': 'Shantou',
  '斯图加特': 'Stuttgart',
  '司徒加特': 'Stuart',
  '斯特拉斯堡': 'Strasbourg',
  '圣托马斯': 'St Thomas',
  '宿务': 'Cebu',
  '汕尾': 'Shanwei',
  '斯温顿': 'Penipu',
  '斯旺西': 'Swansea',
  '绍兴': 'Shaoxing',
  '沈阳': 'Shenyang',
  '三亚': 'Sanya',
  '十堰': 'Shiyan',
  '邵阳': 'Shaoyang',
  '松原': 'Matsubara',
  '朔州': 'Shuozhou',
  '随州': 'Suizhou',
  '苏州': 'Suzhou',
  '宿州': 'Suzhou',
  '泰安': 'Tai',
  '廷布': 'Thimphu',
  '太仓': 'Taicang',
  '塔城': 'Kota Menara',
  '腾冲': 'Tengchong',
  '通化': 'Tonghua',
  '天津': 'Tianjin',
  '通辽': 'Tongliao',
  '塔林': 'Tallinn',
  '铜陵': 'Lidah',
  '铁岭': 'Punggung Besi',
  '吐鲁番': 'Turpan',
  '特里凡得琅': 'Trivandrum',
  '特拉维夫': 'Tel Aviv',
  '图卢兹': 'Toulouse',
  '天门': 'Tianmen',
  '图木舒克': 'Tumushuk',
  '塔那那利佛': 'Antananarivo',
  '突尼斯': 'Tunisia',
  '坦帕': 'Tampa',
  '铜仁': 'Lidah',
  '台山': 'Taishan',
  '天水': 'Tianshui',
  '唐山': 'Tangshan',
  '塔什干': 'Tashkent',
  '塔什库尔干': 'Tashkorgan',
  '汤斯维尔': 'Townsville',
  '太原': 'Taiyuan',
  '台州': 'Taizhou',
  '泰州': 'Taizhou',
  '文昌': 'Wenchang',
  '乌代布尔': 'Udaipur',
  '温得和克': 'Windhoek',
  '五大连池': 'Wudalianchi',
  '维尔纽斯': 'Vilnius',
  '潍坊': 'Weifang',
  '温哥华': 'Vancouver',
  '威海': 'Weihai',
  '芜湖': 'Wuhu',
  '乌海': 'Wuhai',
  '武汉': 'Wuhan',
  '瓦加杜古': 'Ouagadougou',
  '温岭': 'Wenling',
  '乌兰察布': 'Ulanqab',
  '乌兰浩特': 'Ulanhot',
  '乌鲁木齐': 'Urumqi',
  '维罗纳': 'Verona',
  '瓦拉纳西': 'Varanasi',
  '渭南': 'Weinan',
  '万宁': 'Mannings',
  '温尼伯': 'Winnipeg',
  '威尼斯': 'Venesia',
  '乌戎潘当': 'Ujung Pandang',
  '文山': 'Wenshan',
  '巫山': 'Wushan',
  '渥太华': 'Ottawa',
  '万象': 'Vientiane',
  '无锡': 'Wuxi',
  '万鸦老': 'Orang Tua',
  '维也纳': 'Wina',
  '武夷山': 'Gunung Wuyi',
  '温州': 'Wenzhou',
  '梧州': 'Wuzhou',
  '万州': 'Wanzhou',
  '吴忠': 'Wu Zhong',
  '西安': 'Xi',
  '新奥尔良': 'New Orleans',
  '许昌': 'Xuchang',
  '西昌': 'Xichang',
  '宣城': 'Xuancheng',
  '锡尔赫特': 'Sylhet',
  '岘港': 'Da Nang',
  '孝感': 'Xiaogan',
  '夏河': 'Sungai Musim Panas',
  '新加坡': 'Singapura',
  '暹粒': 'Siem Reap',
  '锡林浩特': 'Xilinhot',
  '夏洛特': 'Charlotte',
  '咸宁': 'Xianning',
  '悉尼': 'Sydney',
  '西宁': 'Xining',
  '小松': 'Komatsu',
  '西双版纳': 'Xishuangbanna',
  '休斯顿': 'Houston',
  '仙台': 'Sendai',
  '湘潭': 'Xiangtan',
  '仙桃': 'Xiantao',
  '新潟': 'Niigata',
  '新乡': 'Xinxiang',
  '新西伯利亚': 'Novosibirsk',
  '辛辛那提': 'Cincinnati',
  '兴义': 'Xingyi',
  '信阳': 'Xinyang',
  '襄阳': 'Xiangyang',
  '新余': 'Xinyu',
  '西雅图': 'Seattle',
  '忻州': 'Xinzhou',
  '徐州': 'Xuzhou',
  '延安': 'Yan',
  '雅安': 'Ya',
  '宜宾': 'Yibin',
  '银川': 'Yinchuan',
  '伊春': 'Yichun',
  '运城': 'Yuncheng',
  '宜春': 'Yichun',
  '宜昌': 'Yichang',
  '盐城': 'Yancheng',
  '雅典': 'Athena',
  '印第安纳波利斯': 'Indianapolis',
  '亚的斯亚贝巴': 'Addis Ababa',
  '伊尔库茨克': 'Irkutsk',
  '云浮': 'Yunfu',
  '仰光': 'Yangon',
  '盐湖城': 'Kota Danau Garam',
  '约翰内斯堡': 'Johannesburg',
  '阳江': 'Yangjiang',
  '延吉': 'Yanji',
  '雅加达': 'Jakarta',
  '营口': 'Yingkou',
  '榆林': 'Yulin',
  '玉林': 'Yulin',
  '伊宁': 'Yining',
  '蔚山': 'Ulsan',
  '玉树': 'Yushu',
  '伊斯兰堡': 'Islamabad',
  '伊斯坦布尔': 'Istanbul',
  '鹰潭': 'Yingtan',
  '烟台': 'Yantai',
  '于田': 'Yu Tian',
  '亚特兰大': 'Atlanta',
  '义乌': 'Yiwu',
  '雅温得': 'Yaound茅',
  '宜兴': 'Yixing',
  '玉溪': 'Yuxi',
  '岳阳': 'Yueyang',
  '永州': 'Yongzhou',
  '芽庄': 'Nha Trang',
  '扬州': 'Yangzhou',
  '伊兹密尔': 'Izmir',
  '朱巴': 'Juba',
  '淄博': 'Zibo',
  '长白山': 'Gunung Changbai',
  '长春': 'Changchun',
  '中国高雄': 'Kaohsiung, Cina',
  '中国金门': 'Gerbang Emas Cina',
  '中国台北': 'Cina Taipei',
  '中国台南': 'Tainan, Cina',
  '中国台中': 'Taichung, Cina',
  '札幌': 'Sapporo',
  '珠海': 'Zhuhai',
  '湛江': 'Zhanjiang',
  '镇江': 'Zhenjiang',
  '芝加哥': 'Chicago',
  '张家界': 'Zhangjiajie',
  '张家口': 'Zhangjiakou',
  '周口': 'Zhoukou',
  '扎兰屯': 'Zhalantun',
  '驻马店': 'Zhumadian',
  '斋浦尔': 'Jaipur',
  '重庆': 'Chongqing',
  '长崎': 'Nagasaki',
  '肇庆': 'Zhaoqing',
  '长沙': 'Changsha',
  '中山': 'Zhongshan',
  '舟山': 'Zhoushan',
  '昭苏': 'Zhaosu',
  '昭通': 'Zhaotong',
  '中卫': 'Penjaga Pusat',
  '张掖': 'Zhangye',
  '资阳': 'Ziyang',
  '遵义茅台': 'Zunyi Moutai',
  '遵义新舟': 'Perahu Baru Zunyi',
  '郑州': 'Zhengzhou',
  '长治': 'Changzhi',
  '株洲': 'Zhuzhou',
  '枣庄': 'Zaozhuang',
  '涿州': 'Zhuozhou',
  '漳州': 'Zhangzhou',
  '热门城市（可直接选择城市或输入城市中文/拼音）': 'Kota populer (Anda dapat langsung memilih kota atau memasuki kota Cina / Pinyin) ',
  '热门': 'Populer',
  '输入中文/拼音/↑↓键选择': 'Masukkan kunci Cina / Pinyin / ↑ ↓ untuk dipilih',
  '运营出票单查询': 'Pertanyaan tiket operasi',
  '运营退票单查询': 'Penyelidikan formulir pengembalian dana operasi',
  '采购退票单查询': 'Bentuk pembelian kembali',
  '供应退票单查询': 'Penyelidikan Pengembalian Dana Pasokan',
  '运营改签单查询': 'Penyelidikan perintah perubahan operasi',
  '采购改签单查询': 'Bentuk pembelian amandemen',
  '供应改签单查询': 'Permintaan pesanan perubahan pasokan',
  '退票完成': 'Pengembalian dana selesai',
  '退票中': 'Aplikasi pengembalian dana sedang berlangsung',
  '退票失败': 'Pengembalian dana gagal',
  '退票申请': 'Aplikasi pengembalian dana',
  '特殊': 'Spesial',
  '自愿': 'Sukarela',
  '非自愿': 'Tidak sukarela',
  '航变': 'Perubahan penerbangan',
  '病退': 'Pensiun dari penyakit',
  '备降': 'Penggantian',
  '重构全退': 'Refactoring pengembalian dana penuh',
  '拒载': 'Menolak',
  '超售': 'Oversold',
  '疫情': 'Epidemi',
  '特殊事件': 'Acara spesial',
  '拒签': 'Penolakan visa',
  '形式全退': 'Pengembalian dana penuh formal',
  '废票': 'Tiket terbengkalai',
  '其它': 'Lainnya',
  '改签完成': 'Perubahan selesai',
  '改签失败': 'Perubahan gagal',
  '未知': 'Tidak diketahui',
  '改签选择航班': 'Ubah Pilih Penerbangan',
  '新增政策': 'Kebijakan baru',
  '政策修改': 'Modifikasi Kebijakan',
  rolemanage: {
    'Permission Control': 'Kontrol Izin',
    'Add Role': 'Peran baru',
    'Modify role': 'Ubah peran',
    'Specify user role': 'Tentukan peran pengguna',
    'User to be specified': 'Pengguna yang akan ditentukan',
    'Selected Designated User': 'Pengguna Terpilih Yang Ditunjuk',
    'Permission': 'Seleksi izin',
    'Please enter a role name': 'Silakan masukkan nama peran',
    'Role management': 'Manajemen peran',
    '-Half selected': '-Setengah terpilih',
    'Modify permission successfully': 'Ubah izin berhasil',
    'New Character Success': 'Kesuksesan Karakter Baru',
    'Assigned role success': 'Peran yang ditugaskan berhasil'
  },
  shortmsglist: {
    'Ticket SMS': 'SMS Tiket',
    'Change SMS': 'Ganti SMS',
    'Refund SMS': 'Refund SMS',
    'Airchange SMS (including delay, cancellation, resumption)': 'SMS Lintas Udara (termasuk penundaan, pembatalan, dimulainya kembali)',
    'Service SMS': 'SMS Layanan',
    'Receive number': 'Nomor penerima',
    'Send number': 'Kirim nomor',
    'Content': 'Konten',
    'Time': 'Waktu',
  },
  systemlog: {
    'HR file': 'File HR',
    'Deactivated': 'Dinonaktifkan',
    'Real name': 'Nama Asli',
    'Date': 'Tanggal'
  },
  systemsetting: {
    'Setup name': 'Nama pengaturan',
    'Set content': 'Setel konten',
    'Modification time': 'Waktu modifikasi',
    'Modifier': 'Modifier',
    'New system settings': 'Pengaturan sistem baru',
    'Please select a setting name': 'Silakan pilih nama pengaturan',
    'Please fill in the settings': 'Silakan isi pengaturan',
    'Edit system settings': 'Edit pengaturan sistem',
    'Added system settings successfully': 'Menambahkan pengaturan sistem dengan sukses',
    'Modified successfully': 'Berhasil dimodifikasi',
    'Delete system settings successfully': 'Hapus pengaturan sistem berhasil',
    'System settings not found': 'Pengaturan sistem tidak ditemukan',
  },
  orderdetail: {
    'Rescheduled Upgrade': 'Reschedule Upgrade',
    'Loading desperately': 'Memuat mati-matian...',
    'Ticket Details': 'Detail Tiket',
    'Payment address': 'Alamat pembayaran',
    'Are you sure to issue a ticket?': 'Apakah Anda yakin untuk mengeluarkan tiket?',
    'Ticketing': 'Tiket',
    'Booking Express Instructions': 'Petunjuk Pemesanan Ekspres',
    'Aviation monitoring': 'Pemantauan penerbangan',
    'Ticket swipe': 'Gesek tiket',
    'Cancel Order': 'Batalkan Pesanan',
    'Convert to Appeal Form': 'Konversi ke Bentuk Banding',
    'Exception entry': 'Entri pengecualian',
    'Refund form entry': 'Entri formulir pengembalian dana',
    'Early pick-up': 'Penjemputan awal',
    'Unlock and close': 'Buka kunci dan tutup',
    'Process and lock': 'Proses dan kunci',
    'Close': 'Tutup',
    'Order information': 'Informasi pesanan',
    'Store name': 'Nama toko',
    'Platform ticket number': 'Nomor tiket platform',
    'Platform change order number': 'Nomor pesanan ganti platform',
    'Platform refund order number': 'Nomor pesanan pengembalian dana platform',
    'Exception order number': 'Nomor urutan pengecualian',
    'Appeal number': 'Nomor banding',
    'Downloadable': 'Dapat diunduh',
    'No downgrade': 'Tidak ada downgrade',
    'Order sub-status': 'Sub status pesanan',
    'Fill failed': 'Isi gagal',
    'Unticketed Refund Purchased': 'Unticketed Refund Purchased',
    'Reimbursement Type': 'Jenis Penggantian',
    'Price reduction': 'Pengurangan harga',
    'Price can be reduced': 'Harga bisa dikurangi',
    'No price reduction': 'Tidak ada pengurangan harga',
    'Latest ticket issuance time': 'Waktu penerbitan tiket terbaru',
    'Total Fare': 'Total harga par',
    'Total selling price': 'Total harga jual',
    'Total machine cost': 'Total biaya mesin',
    'Total fuel cost': 'Total biaya bahan bakar',
    'Ticketing time': 'Waktu tiket',
    'ticketing time': 'Waktu tiket',
    'Account verification time': 'Waktu verifikasi akun',
    'Mailing Itinerary': 'Itinerary Mailing',
    'Ticket Notes': 'Catatan Tiket',
    'Return and change instructions': 'Instruksi kembali dan ubah',
    'Epidemics cannot enter': 'Epidemi tidak bisa masuk',
    'Untrustworthy': 'Tak bisa dipercaya',
    'No same cabin for external release': 'Tidak ada kabin yang sama untuk rilis eksternal',
    'Enter the single upgrade': 'Masukkan peningkatan tunggal',
    'Ticket reservation upgrade': 'Upgrade reservasi tiket',
    'The freight does not match': 'Pengangkutan tidak cocok',
    'Policy loss': 'Kehilangan kebijakan',
    'Flight Cancellation': 'Pembatalan Penerbangan',
    'Quick save': 'Penghematan cepat',
    'Flight date': 'Tanggal penerbangan',
    'Itinerary': 'Itinerary',
    'Flight number': 'Nomor penerbangan',
    'Class': 'Kelas',
    'Document number': 'Nomor dokumen',
    'KN registration certification': 'sertifikasi pendaftaran KN',
    'Total sales price': 'Total harga jual',
    'Purchase Amount': 'Jumlah Pembelian',
    'Please enter the purchase amount': 'Silakan masukkan jumlah pembelian',
    'Please enter PNR': 'Silahkan masuk PNR',
    'Please enter large code': 'Silakan masukkan kode besar',
    'Ticket number format': 'Format nomor tiket',
    'Please enter ticket number': 'Silakan masukkan nomor tiket',
    'Ticket number verification': 'Verifikasi nomor tiket',
    'Please enter profit': 'Silakan masukkan untung',
    'Are you sure to re-occupy the seat?': 'Apakah Anda yakin untuk menempati kembali kursi?',
    'Re-occupy the seat': 'Kembali menempati kursi',
    'Are you sure to pay again?': 'Apakah Anda yakin untuk membayar lagi?',
    'Re-pay': 'Gaji ulang',
    'Are you sure about the booking code?': 'Apakah Anda yakin tentang kode pemesanan?',
    'Booking Code': 'Kode Pemesanan',
    'Out-of-pocket tickets': 'Tiket out-of-pocket',
    'Save Ticket': 'Tiket Hemat',
    'Unlock and deal with': 'Buka dan tangani',
    'Ticket purchase record': 'Catatan pembelian tiket',
    'Expenditure': 'Pengeluaran',
    'Income': 'Penghasilan',
    'Passenger': 'Penumpang',
    'Purchase channel': 'Saluran pembelian',
    'Payment Channel': 'Saluran Pembayaran',
    'Purchase Order Number': 'Nomor Pesanan Pembelian',
    'Procurement space': 'Ruang pengadaan',
    'Purchase Remarks': 'Keterangan Pembelian',
    'Agency Fee': 'Biaya Agensi',
    'Agency Rate': 'Tingkat Agensi',
    'Please select the procurement channel': 'Silakan pilih saluran pengadaan',
    'Purchase Type': 'Jenis Pembelian',
    'Please select type': 'Silakan pilih jenis',
    'Offer Type/Offer Logo': 'Jenis Penawaran / Logo Penawaran',
    'Stored Value Card': 'Kartu Nilai Tersimpan',
    'Points': 'Poin',
    'Agency Fee/Agency Fee': 'Biaya Badan / Biaya Badan',
    'New purchase record': 'Catatan pembelian baru',
    'Keep Purchase Records': 'Simpan Catatan Pembelian',
    'Contact Phone': 'Nama Kontak',
    'Account verification information': 'Informasi verifikasi akun',
    'Platform collection and verification amount': 'Jumlah pengumpulan dan verifikasi platform',
    'Platform collection and verification time': 'Waktu pengumpulan dan verifikasi platform',
    'Save the platform collection and verification information': 'Simpan pengumpulan platform dan informasi verifikasi',
    'Purchase payment verification amount': 'Beli jumlah verifikasi pembayaran',
    'Purchase Payment Billing Time': 'Beli Pembayaran Waktu Penagihan',
    'Save the purchase payment verification information': 'Simpan informasi verifikasi pembayaran pembelian',
    'Refund information': 'Refund information',
    'Please select purchase status': 'Silakan pilih status pembelian',
    'Pending payment': 'Pembayaran tertunda',
    'Payment in progress': 'Pembayaran sedang berlangsung',
    'Edit Purchase Record': 'Edit Rekor Pembelian',
    'Purchase Fare': 'Harga beli par',
    'Edit Order Remarks': 'Edit Keterangan Perintah',
    'Shared flight': 'Penerbangan bersama',
    'Main flight': 'Penerbangan utama',
    'Childrens Booking Instructions': 'Petunjuk Pemesanan Anak',
    'One-click AV': 'Satu klik AV',
    'Product Details': 'Detail Produk',
    'Edit Product': 'Edit Produk',
    'Product name': 'Nama produk',
    'NFD': 'NFD',
    'Clearance Products': 'Produk Clearance',
    'Business travel products': 'Produk perjalanan bisnis',
    'Transit': 'Transit',
    'Transit product': 'Produk transit',
    'Charter': 'Piagam',
    'Cut position': 'Posisi potong',
    'Airline VIP': 'VIP Maskapai',
    'General Policy': 'Kebijakan Umum',
    'Prepayment Policy': 'Kebijakan Prabayar',
    'Team Policy': 'Kebijakan Tim',
    'Special Offer Policy': 'Kebijakan Penawaran Khusus',
    'K-bit policy': 'Kebijakan K-bit',
    'Fixed price': 'Harga tetap',
    'Applicable class': 'Kelas yang berlaku',
    'Sales Type': 'Tipe Penjualan',
    'Direct connection': 'Koneksi langsung',
    'Fixed cabin': 'Kabin tetap',
    'See cabin': 'Lihat kabin',
    'Policy Code Format': 'Format Kode Kebijakan',
    'Additional airline code': 'Kode maskapai tambahan',
    'Additional delivery timetime and time': 'Waktu pengiriman tambahan (waktu dan waktu)',
    'Delivery Type': 'Tipe Pengiriman',
    'Total + increment': 'Total + kenaikan',
    'Full amount only': 'Jumlah penuh saja',
    'Increment only': 'Increment only',
    'Delete policy on increment': 'Hapus kebijakan kenaikan',
    'Delete type': 'Tipe hapus',
    'By Policy Code': 'Dengan Kode Kebijakan',
    'By delivery time': 'Pada waktu pengiriman',
    'itinerary': 'Itinerary',
    'Invoice': 'Faktur',
    'Itinerary + difference invoice': 'Itinerary + faktur selisih',
    'office number': 'nomor kantor',
    'IATA number': 'nomor IATA',
    'Drop the upper class': 'Jatuhkan kelas atas',
    'Reservation': 'Reservasi',
    'PAT': 'PAT',
    'Organic Wine Package': 'Paket Anggur Organik',
    'Support stop': 'Dukungan berhenti',
    'Support children': 'Dukung anak',
    'Tariff rules': 'Aturan tarif',
    'Return and change ID': 'Kembali dan ganti ID',
    'Placing Fare': 'Menempatkan harga par',
    'Price Type': 'Tipe Harga',
    'Official website price': 'Harga website resmi',
    'Settlement price': 'Harga penyelesaian',
    'Specified Fare': 'Harga par yang ditentukan',
    'Y cabin discount': 'Diskon kabin Y',
    'Special Ticket Instructions': 'Petunjuk Tiket Khusus',
    'Minimum age limit': 'Batas usia minimum',
    'Maximum age limit': 'Batas usia maksimal',
    'Airline': 'Maskapai',
    'Departure airport code': 'Kode bandara keberangkatan',
    'Arrival airport code': 'Kode bandara kedatangan',
    'Adult cabin': 'Kelas dewasa',
    'Childrens Class': 'Kelas Anak',
    'Select flight date': 'Pilih tanggal penerbangan',
    'Select departure time': 'Pilih waktu keberangkatan',
    'Select arrival time': 'Pilih waktu kedatangan',
    'Get payment address': 'Dapatkan alamat pembayaran',
    'Purchase status': 'Status pembelian',
    'Go to pay': 'Pergi untuk membayar',
    'Ticket swiping rules': 'Aturan menggesek tiket',
    'Ticket swiping frequency': 'Frekuensi menggesek tiket',
    'Ticket source': 'Sumber tiket',
    'Official website': 'Situs web resmi',
    'Ticket swiping channel': 'Saluran gesek tiket',
    'Whether to account for': 'Apakah akan memperhitungkan',
    'Brushing class': 'Kelas menyikat',
    'Monitor the superior class': 'Pantau kelas unggulan',
    'Superior class number reminder': 'Pengingat nomor kelas atas',
    'Deadline for swiping tickets': 'Batas waktu untuk menggesek tiket',
    'Select datetime': 'Pilih datetime',
    'Appeal Type': 'Tipe Banding',
    'Platform Refund': 'Platform Refund',
    'Quality inspection': 'Pemeriksaan kualitas',
    'Our appeal': 'Banding kami',
    'Appeal amount': 'Jumlah banding',
    'Appeal Remarks': 'Keterangan Banding',
    'reason': 'alasan',
    'Ticketing channel': 'Saluran tiket',
    'Ticketing office': 'Kantor tiket',
    'Lowest cabin': 'Kabin terendah',
    'No coupons': 'Tidak ada kupon',
    'Coupons are useful or not': 'Kupon bermanfaat atau tidak',
    'Age': 'Umur',
    'Invoicing': 'Menyuarakan',
    'Single settlement price': 'Harga penyelesaian tunggal',
    'Ticketing gross profit': 'Laba kotor tiket',
    'Cashback + Cashback': 'Cashback + Cashback',
    'Rebate': 'Rabat',
    'Cash back': 'Uang kembali',
    'Par/Class': 'Par / Kelas',
    'Adult': 'Dewasa',
    'Offer': 'Penawaran',
    'Order and pay': 'Pesan dan bayar',
    'WONIU': 'WONIU',
    'Select Flight Person': 'Pilih Orang Penerbangan',
    'Verification Channel': 'Saluran Verifikasi',
    'Where to go': 'Ke mana harus pergi',
    'Ticket number status': 'Status nomor tiket',
    'Fare price': 'Harga tarif',
    'Modify ticket number': 'Ubah nomor tiket',
    'Purchasing channel cannot be empty': 'Pembelian channel tidak boleh kosong',
    'Purchase order number cannot be empty': 'Nomor pesanan pembelian tidak boleh kosong',
    'The transaction serial number cannot be empty': 'Nomor seri transaksi tidak dapat dikosongkan',
    'Payment amount cannot be empty': 'Jumlah pembayaran tidak bisa kosong',
    'The preferential amount cannot be empty, it can be 0': 'Jumlah preferensial tidak boleh kosong, bisa 0',
    'Airline cannot be empty': 'Maskapai tidak boleh kosong',
    'Departure airport code cannot be empty': 'Kode bandara keberangkatan tidak boleh kosong',
    'Arrival airport code cannot be empty ': 'Kode bandara kedatangan tidak boleh kosong',
    'Flight number cannot be empty': 'Nomor penerbangan tidak boleh kosong',
    'Adult cabin cannot be empty': 'Kelas dewasa tidak boleh kosong',
    'Childrens cabin cannot be empty': 'Kabin anak tidak boleh kosong',
    'Please select a flight date': 'Silakan pilih tanggal penerbangan',
    'Please select departure time': 'Silakan pilih waktu keberangkatan',
    'Please select arrival time': 'Silakan pilih waktu kedatangan',
    'Please select the reason for cancellation': 'Silakan pilih alasan pembatalan',
    'Please select the frequency of swiping tickets': 'Silakan pilih frekuensi menggesek tiket',
    'Please select the brush ticket source': 'Silakan pilih sumber tiket kuas',
    'Please select the ticket swiping channel': 'Silakan pilih saluran gesek tiket',
    'Please select whether to account for': 'Silakan pilih apakah akan memperhitungkan',
    'Please enter the swiping class': 'Silahkan masuk kelas gesek',
    'Please enter the monitoring superior class': 'Silakan masuk ke kelas unggulan monitoring',
    'Please enter the superior class number reminder': 'Silakan masukkan pengingat nomor kelas unggulan',
    'Please select the deadline for swiping tickets': 'Silakan pilih batas waktu untuk menggesek tiket',
    'Please enter the order remarks': 'Silakan masukkan komentar pesanan',
    'Please select the appeal type': 'Silakan pilih tipe banding',
    'Please fill in the appeal amount': 'Silahkan isi jumlah bandingnya',
    'The specified class code cannot be empty': 'Kode kelas yang ditentukan tidak boleh kosong',
    'Ticket number cannot be empty': 'Nomor tiket tidak boleh kosong',
    'Easy to travel': 'Nomor tiket tidak boleh kosong',
    'No Data': 'Belum ada data',
    'Flight Butler': 'Flight Butler',
    'Snail': 'Siput',
    'Return to the ticket list and try again after refreshing according to F5': 'Kembali ke daftar tiket dan coba lagi setelah refreshing sesuai F5',
    'Please enter the platform collection and verification amount': 'Silakan masukkan jumlah pengumpulan dan verifikasi platform',
    'Please enter the platform collection and verification time': 'Silakan masukkan pengumpulan dan verifikasi platform',
    'Save the platform collection and verification successfully': 'Simpan pengumpulan dan verifikasi platform dengan sukses',
    'Failed to save the platform collection and verification account Reason:': 'Gagal menyimpan akun pengumpulan dan verifikasi platform Alasan:',
    'Please enter the purchase payment verification amount': 'Silakan masukkan jumlah verifikasi pembayaran pembelian',
    'Please enter the purchase payment billing time': 'Silakan masukkan waktu penagihan pembayaran pembelian',
    'Save the purchase payment verification successfully': 'Simpan verifikasi pembayaran pembelian dengan sukses',
    'Failed to save the purchase payment verification account, Reason:': 'Gagal menyimpan akun verifikasi pembayaran pembelian, Alasan:',
    'Delete the platform collection and verification successfully': 'Hapus pengumpulan dan verifikasi platform dengan sukses',
    'Delete the platform collection and verification failed. Reason:': 'Penghapusan pengumpulan dan verifikasi platform gagal. Alasan:',
    'Delete the purchase payment verification successfully': 'Hapus verifikasi pembayaran pembelian berhasil',
    'Delete the purchase payment verification failed, reason:': 'Hapus verifikasi pembayaran pembelian gagal, alasan:',
    'REFUNDED Refunded': 'Hapus verifikasi pembayaran pembelian gagal, alasan:',
    'VOID voided': 'VOID voided',
    'SUSPENDED Suspended': 'SUSPENDED Suspended',
    'CHECKED IN checked in': 'CHECKED IN check in',
    'LIFT/BOARDED has left port': 'LIFT / BOARDED telah meninggalkan pelabuhan',
    'USED/FLOWN Used': 'Digunakan / FLOWN Digunakan',
    'OPENFORUSE': 'BUKA UNTUK PENGGUNAAN',
    'Success~': 'Sukses ~',
    'Modify the segment information successfully': 'Ubah informasi segmen berhasil',
    'Please enter the correct number': 'Silakan masukkan nomor yang benar',
    'The current limit selects 9 files, this time it is selected': 'Batas saat ini memilih 9 file, kali ini dipilih',
    'Files selected in total': 'File dipilih secara total',
    'Converted to appeal form successfully': 'Dikonversi ke formulir banding berhasil',
    'Refund order number': 'Nomor pesanan pengembalian uang',
    'Successful early seat pick-up': 'Penjemputan kursi awal yang sukses',
    'Failed to take place early, reason:': 'Gagal terjadi lebih awal, alasan:',
    'Failed to cancel the order, reason:': 'Gagal membatalkan pesanan, alasan:',
    'Modify the remarks successfully': 'Ubah komentar dengan sukses',
    'Senior Special': 'Spesial Senior',
    'The order does not exist click OK to close the label': 'Pesanan tidak ada, klik OK untuk menutup label.',
    'Payment channel cannot be empty': 'Saluran pembayaran tidak boleh kosong',
    'Type cannot be empty': 'Tipe tidak bisa kosong',
    'Purchase account cannot be empty': 'Akun pembelian tidak boleh kosong',
    'Purchase password cannot be empty': 'Kata sandi pembelian tidak boleh kosong',
    'New purchase record successful': 'Catatan pembelian baru berhasil',
    'Modify the purchase record successfully!': 'Ubah catatan pembelian dengan sukses!',
    'Delete the purchase record successfully': 'Hapus catatan pembelian dengan sukses',
    'The new ticket swiping order was successful': 'Urutan gesek tiket baru berhasil',
    'Are you sure to close the current page?': 'Apakah Anda yakin untuk menutup halaman saat ini?',
    'Are you sure to unlock and close?': 'Apakah Anda yakin untuk membuka dan menutup?',
    'Unlocked and processed successfully': 'Tidak terkunci dan berhasil diproses',
    'Baby': 'Bayi',
    'ID card': 'KTP',
    'Passport': 'Paspor',
    'Product information is empty': 'Informasi produk kosong',
    'Please fill in the passenger ticket number and try again': 'Silahkan isi nomor tiket penumpang dan coba lagi',
    'Incorrect ticket number': 'Nomor tiket salah',
    'Please fill in the passenger PNR and try again': 'Silahkan isi penumpang PNR dan coba lagi',
    'PNR is incorrect': 'PNR tidak benar',
    'Big encoding incorrect': 'Pengkodean besar salah',
    'Purchase amount must be greater than 0': 'Jumlah pembelian harus lebih besar dari 0',
    'Please enter': 'Silakan masuk',
    'Successful ticket issuance!': 'Penerbitan tiket yang berhasil!',
    'The ticket has been issued': 'Tiket telah diterbitkan',
    'There is already a successful purchase record and the seat cannot be re-occupied. Please use ticketing to reset': 'Sudah ada catatan pembelian yang berhasil dan kursi tidak dapat di tempati kembali. Silakan gunakan tiket untuk mengatur ulang',
    'Resumption Success': 'Resumption Success',
    'Ticket reset successful': 'Pengaturan ulang tiket berhasil',
    'Create an order and pay successfully, wait for asynchronous ticket issuance': 'Buat pesanan dan bayar dengan sukses, tunggu penerbitan tiket asinkron',
    'Ordinary standard': 'Standar biasa',
    'Preferred': 'Pilihan',
    'special Offer': 'Penawaran Khusus',
    'Special Products': 'Produk Khusus',
    'Youth and Senior Special': 'Spesial Pemuda dan Senior',
    'Multiplayer Offer': 'Penawaran Multiplayer',
    'Travel worry-free': 'Perjalanan bebas khawatir',
    'pa airline direct sales': 'pa penjualan langsung maskapai',
    'pb standard official website': 'pb situs web resmi standar',
    'pd housekeeper self-operated': 'pd pengurus rumah tangga mandiri',
    'PE Agent Standard': 'pe Standar Agen',
    'pj charter cut': 'pj charter cut',
    'PC official website special offer': 'pc penawaran khusus situs web resmi',
    'Ph Standard Special': 'ph Standard Special',
    'pf agent special offer': 'pf  Standard Special',
    'Py special low price': 'py harga murah khusus',
    'pw shares the main flight': 'pw harga murah khusus',
    'Official website this policy requires the passengers own mobile phone number': 'Situs web resmi (kebijakan ini mensyaratkan nomor ponsel penumpang sendiri)',
    'Other': 'Lainnya',
    'Not provided': 'Tidak disediakan',
    'Booking code successful': 'Kode pemesanan berhasil',
    'PNR cannot be empty': 'PNR tidak boleh kosong',
    'Save the ticket successfully!': 'Simpan tiket dengan sukses!',
    'Unable to jump to the payment page, the payment address is empty!': 'Tidak dapat melompat ke halaman pembayaran, alamat pembayaran kosong!',
    'The payment address is in the wrong format, please try again!': 'Alamat pembayaran dalam format yang salah, silakan coba lagi!',
    'Was the payment successful?': 'Apakah pembayaran berhasil?',
    'Payment result': 'Hasil pembayaran',
    'Payment successful': 'Pembayaran berhasil',
    'International students': 'Siswa internasional',
    'Date of Birth': 'Tanggal Lahir',
    'Main fly': 'Main fly',
    'Stop': 'Berhenti',
    'First Class': 'Kelas Satu',
    'Business Cabin': 'Kabin Bisnis',
    'walletPay': 'Pembayaran dompet',
    'Alipay payment': 'Alipay payment',
    'Online Banking Payment': 'Pembayaran Perbankan Online',
    'Credit Card Payment': 'Pembayaran Kartu Kredit',
    'Total order price': 'Total harga pesanan:',
    'Available Balance': 'Saldo Tersedia:',
    'The Deposit funds is insufficient please recharge': 'The balance of this wallet is insufficient',
    'Payment password': 'Kata sandi pembayaran:',
    'Confirm payment': 'Konfirmasi pembayaran',
    'Paying': 'Membayar...',
    'Contact person': 'Kontak person',
    'Passenger Name': 'Nama Penumpang',
    'Order total': 'Total pesanan',
    'Contact Information': 'Informasi kontak'
  },
  organizationalStructure: {
    'Affiliated organization': 'Organisasi afiliasi',
    'Please enter department name': 'Silakan masukkan nama departemen',
    'Superior department': 'Departemen yang lebih tinggi',
    'Please select the superior department': 'Silahkan pilih departemen atasan',
    'Note': 'Note',
    'Please enter a note': 'Silakan masukkan catatan',
    'Department Number': 'Nomor Departemen',
    'Please enter department number': 'Silakan masukkan nomor departemen',
    'By department': 'Menurut departemen',
    'Department Management': 'Manajemen Departemen',
    'Select Department': 'Pilih Departemen',
    'This action will permanently delete departments(': 'Tindakan ini akan menghapus departemen secara permanen',
    '), whether to continue ?': '), apakah akan melanjutkan?',
    'Deleted successfully!': 'Dihapus berhasil!',
    'Delete failed!': 'Hapus gagal!',
    'The highest level department cannot be deleted!': 'Departemen tingkat tertinggi tidak dapat dihapus!',
    'Please select the department to delete!': 'Silakan pilih departemen untuk dihapus!',
    'Please fill in the department name': 'Silahkan isi nama jurusan',
    'The new/modified department was successful!': 'Departemen baru / modifikasi berhasil!',
    'Failed to add/modify department (': 'Gagal menambah / memodifikasi departemen (',
    '), please try again later !': '), silakan coba lagi nanti!',
    'Department position': 'Posisi departemen',
    'Department Deputy': 'Deputi Departemen',
    'Department Secretary': 'Sekretaris Departemen',
    'Department data initialization failed, please try again later': 'Inisialisasi data departemen gagal, silakan coba lagi nanti',
    'Data initialization failed, please try again later': 'Inisialisasi data gagal, silakan coba lagi nanti'
  },
  generalManager: {
    'Description': 'Keterangan',
    'Please fill in the job title': 'Silahkan isi jabatan',
    'Up to 50 characters in length': 'Panjang hingga 50 karakter',
    'Confirm deletion of selected posts?': 'Konfirmasi penghapusan postingan terpilih?',
    'Operation successful': 'Operasi berhasil'
  },
  announcementManage: {
    'Please fill in the title': 'Silahkan isi judul',
    'Sender': 'Pengirim',
    'New announcement ': 'Pengumuman baru',
    'Please fill in the sender': 'Silahkan isi pengirimnya',
    'Content': 'Konten',
    'Select file': 'Pilih file',
    'Only xlsx files can be uploaded, and each file does not exceed 20M ': 'Hanya file .xlsx yang dapat diunggah, dan setiap file tidak melebihi 20M',
    'Please fill in the content': 'Silahkan isi isinya',
    'Announcement released successfully': 'Pengumuman berhasil dirilis',
    'Delete announcement successful': 'Hapus pengumuman berhasil'
  },
  menu: {
    'Parent menu': 'Nama menu orang tua',
    'Menu name': 'Nama menu',
    'Menu state': 'Menu state',
    'Menu Level ': 'Tingkat Menu',
    'Level One': 'Tingkat Satu',
    'Level Two': 'Tingkat Dua',
    'Level three ': 'Level tiga',
    'Level Four': 'Tingkat Empat',
    'Menu type': 'Jenis menu',
    'Operation ': 'Operasi',
    'Supplier ': 'Supplier',
    'Buyer': 'Pembeli',
    'Account Type': 'Jenis Akun',
    'Menu level': 'Level menu',
    'Node link': 'Node link',
    'Menu order': 'Pesanan menu',
    'Menu icon': 'Ikon menu',
    'Button ID': 'ID Tombol',
    'Please select account type': 'Silakan pilih jenis akun',
    'Administrator': 'Administrator',
    'Please select menu level': 'Silahkan pilih level menu',
    'Superior menu': 'Menu unggulan',
    'Please select the superior menu': 'Silahkan pilih menu unggulan',
    'New menu': 'Menu baru',
    'Please fill in the menu name': 'Silahkan isi nama menunya',
    'Please fill in the menu order': 'Silahkan isi pesanan menu',
    'Node link cannot be empty, no connection can be filled in\\': 'Node link tidak bisa kosong, tidak ada koneksi yang bisa diisi\\',
    'Edit menu': 'Edit menu',
    'New menu successful': 'Menu baru sukses',
    'Modified menu successfully': 'Menu modifikasi berhasil',
    'Level 1': 'Menu Level 1',
    'Level 2': 'Menu Level 2',
    'Level 3': 'Menu Level 3',
    'Level 4': 'Menu Level 4',
    'Level 5': 'Menu Level 5',
    'Deleted menu successfully': 'Menu terhapus berhasil',
    'Please select': 'Silahkan pilih'
  },
  dict: {
    'Encoding': 'pengkodean kamus',
    'Dictionary name': 'Nama kamus',
    'Open': 'Buka',
    'Close': 'Tutup',
    'Description': 'Keterangan',
    'Dictionary configuration': 'Konfigurasi kamus',
    'Dictionary list': 'Daftar kamus',
    'Data name': 'Nama data',
    'Data value': 'Nilai data',
    'Sort': 'Sort',
    'Edit dictionary': 'Edit kamus',
    'The smaller the value, the higher it is': 'Semakin kecil nilainya, semakin tinggi',
    'New dictionary': 'Kamus baru',
    'Add dictionary entry': 'Tambahkan entri kamus',
    'Please fill in the dictionary code': 'Silahkan isi kode kamus',
    'Please fill in the dictionary name': 'Silahkan isi nama kamus',
    'Please fill in the data name': 'Silahkan isi nama datanya',
    'Please fill in the data value': 'Silahkan isi nilai data',
    'New data dictionary successfully': 'Kamus data baru berhasil',
    'Modified data dictionary successfully': 'Kamus data modifikasi berhasil',
    'Modified data dictionary status successfully': 'Status kamus data modifikasi berhasil',
    'Delete data dictionary data successfully': 'Hapus data kamus berhasil',
    'Edit dictionary entry': 'Edit entri kamus',
    'New data dictionary entry successful': 'Entri kamus data baru berhasil',
    'Modified data dictionary entry successfully': 'Dimodifikasi entri kamus data berhasil'
  },
  oftenPassenger: {
    'Surname': 'Nama keluarga',
    'Given name': 'Nama yang diberikan',
    'Nationality': 'Nasional',
    'Phone': 'Telepon',
    'Document type': 'Jenis dokumen',
    'ID Number': 'Nomor ID',
    'Sex': 'Gender',
    'Name': 'Nama',
    'Man': 'Laki-laki',
    'Woman': 'Wanita',
    'Birthday': 'Ulang tahun',
    'Select date': 'Pilih tanggal',
    'Passenger type': 'Jenis penumpang',
    'Please select passenger type': 'Silahkan pilih tipe penumpang',
    'Area code': 'Kode area',
    'Expiry': 'Habis',
    'Issuing Country': 'Negara yang mengeluarkan',
    'Please fill in the mobile phone number ': 'Silahkan isi nomor handphone',
    'Please fill in the correct mobile phone number': 'Silahkan isi nomor handphone yang benar',
    'Please fill in your birthday': 'Silahkan isi ulang tahunmu',
    'Birthday cannot be greater than current date': 'Ulang tahun tidak bisa lebih besar dari tanggal saat ini',
    'Please fill in the valid period of the certificate': 'Silahkan isi masa berlaku sertifikat',
    'Document expired': 'Dokumen kadaluarsa',
    'ID number cannot be empty': 'nomor ID tidak bisa kosong',
    'The format of the certificate number is incorrect': 'Format nomor sertifikat salah',
    'Please select nationality': 'Silakan pilih kewarganegaraan',
    'Please select the country issuing the certificate': 'Silahkan pilih negara yang mengeluarkan sertifikat',
    'Please select area code': 'Silahkan pilih kode area',
    'Last name cannot be empty': 'Nama belakang tidak bisa kosong',
    'Only enter English': 'Only enter English',
    'First Name cannot be empty': 'Nama tidak bisa kosong',
    'Adult': 'Adult',
    'Child': 'Child',
    'Infant': 'Infant',
    'Passport': 'Paspor',
    'Please select gender': 'Silakan pilih jenis kelamin',
    'Please select document type': 'Silahkan pilih jenis dokumen',
    'Operation failed': 'Operasi gagal',
    'Added/modified successfully': 'Ditambahkan / dimodifikasi berhasil',
    'New frequent flyer': 'frequent flyer baru',
    'Edit Frequent Flyer': 'Edit Frequent Flyer',
    'Please enter ID number': 'Silahkan masukkan nomor ID',
    'Please enter document type': 'Silakan masukkan jenis dokumen'
  },
  wallet: {
    'Total account assets': 'Total aset akun',
    'Note: Total account assets =(cash + frozen + red packet) amount': 'Perhatian: Total aset rekening = (tunai + beku + amplop merah) jumlah',
    'Available deposit balance': 'Kesimbangan yang tersedia',
    'Unwithdrawable amount': 'Jumlah yang tidak dapat ditarik',
    'Frozen Amount': 'Jumlah beku',
    'red envelope balance': 'Balansi amplop merah',
    'type': 'Tip',
    'Level': 'Level',
    'state': 'Status',
    'query': 'Pertanyaan',
    'Reviewer id': 'Reviewer ID',
    'balance': 'Imbangan dompet',
    'amount withdrawn': 'Jumlah ditarik',
    'Freezing ratio': 'Freeze ratio',
    'Margin': 'Deposit',
    'credit amount': 'Jumlah kredit',
    'operation': 'Operasi',
    'View': 'Lihat',
    'DWR': 'Catatan setoran dan penarikan',
    'Please select': 'Silakan pilih',
    'Exempt Auditor id': 'Exempt Reviewer ID',
    'Credit ratio': 'Nisbah kredit',
    'Total credit balance': 'Total saldo kredit',
    'Pay password': 'Payment Password',
    'Bankcard': 'Nomor kartu bank',
    'Please enter the recharge amount': 'Silakan isi keseimbangan dompet,lalai 0',
    'Recharge amount must be a number with a maximum of two decimal places': 'Imbangan dompet harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'Please fill in the amount withdrawn, default 0': 'Silakan isi jumlah yang ditarik,standar 0',
    'Please fill in the freeze ratio, default 0': 'Silakan isi nisbah beku,lalai 0',
    'The amount withdrawn must be a number with a maximum of two decimal places': 'Jumlah yang ditarik harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'The frozen proportion must be a number with a maximum of two decimal places': 'Rasio beku harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'Please fill in the frozen amount, default 0': 'Silakan isi jumlah beku,lalai 0',
    'The frozen amount must be a number with a maximum of two decimal places': 'Jumlah beku harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'Please fill in the total credit balance, default 0': 'Silakan isi keseluruhan bilangan kredit,default 0',
    'Please fill in margin, default 0': 'Silakan isi deposit,lalai 0',
    'The margin must be a number with a maximum of two decimal places': 'Deposit harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'Please fill in the credit amount, default 0': 'Silakan isi jumlah kredit,default 0',
    'The credit amount must be a number with a maximum of two decimal places': 'Jumlah kredit harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'Please fill in the credit scale, default 0': 'Silakan isi nisbah kredit,default 0',
    'The credit proportion must be numerical and have a maximum of two decimal places': 'Rasio kredit harus menjadi angka dengan maksimum dua tempat perpuluhan',
    'The total credit balance must be a number with a maximum of two decimal places': 'Total saldo kredit harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'Please fill in the payment password': 'Silakan isi kata sandi pembayaran',
    'Payment password must be a number': 'Kata sandi pembayaran harus menjadi nomor',
    'Please fill in the bank card number': 'Silakan isi nomor kartu bank',
    'Card number must be a number': 'Nomor kartu bank harus numerik',
    'Please select type': 'Silakan pilih tipe',
    'Please select level': 'Silakan pilih tingkat',
    'Please select Status': 'Silakan pilih status',
    'Please fill in the reviewer id': 'Silakan isi ID peneliti',
    'Please fill in the audit Exemption id': 'Silakan isi ID peneliti pengecualian',
    'Operation failed': 'Operasi gagal',
    'Added/modified successfully': 'Successfully added/modified',
    'New Details': 'Rencana Baru',
    'Edit Details': 'Edit Details',
    'Transaction status': 'Status Transaksi',
    'Transaction type': 'Jenis Transaksi',
    'Income': 'pendapatan',
    'expenditure': 'belanja',
    'Transaction mode': 'Metode Transaksi',
    'Audit status': 'Status Penerimaan',
    'Order number': 'Perintah No.',
    'Trading hours': 'Waktu transaksi',
    'Transaction No': 'Nomor seri transaksi',
    'Third party Transaction No': 'Nomor seri transaksi pihak ketiga',
    'Transaction Amount': 'Jumlah transaksi',
    'Deposit balance': 'Balance akun',
    'Operator': 'Operator',
    'Original order Number': 'Nomor perintah asli',
    'Third-Party Payee Id': 'Id Pembayar Partii ketiga',
    'Third party Account': 'Nomor Akun Koleksi Partii ketiga',
    'Remarks': 'Remarks',
    'Review': 'Review',
    'isAudit': 'Diaudit',
    'Transaction name': 'Nama Transaksi',
    'Credit repayment status': 'Status pembayaran kredit',
    'third-party payer Id': 'Id Pembayar Partii Tiga',
    'third-party Payment Account': 'Akaun pembayaran pihak ketiga',
    'Third party unrefunded amount': 'jumlah pihak ketiga yang tidak terbalik',
    'Please fill in the transaction amount': 'Silakan isi jumlah transaksi',
    'The amount must be greater than 0 and can have up to two decimal places': 'Jumlah transaksi harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'The third party unreturned amount must be a number with a maximum of two decimal places': 'jumlah pihak ketiga yang tidak diubah harus menjadi nomor dengan maksimum dua tempat perpuluhan',
    'Third party payee Id must be numeric': 'Pihak ketiga membayar Id harus nomor',
    'Third Party payer Id must be numeric': 'Id pembayar pihak ketiga harus nomor',
    'Reviewer id cannot be empty': 'ID Reviewer tidak dapat kosong',
    'Reviewer id must be a number': 'ID Reviewer harus sebuah nomor',
    'in trade': 'Dalam transaksi',
    'Transaction success': 'Transaksi berhasil',
    'deal failed': 'Transaksi gagal',
    'Please fill in the transaction serial number': 'Silakan isi nomor seri transaksi',
    'Please select mode': 'Silakan pilih metode',
    'Please select Audit status': 'Silakan pilih status persetujuan',
    'Please select credit repayment status': 'Silakan pilih status pembayaran kredit',
    'Please select Transaction type': 'Silakan pilih tipe transaksi',
    'Please fill in the original order number': 'Silakan isi nomor perintah asli',
    'Please select Transaction status': 'Silakan pilih status transaksi',
    'Please select trading time': 'Silakan pilih waktu transaksi',
    'Please fill in operator': 'Silakan isi operator',
    'Please select operation type': 'Silakan pilih tipe operasi',
    'Audit details': 'Perincian Penerimaan',
    'accountId': 'Akun Pembayaran',
    'Add wallet': 'Tambah dompet',
    'Return': 'Kembali',
    'Details': 'Detail',
    'Recharge': 'Isi ulang',
    'Withdrawal': 'Penarikan',
    'Recharge method': 'Metode isi ulang',
    'Recharge amount': 'Jumlah isi ulang',
    'Payment account name': 'Nama akun pembayaran',
    'Payment serial number': 'Pembayaran nomor urut',
    'Withdrawal amount': 'Jumlah penarikan',
    'Receiving account name': 'Menerima nama akun',
    'Receiving account number': 'Menerima nomor rekening',
    'Please select the recharge method': 'Silahkan pilih metode isi ulang',
    'Please enter account name': 'Silakan masukkan nama akun',
    'Please enter account number': 'Silahkan masukkan nomor rekening',
    'Please enter serial number': 'Silakan masukkan nomor urut',
    'Account Name': 'Nama Akun',
    'Account number': 'Nomor rekening',
    'Pass': 'Pass',
    'Reject': 'Tolak'
  },
  orderPolicy: {
    'All airports: ALL': 'Semua bandara: SEMUA',
    'Publication of Tariff Policy': 'Pengumuman kebijakan pengiriman barang',
    'Private Configuration Policy': 'Kebijakan konfigurasi pribadi',
    'B2T policy': 'Kebijakan B2T',
    'Travel type': 'Jenis Perjalanan',
    'all': 'Semua',
    'Airlines': 'Maskapai',
    'Policy Code': 'Kode Kebijakan',
    'Point of departure': 'Titik keberangkatan',
    'arrival point': 'Titik kedatangan',
    'Policy source': 'Sumber kebijakan',
    'Policy type': 'Jenis Kebijakan',
    'Policy state': 'Status Kebijakan',
    'Cabin': 'Kelas',
    'Invoicing OFFICE': 'Nomor KANTOR Penagihan',
    'Automatic issue': 'Keluaran tiket otomatis',
    'No Tickets Last Week': 'Minggu lalu tidak ada kebijakan tiket',
    'Start time': 'Waktu mulai',
    'End time': 'Akhir waktu',
    'End time cannot be less than start time': 'Akhir waktu tidak boleh kurang dari waktu mulai',
    'ticket type': 'Jenis Tiket',
    'Policy Alias': 'Kebijakan Alias',
    'Change Encoding': 'Apakah akan mengubah kode',
    'same GDS code import': 'impor pengkodean GDS yang sama',
    'File number': 'Nomor file',
    'Fare Lower': 'Sedikit lebih rendah',
    'Policy id/Policy Type': 'Kode Kebijakan/ Jenis Kebijakan',
    'One way': 'One way',
    'Round trip': 'Perjalanan pulang pergi',
    'One way/round trip': 'Sekali jalan / pulang pergi',
    'Flight type': 'Jenis Penerbangan',
    'Start & End': 'Tanggal mulai dan berakhir',
    'To': 'untuk',
    'return to': 'Backhaul diperluas ke',
    'Originating': 'Asal',
    'arrive': 'Kedatangan',
    'Deduction rate': 'Deduction rate',
    'Quick Fix': 'Modifikasi',
    'state': 'Status',
    'Automatic ticketing': 'Penerbitan tiket otomatis',
    'Last date': 'Kencan terakhir',
    'Modify': 'Modifikasi',
    'Enable': 'Aktifkan',
    'hang': 'Suspend',
    'Agency fee': 'Biaya Agensi',
    'Reward': 'Hadiah',
    'Billing fee': 'Biaya invoicing',
    'one-way direct reduction': 'Satu cara diskon',
    'Round trip subtraction': 'Diskon perjalanan bulat',
    'expiry date': 'Masa berlaku outbound',
    'Policy valid period': 'Periode valid kebijakan',
    'return expiry date': 'Pengembalian masa berlaku diperpanjang menjadi',
    'invoicing period': 'Menyuarakan masa berlaku',
    'Method of issue': 'Metode tiket',
    'par limit is higher than': 'Batas tiket lebih tinggi dari',
    'Appointed agency fee': 'Biaya keagenan yang ditunjuk',
    'Priority BSP': 'Prioritas BSP',
    'priority BOP': 'BOP Prioritas',
    'Designated baggage amount': 'Tunjangan Bagasi Ditunjuk',
    'Settlement method': 'Metode penyelesaian',
    'Please fill in the agency fee, default 0': 'Silahkan isi biaya agensi, default 0',
    'The agency fee must be a number with a maximum of two decimal places': 'Biaya keagenan harus angka dan sampai dua tempat desimal',
    'Please fill in reward, default 0': 'Silahkan isi hadiahnya, defaultnya 0',
    'Reward must be a number with a maximum of two decimal places': 'Hadiah harus berupa angka dan sampai dua tempat desimal',
    'Please fill in the billing fee, default 0': 'Silahkan isi biaya faktur, default 0',
    'Billing fee must be a number with a maximum of two decimal places': 'Biaya invoicing harus berupa angka dan sampai dua tempat desimal',
    'Please fill in one-way direct deduction, default 0': 'Silahkan isi reduksi langsung satu arah, default 0',
    'One-way direct subtraction must be a number with a maximum of two decimal places': 'Pengurangan langsung satu arah harus berupa angka dan hingga dua tempat desimal',
    'Please fill in round trip deduction, default 0': 'Silakan isi reduksi langsung pulang pergi, default adalah 0',
    'Round trip straight subtraction must be a number with a maximum of two decimal places': 'Pengurangan langsung pulang pergi harus berupa angka dan maksimal dua tempat desimal',
    'Face limit must be a number': 'Batas par harus berupa angka',
    'The appointed agency fee must be a number with a maximum of two decimal places': 'Biaya keagenan yang ditunjuk harus berupa angka dan hingga dua tempat desimal',
    'Specified baggage allowance must be a number': 'Jatah bagasi yang ditunjuk harus nomor',
    'domestic origin': 'Asal domestik',
    'Direct SOTO': 'Perjalanan SOTO Langsung',
    'Domestic origin Add-On': 'Pengaya Asal Domestik',
    'Foreign origin Add-On': 'Pengaya Asal Asing',
    'From abroad to abroad': 'Luar Negeri ke Luar Negeri',
    'domestic originating transit': 'Transit asal domestik',
    'foreign originating transit': 'Transit asal asing',
    'offshore offshore': 'Luar Negeri Luar Negeri Luar Negeri',
    'outside China': 'Luar negeri, dalam dan luar negeri',
    'Globe to globe': 'Global to Global',
    'Global to global': 'Global transit global',
    'System hang': 'Sistem ditangguhkan',
    'Unusable': 'Tidak dapat menggunakan',
    'Pending review': 'Ulasan tertunda',
    'Audit failed': 'Audit gagal',
    'under review': 'Meninjau',
    'Offshore electron': 'Elektronik Luar Negeri',
    'No need to change code': 'Tidak perlu mengubah kode',
    'change code issue': 'Ubah kode untuk mengeluarkan tiket',
    'Big ticket issue (no need to change)': 'Tiket skala besar (tidak perlu diubah) ',
    'Big ticket issue (need to change)': 'Tiket skala besar (perlu diubah) ',
    'No need to change the arrangement out of the ticket (no place outside)': 'Tidak perlu mengganti tiket (tidak ada tempat untuk meletakkannya) ',
    'Original draft': 'Tiket asli dikeluarkan',
    'Change out of ticket': 'Tukar tiket',
    'The same region configuration can be originally issued': 'Konfigurasi regional yang sama awalnya dapat diprogram untuk mengeluarkan tiket',
    'Yes': 'Ya',
    'No': 'Tidak',
    'Cash': 'Uang Tunai',
    'Check': 'Cek',
    'Credit card': 'Kartu Kredit',
    'New policy': 'Kebijakan baru',
    'NDC(Foreign Airlines)': 'NDC (maskapai asing) ',
    'official website type': 'Jenis situs web resmi',
    'Official website of B': 'situs resmi B-end',
    'official website of C': 'Situs web resmi C-end',
    'C terminal website': 'Situs web resmi C-end',
    'Invoicing GDS': 'Invoicing GDS',
    'Place of bill': 'Tempat penagihan',
    'Ticket rescheduling': 'Penjadwalan ulang tiket',
    'No time difference': 'Tidak ada perbedaan waktu dalam penjadwalan ulang tiket',
    'Time difference': 'Ada perbedaan waktu hanya untuk penjadwalan ulang',
    'Audit after 9am schedul ': 'Review dijadwal ulang setelah jam 9',
    'Audit after 15pm schedul ': 'Review dijadwal ulang setelah jam 15',
    'Audit after 16pm schedul': 'Review dijadwal ulang setelah jam 16',
    'Audit after 20pm schedul ': 'Review dijadwal ulang setelah jam 20',
    '24h ahead of schedule': '24 jam sebelum penjadwalan ulang',
    '48h ahead of schedule': 'penjadwalan ulang 48 jam sebelumnya',
    'Holiday sales': 'After-sales di hari libur',
    'Applicable airlines': 'Maskapai penerbangan berlaku pada saat yang sama',
    'Unified group airlines': 'Unified Group Airlines, Contoh: MU / CA',
    'Supplier OFFICE': 'Nomor KANTOR Pemasok',
    'Example :SHA889': 'Contoh: SHA889',
    'Invoicing PCC': 'Invoicing PCC',
    'Example53': 'Contoh: 5.3',
    'Example :200': 'Contoh:200',
    'Extra Refund Service': 'Layanan pengembalian dana tambahan',
    'There is a refund service charge': 'Ada biaya layanan pengembalian uang',
    'Refund Service': 'Refund Service',
    'Example:3': 'Contoh: 3',
    'Airlines & Express GDS Policy': 'Kebijakan GDS Maskapai',
    'Protocol type of policy': 'Jenis kebijakan protokol',
    'Please enter': 'Silahkan masuk',
    'Advance issuance days': 'Advanced invoicing days',
    'Minimum stay days': 'Minimal stay days',
    'usual billing time': 'Biasanya menagih waktu',
    'Maximum stay days': 'Maksimum tinggal',
    'Saturday billing time': 'Sabtu menagih waktu',
    'No bill': 'Tidak ada faktur',
    'Sunday billing time': 'Minggu faktur waktu',
    'Auto Ticketing Special Settings': 'Pengaturan khusus untuk tiket otomatis',
    'Please enter Airport 3 code': 'Silakan masukkan kode dua karakter negara atau kode tiga karakter bandara',
    'Transit': 'Transit',
    'Example :A/B/C': 'Contoh: A / B / C',
    'Not applicable to connecting airports': 'Tidak berlaku untuk transfer airport',
    'Applicable age': 'Usia yang berlaku',
    'Optional': 'Unlimited bisa dibiarkan kosong',
    'Year': 'Satu tahun',
    'Applicable number': 'Jumlah orang yang berlaku',
    'Man': 'Orang',
    'day': 'Allah',
    'Child ticket': 'Tiket anak',
    'Child and adult congruence': 'Anak dan Dewasa Konsisten',
    'Open no reward': 'Bisa dibuka tanpa imbalan',
    'Do not open': 'Tidak terbuka',
    'Specify reward': 'Hadiah yang ditunjuk',
    'Do not open without agency fee': 'Tanpa biaya agensi',
    'Children do not open': 'Anak jangan buka sendiri',
    'Children do not enjoy direct deductions': 'Anak-anak tidak menikmati pengurangan langsung',
    'Baby ticket': 'Tiket bayi',
    'Additional service charge': 'Biaya penanganan tambahan',
    'Large code issue (no need to change the encoding)': 'Penerbitan tiket kode besar (tidak perlu diubah) ',
    'Large code issue (need to Change Encoding)': 'Penerbitan tiket kode besar (perlu diubah) ',
    'No bit no ticket (change when there is a bit outside)': 'Tidak ada kursi yang tidak akan ditukar dengan tiket (ganti ketika ada kursi di luar) ',
    'Auto change': 'Warping otomatis',
    'Does no bit accept short editing': 'Apakah akan menerima pengeditan pendek tanpa posisi',
    'Change code does not authorize': 'Mengubah kode tidak sah',
    'Specify Office number location': 'Tentukan lokasi nomor Office',
    'original code issue': 'Tiket kode asli',
    'Not applicable': 'Tidak berlaku',
    'Destination notch': 'Destination gap trip',
    'Gaps in applicable policies': 'Kesenjangan dalam kebijakan yang berlaku',
    'Gap in applicable country': 'Berlaku in-country gap',
    'Designated country': 'Negara yang ditunjuk',
    'unavailable': 'Tidak tersedia',
    'Shared flight': 'Penerbangan bersama',
    'No reward for the whole journey': 'Tidak ada hadiah untuk seluruh proses',
    'Full designated reward': 'Hadiah yang ditunjuk kursus penuh',
    'Shared segment no reward': 'Tidak ada hadiah untuk segmen bersama',
    'Shared segment specified reward': 'Segmen berbagi menentukan hadiah',
    'Partial sharing required for review': 'Berbagi sebagian dapat ditinjau',
    'Do not open with sharing': 'Tidak terbuka dengan berbagi',
    'Give all rewards': 'Berikan semua hadiah',
    'Reward all when shared with the following airlines only': 'Semua hadiah hanya jika dibagikan dengan maskapai berikut',
    'Example :FM or FM/AF(separated by/for multiple airlines)': 'Contoh: FM atau FM / AF (digunakan / dipisahkan ketika beberapa maskapai) ',
    'SPA/ combined transport gives all rewards': 'SPA / intermodal untuk semua hadiah',
    'If :CZ/HU': 'Seperti: CZ / HU',
    'Air Department': 'Maskapai',
    'such as :PVG/SHA/CN': 'Seperti: PVG / SHA / CN',
    'If :CN/HK': 'Misalnya: CN / HK',
    'Must be the first paragraph': 'Harus paragraf pertama',
    'Any segment contains': 'Setiap segmen berisi',
    'Allow mixing 1/2RT': 'Kabin campur 1 / 2RT diperbolehkan',
    'Only the same document number can be mixed 1/2RT': 'Nomor dokumen yang sama dapat dicampur dengan 1 / 2RT',
    'Tariff base to be consistent': 'Basis pengiriman harus sama',
    'Warm reminder: Check the box slightly lower will reduce the chance of the policy being selected, please verify the policy!': 'Pengingat hangat: mencentang tiket yang sedikit lebih rendah akan mengurangi kemungkinan kebijakan dipilih, harap verifikasi kebijakannya!',
    'TOUR CODE contains': 'Terkandung dalam KODE TOUR',
    'For example :CHN5300F/*(* denotes any tourcode)': 'Seperti: CHN5300F / * (* berarti tourcode apa pun) ',
    'No agency fee': 'Tanpa biaya agensi',
    'No reward': 'Tidak ada hadiah',
    'Only applies to the following TOUR CODE': 'Hanya untuk KODE TOUR berikut',
    'CHN5300F/SHAR001 or CHN* (beginning of CHN) or *F01 (ending of F01) or 8HN53* (baohan NH53)': 'CHN5300F / SHAR001 atau CHN * (dimulai dengan CHN) atau * F01 (di akhiri dengan F01) atau 8HN53 * (baohan NH53) ',
    'Does the agency fee apply when the system COMMISSION is 0': 'Apakah biaya keagenan berlaku ketika sistem KOMISI 0',
    'Round-trip must include accommodation': 'Perjalanan pulang pergi harus mencakup kabin',
    'high space, such as: H/B/E/M/D/C/P/Y/M/F': 'Kelas tinggi, seperti: H / E / M / B / D / C / P / Y / J / F',
    'Face value (excluding tax)': 'Tiket (tidak termasuk pajak) ',
    'above': 'Di atas',
    'Invokes only if it is greater than or equal to the amount': 'Faktur hanya akan dikeluarkan jika lebih besar dari atau sama dengan jumlah ini',
    'below': 'Di bawah',
    'Invoicing is required for less than or equal to the amount': 'Faktur hanya akan dikeluarkan jika kurang dari atau sama dengan jumlah ini',
    'included in tariff base': 'Termasuk dalam pangkalan barang',
    'Format :PR/WX/WR': 'Format: PR / WX / WR',
    'Only applicable to the following tariff bases': 'Hanya berlaku untuk basis tarif berikut',
    'Q3M6CN/A3M5TR or Q3*(beginning with Q3M) or *CN(ending with CN) or *R6R*(including R6R) or J(for single base rate only)': 'Q3M6CN / A3M5TR atau Q3 * (dimulai dengan Q3M) atau * CN (di akhiri dengan CN) atau * R6R * (termasuk R6R) atau J (hanya untuk satu tingkat dasar) ',
    'outbound applicable flight': 'Penerbangan keluar yang berlaku',
    'Example:CA123/CA234/TG001-TG999': 'Format: CA123 / CA234 / TG001-TG999',
    'return applicable Flight': 'Kembalikan penerbangan yang berlaku',
    'Not applicable Flights': 'Penerbangan tidak berlaku',
    'Format :CA123/CA234/CA7*/CA27*/TG001-TG999/ No limit': 'Format: CA123 / CA234 / CA7 * / CA27 * / TG001-TG999 / Tidak terbatas opsional',
    'Not applicable route': 'Rute yang tidak berlaku',
    'Example:PVG-BKK/PEK-LHR': 'Format: JP-JP / PVG-JP / CN-ICN',
    'Go cycle not applicable': 'Siklus Outbound Tidak Berlaku',
    'Monday': 'Senin',
    'Tuesday': 'Selasa',
    'Wednesday': 'Rabu',
    'Thursday': 'Kamis',
    'Friday': 'Jumat',
    'Saturday': 'Sabtu',
    'Sunday': 'Minggu',
    'Return not applicable period': 'Siklus Kembali Tidak Berlaku',
    'outbound date not applicable': 'Keberangkatan tidak berlaku tanggal',
    'Return No applicable Date': 'Kembali Tidak Berlaku Tanggal',
    'Other remarks': 'Pernyataan lain',
    'reset': 'Reset',
    'Confirm': 'OK',
    'Refund service fee must be a number with a maximum of two decimal places': 'Biaya layanan pengembalian dana harus berupa angka dan hingga dua tempat desimal',
    'Baggage allowance must be a number': 'Jatah bagasi harus nomor',
    'Days must be numbers': 'Hari harus angka',
    'Abacus or Sabre': 'Abacus atau Sabre',
    'International Student': 'Mahasiswa internasional',
    'Immigrant': 'Imigran',
    'Labour': 'Buruh',
    'Seafarer': 'Seaman',
    'Youth': 'Pemuda',
    'Old age': 'Usia tua',
    'to visit family': 'Mengunjungi kerabat',
    'Hong Kong, Macao and Taiwan': 'Hong Kong, Makau dan Taiwan',
    'Foreign': 'Ekspatriat',
    'non-Chinese name': 'Nama karakter non-Cina',
    'Add-On': 'Add-On',
    'offshore transit': 'Transit luar negeri',
    'OPEN': 'BUKA',
    'Tripartite Agreement': 'Perjanjian Tripartit',
    'Set of ticket': 'Paket',
    'whole lump': 'Seluruh kelompok',
    'Little tuan': 'Kelompok kecil',
    'Please select Policy type': 'Silakan pilih jenis kebijakan',
    'Please select the ticket type': 'Silakan pilih jenis tiket',
    'Please select website type': 'Silahkan pilih tipe website resmi',
    'Please select billing type': 'Silakan pilih jenis faktur',
    'Please reschedule': 'Silakan pilih penjadwalan ulang tiket',
    'Please select': 'Silahkan pilih',
    'Please fill in the airline': 'Silahkan isi maskapai',
    'Please fill in suppliers OFFICE number ': 'Silahkan isi nomor KANTOR supplier',
    'Please fill in the invoice OFFICE number': 'Silahkan isi nomor KANTOR faktur',
    'Please fill in the drawing PCC number': 'Silahkan isi nomor PCC faktur',
    'Please select time': 'Silakan pilih waktu',
    'website': 'website',
    'Please enter the minimum value': 'Silahkan isi minimal jumlah orang',
    'Please enter the maximum value': 'Silahkan isi orang paling banyak',
    'Number of people must be numbers': 'Jumlah orang harus angka',
    'Minimum number of people applicable': 'Jumlah minimum orang yang berlaku',
    'Applicable to up to 9 people': 'Berlaku untuk hingga 9 orang',
    'Minimum number of people up to 8 people': 'Jumlah orang minimal hingga 8 orang',
    'Maximum number of people Minimum 2 people': 'Jumlah orang Maksimal Minimal 2 orang',
    'The minimum number of people cannot exceed the maximum number of people': 'Jumlah minimum orang tidak dapat melebihi jumlah maksimum orang'
  },
  adminLang: {
    'New': 'Baru',
    'Status': 'Status',
    'Query': 'Pertanyaan',
    'Reset': 'Reset',
    'Number of threads': 'Jumlah benang',
    'Proxy ip': 'Proxy ip',
    'Remarks': 'Keterangan',
    'Creation time': 'Waktu penciptaan',
    'Operation': 'Operasi',
    'Disable': 'Nonaktifkan',
    'Edit': 'Sunting',
    'Are you sure to delete?': 'Apakah Anda yakin untuk menghapus?',
    'Delete': 'Hapus',
    'Log': 'Log',
    'Cancel': 'Batal',
    'Save': 'Simpan',
    'Please fill in the number of threads': 'Silahkan isi jumlah benang',
    'Import': 'Impor',
    'Reptile Number': 'Nomor Reptil',
    'Airline': 'Maskapai',
    'Yes': 'Ya',
    'No': 'Tidak',
    'Edit policy crawler configuration': 'Edit konfigurasi perayap kebijakan',
    'Task start time': 'Waktu mulai tugas',
    'Task end time': 'Tugas akhir waktu',
    'Click to upload': 'Klik untuk mengunggah',
    'Only xlsx files can be uploaded': 'Hanya file xlsx yang dapat diunggah',
    'Download Template': 'Download Template',
    'Please fill in the crawler number': 'Silahkan isi nomor crawler',
    'Please fill in the airline': 'Silahkan isi maskapai',
    'Please select task start time': 'Silahkan pilih waktu mulai tugas',
    'Please select task end time': 'Silakan pilih waktu akhir tugas',
    'Added policy crawler configuration': 'Konfigurasi perayap kebijakan tambahan',
    'Added/modified policy crawler configuration successful': 'Ditambahkan / dimodifikasi konfigurasi perayap kebijakan berhasil',
    'Please select airline': 'Silakan pilih maskapai',
    'Are you sure to export the data?': 'Apakah Anda yakin untuk mengekspor data?',
    'Tip': 'Tip',
    'OK': 'OK',
    'Please select the uploaded file': 'Silahkan pilih file yang diunggah',
    'Deleted successfully': 'Dihapus berhasil',
    'Please fill in the mobile phone number': 'Silahkan isi nomor handphone',
    'Please fill in the correct mobile phone number': 'Silahkan isi nomor handphone yang benar',
    'Modify': 'Modifikasi',
    'Status Success': 'Status Sukses',
    'Status failed': 'Status gagal',
    'Level': 'Level',
    'Ready': 'Siap',
    'Running': 'Berlari',
    'Disabled': 'Penyandang Cacat',
    'Task Code': 'Kode Tugas',
    'Task name': 'Nama tugas',
    'Task class name': 'Nama kelas tugas',
    'Task Cron/Update Cron': 'Task Cron / Update Cron',
    'Parameter': 'Parameter',
    'Task timeout': 'Batas waktu tugas',
    'Number of failed retries': 'Jumlah percobaan ulang yang gagal',
    'Are you sure it is enabled?': 'Apakah Anda yakin itu diaktifkan?',
    'Enable': 'Aktifkan',
    'Are you sure it is disabled?': 'Apakah Anda yakin itu dinonaktifkan?',
    'New task scheduling': 'Penjadwalan tugas baru',
    'Edit Task Scheduling': 'Sunting Penjadwalan Tugas',
    'Mission Cron': 'Mission Cron',
    'Cron to perform the task': 'Cron untuk melakukan tugas',
    'Update Cron': 'Update Cron',
    'Cron that regularly updates task content': 'Cron yang secara teratur memperbarui konten tugas',
    '0 is the unlimited timeout time, unit: minutes': '0 adalah waktu timeout tak terbatas, unit: menit',
    '0 is the number of unlimited retries': '0 adalah jumlah percobaan ulang tak terbatas',
    'Please fill in the task code': 'Silahkan isi kode tugas',
    'Please fill in the task name': 'Silahkan isi nama tugas',
    'Please fill in the task class name': 'Silahkan isi nama kelas tugas',
    'Please fill in the task Cron': 'Silahkan isi tugas Cron',
    'Please enter the correct Cron expression': 'Silakan masukkan ekspresi Cron yang benar',
    'Please fill in the update Cron': 'Silahkan isi updatenya Cron',
    'Please fill in the task timeout time': 'Silahkan isi waktu timeout tugas',
    'Please fill in the number of failed retries': 'Silahkan isi jumlah percobaan ulang yang gagal',
    'Task Scheduling Log -': 'Log Penjadwalan Tugas -',
    'Please enter a positive integer': 'Silakan masukkan bilangan bulat positif',
    'New task scheduling successful': 'Penjadwalan tugas baru berhasil',
    'Modified task scheduling successful': 'Modifikasi penjadwalan tugas berhasil',
    'Enabled successfully': 'Diaktifkan berhasil',
    'Disable success': 'Nonaktifkan Sukses',
    'Delete task scheduling successful': 'Hapus penjadwalan tugas berhasil',
    'Valid': 'Valid',
    'Invalid': 'tidak sah',
    'Export': 'Ekspor',
    'Channel': 'Saluran',
    'Crawl type': 'Tipe merangkak',
    'Flight date range': 'Rentang tanggal penerbangan',
    'Route range': 'Rentang rute',
    'Request interval': 'Minta interval',
    'Whether to cache/warehousing': 'Apakah akan cache / pergudangan',
    'Task time range': 'Rentang waktu tugas',
    'Create/last update time': 'Buat / waktu pembaruan terakhir',
    'Total': 'Total',
    'Increment': 'Increment',
    'Class': 'Kelas',
    'Incremental number of seats': 'Jumlah kursi tambahan',
    'Crawling space': 'Ruang merangkak',
    'Multiple People/Separation': 'Banyak Orang / Perpisahan',
    'Flight date start number': 'Nomor mulai tanggal penerbangan',
    'Start from 1, the day is 1': 'Mulai dari 1, hari 1',
    'Number of flight date ends': 'Jumlah tanggal penerbangan berakhir',
    'End number -1 is the end date': 'Nomor akhir -1 adalah tanggal akhir',
    'Route start number': 'Nomor awal rute',
    '0 for all': '0 untuk semua',
    'Number of route ends': 'Jumlah rute berakhir',
    'Unit: milliseconds': 'Unit: milidetik',
    'Increase the number of people when inquiring': 'Tambah jumlah orang saat bertanya',
    'Whether to cache': 'Apakah akan cache',
    'Cache address': 'Cache alamat',
    'Cache time': 'Cache time',
    'Unit: minutes': 'Unit: menit',
    'Whether to put into storage': 'Apakah akan disimpan',
    'Delete type': 'Hapus tipe',
    'Delete by day': 'Hapus di siang hari',
    'Delete by route': 'Hapus melalui rute',
    'Warehousing increase time': 'Pergudangan tambah waktu',
    'Please select channel': 'Silahkan pilih channel',
    'Please select crawl type': 'Silahkan pilih tipe crawl',
    'Please fill in the incremental number of seats': 'Silahkan isi tambahan jumlah kursi',
    'Please fill in the crawling space': 'Silahkan isi ruang merangkak',
    'Please fill in the starting number of the flight date': 'Silahkan isi nomor awal tanggal penerbangan',
    'Please fill in the number of flight date ends': 'Silahkan isi jumlah tanggal penerbangan berakhir',
    'Please fill in the starting number of routesSilahkan isi jumlah awal rute': 'Silahkan isi jumlah awal rute',
    'Please fill in the number of route ends': 'Silahkan isi nomor rute berakhir',
    'Please fill in the request interval': 'Silahkan isi interval permintaan',
    'Please fill in the inquiry to increase the number of people': 'Silahkan isi pertanyaan untuk menambah jumlah orang',
    'Please choose whether to cache': 'Silakan pilih apakah akan cache',
    'Please fill in the cache address': 'Silahkan isi alamat cache',
    'Please fill in the cache time': 'Silahkan isi waktu cache',
    'Please select whether to put into storage': 'Silakan pilih apakah akan dimasukkan ke dalam penyimpanan',
    'Please select deletion type': 'Silakan pilih jenis penghapusan',
    'Please fill in the warehousing increase time': 'Silahkan isi waktu pertambahan pergudangan',
    'Modified status successfully': 'Modifikasi status berhasil',
    'Failed to modify state': 'Gagal memodifikasi keadaan',
    'The number of flight date ends must be greater than the number of flight date starts': 'Jumlah akhir tanggal penerbangan harus lebih besar dari jumlah tanggal penerbangan yang dimulai',
    'Airline configuration not found': 'Konfigurasi maskapai tidak ditemukan',
    'Policy crawler log -': 'log perayap kebijakan -',
    'Wrong oh, this is an error message': 'Salah oh, ini pesan kesalahan',
    'Shop': 'Toko',
    'Store Code': 'Kode Toko',
    'Occupy space': 'Menempati ruang',
    'Pause time': 'Jeda waktu',
    'Abnormal airline code': 'Kode maskapai abnormal',
    'Exception policy code': 'Kode kebijakan pengecualian',
    'Filter Policy Code': 'Kode Kebijakan Filter',
    'Creation time/modification time': 'Waktu pembuatan / waktu modifikasi',
    'Multiple times | separated, including judgments respectively': 'Beberapa kali | terpisah, termasuk penilaian masing-masing',
    'Do not account for childrens policy code': 'Jangan memperhitungkan kode kebijakan anak',
    'Active cache interface': 'Antarmuka cache aktif',
    'Cache name': 'Cache nama',
    'Cache URL': 'URL Cache',
    'Added seat-occupying crawler configuration': 'Ditambahkan konfigurasi perayap yang menempati kursi',
    'Please fill in the active cache interface': 'Silakan isi antarmuka cache aktif',
    'Please fill in the cache name': 'Silahkan isi cache name',
    'Please fill in the cache URL': 'Silahkan isi URL cache',
    'Deleted data successfully': 'Data yang dihapus berhasil',
    'Added success Check the result later': 'Tambah sukses Cek hasilnya nanti',
    'Occupy crawler log -': 'Occupy crawler log -',
    'Payment channel configuration not found': 'Konfigurasi saluran pembayaran tidak ditemukan',
    'Please select a level': 'Silakan pilih level',
    'Module': 'Modul',
    'Event': 'Event',
    'Source': 'Sumber',
    'Title': 'Judul',
    'Operator': 'Operator',
    'Start date': 'Tanggal mulai',
    'End date': 'Tanggal akhir',
    'Clear data': 'Data yang jelas',
    'Content': 'Konten',
    'Time': 'Waktu',
    'Confirm that the data is cleared according to the query conditions?': 'Memastikan bahwa data dibersihkan sesuai dengan kondisi kueri?',
    'Start and end dates cannot be empty': 'Tanggal mulai dan berakhir tidak boleh kosong',
    'End date must be greater than or equal to start date': 'Tanggal akhir harus lebih besar dari atau sama dengan tanggal mulai',
    'Module configuration not found': 'Konfigurasi modul tidak ditemukan',
    'Event configuration not queried': 'Konfigurasi acara tidak ditanyakan',
    'Airline cannot be empty': 'Maskapai tidak bisa kosong',
    'Bar data': 'Bar data',
    'Query cache': 'Query cache',
    'Sync cache': 'Sync cache',
    'Cache key': 'Cache key',
    'Confirm sync cache?': 'Mengonfirmasi cache sync?',
    'Synchronization cache successful': 'Sinkronisasi cache berhasil',
    'Merchant Name': 'Nama Pedagang',
    'Merchant Code': 'Kode Pedagang',
    'Merchant Type': 'Tipe Pedagang',
    'Supplier': 'Supplier',
    'Buyer': 'Pembeli',
    'Open': 'Buka',
    'Close': 'Tutup',
    'Enterprise Type': 'Enterprise Type',
    'Full name of the company': 'Nama lengkap perusahaan',
    'Company abbreviation': 'Singkatan perusahaan',
    'Company Code': 'Kode Perusahaan',
    'Address': 'Alamat',
    'Contact person': 'Kontak person',
    'Contact number': 'Nomor kontak',
    'Authorization time': 'Waktu otorisasi',
    'Permission Control': 'Kontrol Izin',
    'Select date': 'Pilih tanggal',
    'Select time': 'Pilih waktu',
    'Permission': 'Seleksi izin',
    'Home': 'Rumah',
    'Please select at least one type': 'Silakan pilih setidaknya satu jenis',
    'Please select at least one level': 'Silakan pilih setidaknya satu level',
    'Please select at least one state': 'Silakan pilih setidaknya satu negara bagian',
    'Please fill in the full name of the company': 'Silahkan isi nama lengkap perusahaan',
    'Please fill in the company abbreviation': 'Silahkan isi singkatan perusahaan',
    'Please fill in the company code': 'Silahkan isi kode perusahaan',
    'Please fill in the company address': 'Silahkan isi alamat perusahaan',
    'Please fill in the contact person': 'Silahkan isi contact person',
    'Please select a date': 'Silakan pilih tanggal',
    'Please select time': 'Silahkan pilih waktu',
    'New merchant': 'Pedagang baru',
    'Agent Management': 'Manajemen Agen',
    'Add/modify merchant successfully': 'Tambah / modifikasi merchant berhasil',
    'Edit Merchant': 'Sunting Pedagang',
    'Added/modified merchant successfully!': 'Menambah / memodifikasi merchant berhasil!',
    'Deleted company data successfully': 'Data perusahaan berhasil dihapus',
    'admin': 'Operasi',
    'Merchant': 'Pedagang',
    'Real name': 'Nama asli',
    'Login name': 'Nama masuk',
    'Contact information': 'Informasi kontak',
    'Job number': 'Nomor pekerjaan',
    'Administrator': 'Administrator',
    'Role name': 'Nama peran',
    'Department Name': 'Nama Departemen',
    'Job Title': 'Job Title',
    'Mailbox': 'Kotak Surat',
    'Gender': 'Gender',
    'Reset-pw': 'Setel Ulang Kata Sandi',
    'Login must be a letter or number': 'Login harus berupa huruf atau nomor',
    'Password': 'Password',
    'Confirm password': 'Konfirmasi kata sandi',
    'Male': 'Laki-laki',
    'Female': 'Perempuan',
    'Confidentiality': 'Kerahasiaan',
    'Department': 'Departemen',
    'Please select a department': 'Silakan pilih departemen',
    'Post': 'Post',
    'Please select a position': 'Silahkan pilih posisi',
    'Character name': 'Nama karakter',
    'Please select a role': 'Silahkan pilih peran',
    'Normal': 'Normal',
    'Security Question': 'Masalah perlindungan rahasia',
    'Secret Answer': 'Jawaban Rahasia',
    'Please fill in the account number': 'Silahkan isi nomor rekening',
    'Account number must be a combination of numbers and letters': 'Nomor rekening harus kombinasi angka dan huruf',
    'Please fill in the password': 'Silahkan isi password',
    'Please fill in the password again': 'Silahkan isi password lagi',
    'The password filled in twice is inconsistent!': 'Kata sandi yang diisi dua kali tidak konsisten!',
    'Please fill in your real name': 'Silahkan isi nama aslimu',
    'Please fill in the job number': 'Silahkan isi nomor pekerjaan',
    'Please select a role name': 'Silakan pilih nama peran',
    'Please select a department name': 'Silakan pilih nama departemen',
    'Please fill in the job title': 'Silahkan isi jabatan',
    'Deleted': 'Dihapus',
    'Are you sure the reset password is 123456 ?': 'Apakah Anda yakin kata sandi reset 123456?',
    'Reset password to 123456': 'Setel ulang kata sandi ke 123456.',
    'Failed to reset password': 'Gagal reset password,',
    'Operation failed': 'Operasi gagal',
    'The mailbox format is incorrect': 'Format kotak surat salah',
    'Inconsistent password filled in twice': 'Kata sandi tidak konsisten diisi dua kali',
    'New account': 'Akun baru',
    'Edit account': 'Edit akun',
    'Agent account management': 'Manajemen akun agen'
  },
  zsCurrencyList: {
    'Country name': 'Nama negara',
    'Please enter country name': 'Silakan masukkan nama negara',
    'Currency name': 'Nama mata uang',
    'Currency symbol': 'Simbol mata uang',
    'Currency Code': 'Kode mata uang saat ini',
    'Bank of China Exchange Rate': 'Nilai Tukar Bank of China',
    'Middle Rate': 'Nilai tukar pasar menengah',
    'Custom Exchange Rate': 'Nilai Tukar Kustom',
    'Status': 'Status',
    'Update time': 'Waktu pembaruan',
    'Central Bank': 'Bank Sentral',
    'URL': 'URL'
  },
  flight: {
    'Subject to airline regulations': 'Tunduk pada peraturan maskapai',
    'Return and change': 'Kembali dan berubah',
    'Baggage Allowance': 'Tunjangan Bagasi',
    'Reimbursement voucher': 'Reimbursement voucher',
    'Reservation Instructions': 'Petunjuk Reservasi',
    'Fare': 'Dewasa',
    'Tax': 'Anak',
    'Re-search flight': 'Pencarian ulang penerbangan',
    'Passenger': 'Penumpang',
    'PassengerType': 'Tipe Penumpang',
    'Adult': 'Dewasa',
    'Age 12 and older': '12 taun lan ndhuwur',
    '2~12 years old (excluding)': '2 taun nganti 12 taun(ora kalebu)',
    'Please select passenger gender': 'Silakan pilih jenis kelamin penumpang',
    'Male': 'Laki-laki',
    'Female': 'Perempuan',
    'Last name': 'Nama keluarga',
    'First name': 'Nama (Diberikan Nama) ',
    'Nationality': 'Kebangsaan',
    'Select date of birth': 'Pilih tanggal lahir',
    'Please select ID type': 'Silahkan pilih jenis dokumen',
    'Passport': 'Paspor',
    'Hong Kong and Macau Pass': 'Hong Kong and Macau Pass',
    'Taiwan Travel Permit for Mainland Residents': 'Izin Perjalanan Taiwan untuk Penduduk Daratan',
    'Credential No': 'Nomor dokumen',
    'Select the valid period': 'Pilih masa berlaku',
    'Telephone No': 'Nomor ponsel',
    'Children': 'Anak-anak',
    'Gender': 'Gender',
    'Contact person': 'Kontak person',
    'Email for emergency contact, please fill in correctly': 'Email (untuk kontak darurat, silahkan isi dengan benar) ',
    'Next step': 'Langkah selanjutnya',
    'Order Confirmation': 'Konfirmasi Pesanan',
    'Date of birth': 'Ulang Tahun',
    'Pay': 'Pergi untuk membayar',
    'day': 'Surga',
    'hour': 'Jam',
    'minute': 'Menit',
    'seconds': 'Detik',
    'Please enter passenger last name': 'Silakan masukkan nama belakang penumpang',
    'Please enter passenger name': 'Silakan masukkan nama penumpang',
    'Please enter passenger nationality': 'Silakan masukkan kewarganegaraan penumpang',
    'Please select Passenger Document Type': 'Silakan pilih Jenis Dokumen Penumpang',
    'Please enter passenger Credential No': 'Silahkan masukkan nomor ID penumpang',
    'Please select the valid period of the passenger document': 'Silakan pilih masa berlaku dokumen penumpang',
    'Please select passenger birthday': 'Silakan pilih ulang tahun penumpang',
    'Please enter the passengers mobile phone number ': 'Silahkan masukkan nomor handphone penumpang',
    'Please enter child passenger last name': 'Silakan masukkan nama belakang penumpang anak',
    'Please enter child passenger name': 'Silakan masukkan nama penumpang anak',
    'Please select child passenger gender': 'Silakan pilih jenis kelamin penumpang anak',
    'Please enter the nationality of the child passenger': 'Silakan masukkan kewarganegaraan penumpang anak',
    'Please select Child Passenger Document Type': 'Silakan pilih Jenis Dokumen Penumpang Anak',
    'Please enter Child Passenger Credential No': 'Silahkan masukkan Nomor ID Penumpang Anak',
    'Please select the valid period of the child passenger document': 'Silakan pilih masa berlaku dokumen penumpang anak',
    'Please select Child Passenger Birthday': 'Silahkan pilih Ulang Tahun Penumpang Anak',
    'Please enter the child passenger mobile phone number': 'Silakan masukkan nomor ponsel penumpang anak',
    'FIT Booking': 'FIT Booking',
    'One way': 'One way',
    'Round trip': 'Perjalanan pulang pergi',
    'Departure': 'Keberangkatan',
    'Destination': 'Tujuan',
    'Departure date': 'Tanggal keberangkatan',
    'Return date': 'Kembali tanggal',
    'Search': 'Cari',
    'Departure city cannot be empty': 'Keberangkatan kota tidak bisa kosong',
    'Arrival city cannot be empty': 'Kota kedatangan tidak bisa kosong',
    'Please select a voyage type': 'Silahkan pilih tipe voyage',
    'Please select a departure date': 'Silakan pilih tanggal keberangkatan',
    'Please select arrival date': 'Silakan pilih tanggal kedatangan',
    'Please select the number of passengers': 'Silahkan pilih jumlah penumpang',
    'Filter': 'Filter',
    'Clear all': 'Hapus semua',
    'Direct flight': 'Langsung',
    'Transfer': 'Transit',
    'DptArrTime': 'Waktu kedatangan',
    'Am': 'Pukul {time} pagi',
    'Pm': 'Pukul {time} sore',
    'Night': 'Pukul {time} malam',
    'PriceToHigh': 'Harga termurah',
    'PriceToLow': 'Harga tetapan',
    'FlightTimeToLate': 'Berangkat(Terawal)',
    'FlightTimeToMorning': 'Berangkat(Terakhir)',
    'ElapsedTimeToLong': 'Tercepat',
    'ElapsedTimeToShort': 'Lebih lambat',
    'Airline': 'Maskapai',
    'Transit city': 'Kota transit',
    'You have enough reasons to choose us': 'Anda punya cukup alasan untuk memilih kami',
    'Service Guarantee': 'Jaminan Layanan',
    'One-to-one account manager 7 * 24 hours service': 'One-to-one account manager layanan 7 * 24 jam',
    'Ticket guarantee': 'Jaminan tiket',
    '100% ticket issued after payment': '100% tiket dikeluarkan setelah pembayaran',
    'Travel guarantee': 'Jaminan perjalanan',
    'If the passenger cannot handle the flight normally due to the ticket problem, the platform will bear the loss': 'Jika penumpang tidak dapat menangani penerbangan secara normal karena masalah tiket, platform akan menanggung kerugian',
    'Turn': 'Turn',
    'Times': 'Times',
    'SELECT': 'PILIH',
    'Class': 'Kelas',
    'Refund': 'Refund',
    'Change': 'Perubahan',
    'Price': 'Harga',
    'People': 'Orang',
    'Baby': 'Baby',
    'Avg tax-inclusive': 'Harga per orang termasuk pajak',
    'Reservation': 'Buku',
    'Flight information is empty': 'Informasi penerbangan kosong',
    'Total duration': 'Total durasi',
    'First Class': 'Kelas Satu',
    'Business Class': 'Kelas Bisnis',
    'Economy Class': 'Kelas Ekonomi',
    'Business/First Class': 'Bisnis / Kelas Kapisan',
    'Economy/Excess Class': 'Kelas Ekonomi / Super',
    'from': 'from',
    'Flight details': 'Detail',
    'go trip': 'Berangkat',
    'return trip': 'Pulang',
    'Transfer from': 'Dari {city} {time}',
    'stopover': 'Persinggahan di {city}',
    'Previous step': 'Langkah sebelumnya',
    'Please select passenger nationality': 'Silakan pilih kewarganegaraan penumpang',
    'Please select a passenger area code': 'Silakan pilih kode area penumpang',
    'Please enter contact last name': 'Silahkan masukkan nama belakang kontak',
    'Please enter contact name': 'Silahkan masukkan nama kontak',
    'Please select a contact area code': 'Silahkan pilih kode area kontak',
    'Please enter the contact mobile phone number': 'Silahkan masukkan kontak nomor handphone',
    'Please enter contact email': 'Silahkan masukkan email kontak'
  },
  refundList: {
    'Downloading, do not close or refresh the page': 'Mengunduh, jangan menutup atau menyegarkan halaman...',
    'Refund form status': 'Status perintah',
    'Refund Type': 'Jenis Kembalian',
    'Special': 'Spesial',
    'Voluntary': 'Sukarela',
    'Involuntary': 'Tidak disengaja',
    'Flight change': 'Perubahan penerbangan',
    'Refund due to illness': 'Keluar dari sakit',
    'Diversion': 'Bergantian',
    'Refactor full refund': 'Refactoring retret penuh',
    'Deny boarding': 'Tolak memuat',
    'Oversold': 'Oversold',
    'Epidemic': 'Epidemi',
    'Special event': 'Acara khusus',
    'Visa refused': 'Visa ditolak',
    'Formal full refund': 'Semua bentuk kembali',
    'Void ticket‌': 'Tiket terbengkalai',
    'Platform ticket number': 'Tiket platform',
    'Platform refund order number': 'Nomor Kembalian',
    'Flight number': 'Nomor penerbangan',
    'Passenger': 'Penumpang',
    'Start date': 'Mulai tanggal',
    'End date': 'Akhir kencan',
    'Auto refresh': 'Minuman otomatis',
    'Query': 'Pertanyaan',
    'Reset': 'Reset',
    'Refund time': 'Waktu pengembalian',
    'Abnormal refund': 'Pengembalian dana tidak normal',
    'Abnormal reject': 'Penolakan abnormal',
    'Refund passenger card has been changed': 'Kartu penumpang pengembalian dana telah diganti',
    'PNR/Route': 'Kode / Jalan-jalan',
    'Refund Fee': 'Biaya Pengembalian Dana',
    'Ticket Refund Amount': 'Umpan Pengembalian Dana',
    'Refund Type/Reason': 'Jenis Kembalian / Alasan untuk kembali',
    'Source/Latest Refund': 'Sumber pengembalian dana / waktu pengembalian dana terbaru',
    'Refund profit': 'Kembalikan keuntungan',
    'Lock single': 'Kunci tunggal',
    'Unlock': 'Membuka kunci',
    'View': 'Melihat',
    'Handle': 'Tangan',
    'Refund slip log': 'Log slip pengembalian',
    'Order number': 'Nomor pesanan',
    'Operator': 'Operator',
    'Dispatch': 'Pengiriman',
    'Account number': 'Nomor akun',
    'Cancel': 'Membatalkan',
    'Pending process': 'Proses tertunda',
    'Completed': 'Pengembalian dana selesai',
    'Failed': 'Pengembalian dana gagal',
    'Please select an account': 'Silahkan pilih akun',
    'Please select the verification type': 'Silahkan pilih tipe verifikasinya',
    'Refund remarks:': 'Komentar pengembalian dana:',
    'Financial Notes:': 'Catatan Keuangan:',
    'Copied to paste board': 'Disalin ke papan tempel',
    'The refund slip has been approved': 'Slip pengembalian dana telah disetujui',
    'Lock': 'Kunci',
    'Unlocked successful': 'Sukses tidak terkunci',
    'Unlock failed': 'Buka kunci gagal',
    'Start and end dates cannot be null': 'Tanggal mulai dan berakhir tidak bisa dibatalkan',
    'The verification end date must be greater than or equal to the start date': 'Tanggal akhir verifikasi harus lebih besar dari atau sama dengan tanggal mulai',
    'Order dispatched successfully': 'Pesanan di kirim dengan sukses',
    'Please wait': 'Mohon tunggu...',
    'Ticket Refund Application': 'Masukkan slip pengembalian dana',
    'Submit request': 'Simpan slip pengembalian dana',
    'Refund Order Information': 'Informasi formulir pengembalian dana',
    'Ticket number': 'Nomor tiket',
    'Refund order number': 'Nomor pesanan pengembalian dana',
    'Query Interface': 'Pertanyaan Antar',
    'Segment Information': 'Informasi segmen penerbangan',
    'Ticketing segment information': 'Informasi segmen tiket',
    'Segment': 'Segmen',
    'Type': 'Mengetik',
    'Status': 'Pernyataan',
    'Airlines': 'Maskapai penerbangan',
    'Itinerary': 'Itinerary',
    'Flight date': 'Tanggal penerbangan',
    'Cabin': 'Kabin',
    'Refund flight info': 'Informasi segmen penerbangan pengembalian',
    'Passenger Information': 'Informasi penumpang',
    'Original passenger info': 'Informasi Penumpang Tiket',
    'Passenger status': 'Status penumpang',
    'Passenger name': 'Nama penumpang',
    'Document number': 'Nomor dokumen',
    'Sex': 'Seks',
    'Male': 'Laki-laki',
    'Female': 'Perempuan',
    'Price': 'Harga',
    'Taxes and Fees': 'Pajak dan Biaya',
    'Total selling price': 'Total harga jual',
    'Please enter a refund fee': 'Silakan masukkan umpan pengembalian dana',
    'Please enter the refund amount': 'Silakan masukkan jumlah pengembalian dana',
    'Refund passenger info': 'Informasi penumpang pengembalian',
    'Refund Information': 'Informasi Pengembalian Dana',
    'Please select': 'Silakan pilih',
    'Reason for refund': 'Alasan pengembalian dana',
    'Please enter content': 'Silakan masukkan konten',
    'Total refund fee': 'Total pengembalian dana',
    'Total refund': 'Total pengembalian',
    'Refund flight segment cannot be empty': 'Segmen penerbangan pengembalian dana tidak dapat dikosongkan',
    'Refund passengers cannot be empty': 'Pengembalian penumpang tidak bisa dikosongkan',
    'Please enter': 'Silakan masuk',
    'Platform refund fee': 'Platform pengembalian dana',
    'Purchase refund fee': 'Biaya pengembalian dana pembelian',
    'Purchase recovery': 'Pemulihan pembelian',
    'Profit': 'Siap',
    'Please enter the total refund charge': 'Silakan masukkan total tagihan pengembalian dana',
    'Please select a refund type': 'Silakan pilih jenis pengembalian dana',
    'Please enter the total refund amount': 'Silakan masukkan jumlah pengembalian dana total',
    'Refund form submitted successfully': 'Simpan formulir pengembalian dana dengan sukses',
    'Tips': 'Tip',
    'Successfully obtained ticketing information': 'Berhasil memperoleh informasi tiket',
    'Successfully obtained refund information': 'Berhasil memperoleh informasi pengembalian dana',
    'Please enter the correct number': 'Silakan masukkan nomor yang benar',
    'Normal': 'Normal',
    'Issue tickets': 'Masalah tiket',
    'Refund': 'Menyenangkan',
    'Change book': 'Ganti buku',
    'Changed': 'Berubah',
    'Exception': 'Tidak ada',
    'Ticket refund': 'Permintaan tiket',
    'Ticket refund application': 'Aplikasi pengembalian dana',
    'Refund Details': 'Detail bentuk pengembalian dana',
    'Modification': 'Modifikasi',
    'Secondary Reason for Reject': 'Alasan Sekunder untuk Penolakan',
    'Total ticket price': 'Total harga tiket',
    'Ticket time': 'Waktu tiket',
    'Children': 'Anak-anak',
    'Operation': 'Operasi',
    'Purchase Amount': 'Beli Tante',
    'Change': 'Perubahan',
    'Ticket number verification': 'Verifikasi nomor tiket',
    'Refund rejected': 'Pengembalian dana ditolak',
    'Unlock and handle': 'Buka kunci dan tangan',
    'Airline refund rules': 'Aturan pengembalian dana maskapai',
    'Please enter the refund order number': 'Silakan masukkan nomor pesanan pengembalian uang',
    'Total refund amount': 'Jumlah pengembalian dana total',
    'Ticket Remarks': 'Pameran Tiket',
    'Save refund notes': 'Simpan pengembalian uang tidak',
    'Save Ticket Notes': 'Simpan Tiket Tidak',
    'Save financial notes': 'Simpan catatan keuangan',
    'Order log': 'Catatan pesanan',
    'Edit Products': 'Edit Produk',
    'Policy Type': 'Jenis Kebijakan',
    'Clearance Products': 'Produk Pembersihan',
    'Business travel products': 'Produk perjalanan bisnis',
    'Transit': 'Transit',
    'Transit products': 'Produk transit',
    'Charter airline': 'Maskapai penerbangan charter',
    'Cut position': 'Potong posisi',
    'Airline VIP': 'VIP Maskapai',
    'General Policy': 'Polisi Umum',
    'Prepayment Policy': 'Polisi Prabayar',
    'Team Policy': 'Tim Polisi',
    'Special Policy': 'Polisi Khusus',
    'K-bit policy': 'Polisi B-bit',
    'Fixed price': 'Harga tetap',
    'Applicable spaces': 'Ruang yang berlaku',
    'Directly connected': 'Terhubung langsung',
    'Type of sale': 'Jenis penjualan',
    'Solid hatch': 'Ttas padat',
    'See hatch': 'Lihat topi',
    'Policy code format': 'Formulir kode kebijakan',
    'None': 'Tidak ada',
    'Additional airline code': 'Kode maskapai tambahan',
    'Additional delivery time (time and space)': 'Waktu pengiriman tambahan (ruang dan waktu)',
    'Delivery Type': 'Tipe Pengiriman',
    'Total + increment': 'Total + peningkatan',
    'Full quantity only': 'Hanya dalam jumlah penuh',
    'Increment only': 'Hanya tambahan',
    'Delete policy on increment': 'Hapus kebijakan tentang penambahan',
    'Yes': 'Ya',
    'No': 'Tidak',
    'Delete type': 'Hapus tipe',
    'By policy code': 'Dengan kode kebijakan',
    'By delivery time': 'Pada waktu pengiriman',
    'Reimbursement Type': 'Penggantian Jenis',
    'Invoice': 'Faktur',
    'Itinerary + Difference Invoice': 'Itinerary + Perbedaan Faktur',
    'Office number': 'Nomor kantor',
    'IATA number': 'Nomor IATA',
    'Drop in superior cabinet': 'Jatuhkan di kabin superior',
    'Reservation': 'Reservasi',
    'Machine Wine Package': 'Paket Anggur Mesin',
    'Sharing': 'Berbagi',
    'Support stopping': 'Dukungan berhenti',
    'Support children': 'Dukung anak-anak',
    'Tariff rules': 'Aturan tarif',
    'Return and Change ID': 'Kembali dan Ubah ID',
    'Place a Fare': 'Tempatkan harga par',
    'Price Type': 'Tipe Harga',
    'Official website price': 'Harga situs web resmi',
    'Settlement price': 'Harga penyelesaian',
    'Specify Fare': 'Tentukan harga par',
    'Y cabin discount': 'Y kabin diskon',
    'Special Ticket Instructions': 'Petunjuk Tiket Khusus',
    'Minimum age limit': 'Batasan usia minimum',
    'Maximum age limit': 'Batas usia maksimal',
    'Refund Review': 'Tinjauan Pengembalian Dana',
    'Audit Results': 'Hasil Audit',
    'Do not pass': 'Jangan lewat',
    'Please select a reason for rejection': 'Silakan pilih alasan penolakan',
    'Provide involuntary supporting materials': 'Memberikan materi pendukung yang tidak disengaja',
    'Cancel Retention Change': 'Batalkan Perubahan Retensi',
    'Ticket number is not OPEN status': 'Nomor tiket bukan status BUKA',
    'The policy does not match and cannot be refunded': 'Kebijakan tidak cocok dan tidak dapat dikembalikan',
    'Exchange for a refund': 'Pertukaran untuk pengembalian dana',
    'Partial refund': 'Pengembalian sebagian',
    'Other': 'Lainnya',
    'Secondary Reason for Rejection': 'Alasan Sekunder Penolakan',
    'Please select a secondary reason for rejection': 'Silakan pilih alasan sekunder untuk penolakan',
    'Insufficient materials for involuntary refunds': 'Bahan yang tidak cukup untuk pengembalian dana yang tidak disengaja',
    'The content of the involuntary refund materials': 'Isi materi pengembalian dana yang tidak disengaja',
    'The supplier contacts the airline to change the visa and needs a refund from the airline': 'Pemasok menghubungi maskapai untuk mengubah visa dan membutuhkan pengembalian dana dari maskapai.',
    'The guest contacts the airline to change the booking and needs a refund from the airline': 'Tamu menghubungi maskapai untuk mengubah pemesanan dan membutuhkan pengembalian dana dari maskapai.',
    'The changed ticket number is required': 'Nomor tiket yang diubah diperlukan.',
    'Does not comply with special policies': 'Tidak mematuhi polisi khusus',
    'Does not meet the rules of aeronautical change': 'Tidak memenuhi aturan perubahan penerbangan',
    'Protection flight confirmed': 'Penerbangan perlindungan dikonfirmasi',
    'Ticket checked in': 'Tiket dicentang',
    'Airline has retreated': 'Maskapai telah berulang',
    'Need to unhook': 'Perlu melepaskan',
    'Follow the used segment ticket number USED': 'Ikuti nomor tiket segmen bekas MENGGUNAKAN',
    'Can t refund a single paragraph ': 'Tidak dapat mengembalikan satu paragraf pun ',
    'Wrong payment amount': 'Jumlah pembayaran salah',
    'No refund policy needs to be cancelled and changed': 'Tidak ada kebijakan pengembalian uang yang perlu dibatalkan dan diubah',
    'Itinerary to be voided': 'Rencana perjalanan untuk dipilih',
    'Ctrip asks to refuse an order': 'Ctrip meminta untuk menolak perintah',
    'Vulnerable ticket': 'Tiket rentan',
    'Associated child and infant tickets cannot be refundable single': 'Tiket anak dan bayi terkait tidak dapat dikembalikan tunggal',
    'Only vouchers can be refunded': 'Hanya voucher yang bisa dikembalikan',
    'Charter flights are non-refundable': 'Penerbangan charter tidak dapat dikembalikan.',
    'Ticket has expirated': 'Tiket telah kedaluwarsa',
    'Ticket desk collapse/airline bankruptcy': 'Meja tiket runtuh / kebangkrutan maskapai',
    'Remarks': 'Luar biasa',
    'Affirmation': 'Afirmasi',
    'Turn to an appeal': 'Beralih ke banding',
    'Type of appeal': 'Jenis banding',
    'Platform Refund': 'Platform Ulang',
    'Quality inspection': 'Pemeriksaan kualitas',
    'Our company appeals': 'Perusahaan kami mengajukan banding',
    'Appeal Amount': 'Dukungan Banding',
    'Appeal Remarks': 'Pameran Banding',
    'Attachments': 'Lampiran',
    'Click to upload': 'Klik untuk mengunggah',
    'Save': 'Simpan',
    'Abnormal verification': 'Verifikasi abnormal',
    'Please enter the purchase refund fee': 'Silakan masukkan biaya pengembalian dana pembelian',
    'Please enter purchase rebate': 'Silakan masukkan rebat pembelian',
    'Rejected verification': 'Verifikasi ditolak.',
    'Reason for rejection': 'Alasan penolakan',
    'Has the ticket been refunded': 'Apakah tiketnya sudah dikembalikan',
    'Please enter airline refund charge': 'Silakan masukkan biaya pengembalian dana maskapai',
    'Please enter airline return': 'Silakan masuk maskapai kembali',
    'Exception Note': 'Catatan Pengecualian',
    'Submit': 'Tunduk',
    'Verification channel': 'Saluran verifikasi',
    'Where to go': 'Ke mana harus pergi',
    'Departure airport code': 'Kode bandara keberangkatan',
    'Arrival airport code': 'Kode bandara kedatangan',
    'Departure time': 'Waktu keberangkatan',
    'Ticket number status': 'Statistik nomor tiket',
    'Fare price': 'Harga tarif',
    'China Eastern Airlines NDC Refund': 'China Eastern Airlines NDC Kembali',
    'Is it refundable?': 'Apakah itu dapat dikembalikan?',
    'Refundable': 'Dapat dikembalikan',
    'Non-refundable': 'Tidak dapat dikembalikan',
    'Non-refundable cause': 'Penyebab yang tidak dapat dikembalikan',
    'Refund confirmation': 'Konfirmasi pengembalian dana',
    'Adult cabin': 'Kelas dewasa',
    'Children s Cabin ': 'Kabin Anak ',
    'Select flight date': 'Pilih tanggal penerbangan',
    'Select departure time': 'Pilih waktu keberangkatan',
    'Arrival time': 'Waktu kedatangan',
    'Select time of arrival': 'Pilih waktu kedatangan',
    'Modify the latest refund time': 'Ubah waktu pengembalian dana terbaru',
    'Latest refund time': 'Waktu pengembalian dana terbaru',
    'Please select profit type': 'Silahkan pilih tipe keuntungan',
    'Airline cannot be empty': 'Maskapai tidak bisa kosong',
    'Departure airport code cannot be empty': 'Kode bandara keberangkatan tidak bisa kosong',
    'Arrival airport code cannot be empty': 'Kode bandara kedatangan tidak bisa dibatalkan',
    'Flight number cannot be empty': 'Nomor penerbangan tidak bisa dikosongkan',
    'Adult cabin cannot be empty': 'Kelas orang dewasa tidak bisa dikosongkan',
    'Children s cabin cannot be empty ': 'Kabin anak tidak bisa dikosongkan ',
    'Please select a flight date': 'Silakan pilih tanggal penerbangan',
    'Please select departure time': 'Silahkan pilih waktu keberangkatan',
    'Please select an arrival time': 'Silahkan pilih waktu kedatangan',
    'The latest refund time cannot be empty': 'Waktu pengembalian dana terbaru tidak dapat dikosongkan',
    'Please select the refund form status': 'Silakan pilih statistik formulir pengembalian dana',
    'Please select appeal type': 'Silakan pilih tipe banding',
    'Please select a passenger': 'Silakan pilih penumpang',
    'Please fill in the appeal amount': 'Silakan isi jumlah banding',
    'Please fill in the remarks': 'Silakan isi komentar',
    'Please fill in the reason for rejection': 'Tolong isi alasan penolakan',
    'Please select whether the ticket has been refunded': 'Silakan pilih apakah tiket telah dikembalikan',
    'Please fill in the exception notes': 'Silakan isi pengecualian notes',
    'Voyage': 'Pelayaran',
    'Segment back': 'Segmen kembali',
    'Material return': 'Bahan kembali',
    'Voluntary refund': 'Pengembalian dana sukarela',
    'Modify the latest refund time successfully': 'Ubah waktu pengembalian dana terbaru dengan sukses',
    'Modified segment information successfully': 'Informasi segmen yang dimodifikasi berhasil',
    'Switched off': 'Dialihkan',
    'Ticket used': 'Tiket digunakan',
    'Passenger is boarding': 'Penumpang sedang naik',
    'Checking in': 'Memeriksa di',
    'Ticket Valid': 'Validasi Tiket',
    'The ticket has been exchanged for a paper ticket': 'Tiket sudah ditukar dengan tiket kertas',
    'Ticket has been refunded': 'Tiket telah dikembalikan',
    'Ticket has been suspended': 'Tiket telah ditangguhkan',
    'Void': 'Suara',
    'The format of the ticket number is wrong, it can only be 6, 7, and 13': 'Format nomor tiketnya salah, hanya bisa 6, 7, dan 13',
    'Deleted attachment successful': 'Dihapus lampiran berhasil',
    'Failed to delete attachment, reason:': 'Gagal menghapus lampiran, alasan:',
    'Exceptionally successful verification': 'Verifikasi yang sangat sukses',
    'The verification was rejected successfully': 'Verifikasi berhasil ditolak.',
    'The verification failed due to:': 'Verifikasi gagal karena:',
    'Airline Refund Fee': 'Biaya Pengembalian Dana Maskapai',
    'Airline returns': 'Maskapai kembali',
    'The abnormal operation of the refund was successful': 'Operasi abnormal pengembalian dana berhasil',
    'The abnormal operation of refund failed. Reason:': 'Operasi pengembalian dana yang tidak normal gagal. Alasan:',
    'Abnormal rejection operation successful': 'Operasi penolakan abnormal berhasil',
    'Abnormal rejection operation failed, reason:': 'Operasi penolakan abnormal gagal, alasan:',
    'Please select the passenger who needs to refund the ticket': 'Silakan pilih penumpang yang perlu mengembalikan tiket',
    'Select the passenger, please enter the refund fee': 'Pilih penumpang, silakan masukkan biaya pengembalian dana',
    'Select the passenger, please enter the refund amount': 'Pilih penumpang, silakan masukkan jumlah pengembalian uang',
    'Please select the flight segment that needs to be refunded': 'Silakan pilih segmen penerbangan yang perlu dikembalikan',
    'Please enter the reason for the refund': 'Silakan masukkan alasan pengembalian dana',
    'Please enter a refund rates': 'Silakan masukkan tingkat pengembalian dana',
    'Please enter refund and return': 'Silakan masukkan pengembalian dana dan pengembalian',
    'Please enter refund profit': 'Silakan masukkan pengembalian dana keuntungan',
    'Submit refund successfully': 'Kirim pengembalian dana berhasil',
    'Modified the refund form successfully': 'Berhasil memodifikasi formulir pengembalian dana',
    'Confirm the refund form status to change': 'Konfirmasi status formulir pengembalian uang untuk berubah',
    'Is it?': 'Apakah itu?',
    'Modified the status of the refund form successfully': 'Modifikasi status formulir pengembalian dana berhasil',
    'Failed to modify the status of the refund form. Reason:': 'Gagal mengubah status formulir pengembalian dana. Alasan:',
    'Modify the refund form status and the order is successful': 'Ubah status formulir pengembalian dana dan pesanan berhasil',
    'The order failed to modify the status of the refund form. Reason:': 'Pesanan gagal mengubah status formulir pengembalian dana. Alasan:',
    'Modify the refund status successfully': 'Ubah status pengembalian dana dengan sukses',
    'Failed to modify the refund status, reason:': 'Gagal mengubah status pengembalian dana, alasan:',
    'Are you sure you want to return the order?': 'Apa kamu yakin ingin mengembalikan pesanannya?',
    'Are you sure the status of the refund order is changed to refund and cancel?': 'Apakah Anda yakin status pesanan pengembalian uang diubah menjadi pengembalian uang dan dibatalkan?',
    'Good to go': 'Bagus untuk pergi',
    'The refund review failed. Reason:': 'Peninjauan pengembalian dana gagal. Alasan:',
    'Refund completed successfully': 'Pengembalian dana selesai dengan sukses',
    'Refund completion failed, reason:': 'Penyelesaian pengembalian dana gagal, alasan:',
    'Confirm that the refund is complete?': 'Konfirmasi bahwa pengembalian dana sudah selesai?',
    'Confirm review confirmation?': 'Konfirmasi konfirmasi ulasan?',
    'Review confirmed successful': 'Review dikonfirmasi berhasil',
    'Review confirmation failed, reason:': 'Konfirmasi ulasan gagal, alasan:',
    'Confirm the verification of the refund?': 'Konfirmasi verifikasi pengembalian dana?',
    'Successful verification of refund': 'Verifikasi pengembalian dana yang berhasil',
    'The verification of the refund failed. Reason:': 'Verifikasi pengembalian dana gagal. Alasan:',
    'Please enter the platform refund verification amount': 'Silakan masukkan jumlah verifikasi pengembalian dana platform',
    'Please enter the platform refund verification time': 'Silakan masukkan waktu verifikasi pengembalian dana platform',
    'Save the platform refund and verify the account successfully': 'Simpan pengembalian dana platform dan verifikasi akun dengan sukses',
    'The save platform refund verification failed. Reason:': 'Verifikasi pengembalian dana platform simpan gagal. Alasan:',
    'Please enter the purchase refund verification amount': 'Silakan masukkan jumlah verifikasi pengembalian dana pembelian',
    'Please enter the time of the purchase refund bill': 'Silakan masukkan waktu tagihan pengembalian dana pembelian',
    'Save the purchase receipt and verify the account successfully': 'Simpan tanda terima pembelian dan verifikasi akun dengan sukses',
    'Failed to save the purchase receipt for verification. Reason:': 'Gagal menyimpan tanda terima pembelian untuk verifikasi. Alasan:',
    'Delete the platform refund and verify the account successfully': 'Hapus pengembalian dana platform dan verifikasi akun dengan sukses',
    'Delete platform refund verification failed, reason:': 'Hapus verifikasi pengembalian dana platform gagal, alasan:',
    'Delete the purchase receipt and verify the account successfully': 'Hapus tanda terima pembelian dan verifikasi akun dengan sukses',
    'Delete the purchase receipt verification failed. Reason:': 'Menghapus verifikasi penerimaan pembelian gagal. Alasan:',
    'The platform refund amount and time cannot be empty!': 'Jumlah dan waktu pengembalian platform tidak boleh kosong!',
    'The purchase refund amount and time cannot be empty!': 'Jumlah dan waktu pengembalian pembelian tidak boleh kosong!',
    'Settlement was abnormally successful': 'Penyelesaian sukses secara tidak normal',
    'Settlement failed abnormally, reason:': 'Penyelesaian gagal secara tidak normal, alasan:',
    'Settlement exception handled successfully': 'Pengecualian penyelesaian ditangani dengan sukses',
    'The settlement exception has been handled and failed. Reason:': 'Pengecualian penyelesaian telah ditangani dan gagal. Alasan:',
    'The refund amount and time cannot be empty!': 'Jumlah dan waktu pengembalian uang tidak boleh kosong!',
    'Payment successful': 'Pembayaran berhasil',
    'The refund failed. Reason:': 'Pengembalian dana gagal. Alasan:',
    'Refund successful': 'Pengembalian dana berhasil',
    'Refund failed, reason:': 'Pengembalian dana gagal, alasan:',
    'Are you sure you want to close the current page?': 'Apa kamu yakin ingin menutup halaman saat ini?',
    'Are you sure to unlock and close?': 'Apakah kamu yakin untuk membuka dan menutup?',
    'Unlocked and processed successfully': 'Membuka dan memproses dengan sukses',
    'Modify the remarks form successfully': 'Ubah komentar pada formulir pengembalian dana dengan sukses',
    'Failed to modify the remarks on the refund form. Reason:': 'Gagal mengubah pernyataan pada formulir pengembalian dana. Alasan:',
    'The remarks on the refund form cannot be empty!': 'Gagal mengubah pernyataan pada formulir pengembalian dana. Alasan: Pernyataan pada formulir pengembalian uang tidak bisa kosong!',
    'Modify the ticket and note successfully': 'Ubah tiket dan catat dengan sukses',
    'Failed to modify the remarks on the ticket. Reason:': 'Gagal mengubah pernyataan di tiket. Alasan:',
    'Failed to modify the ticketing remarks. Reason: The ticketing remarks cannot be empty!': 'Gagal mengubah komentar tiket. Alasan: Ucapan tiket tidak bisa kosong!',
    'Modified Financial Remarks Successfully': 'Modifikasi Keterangan Keuangan Berhasil',
    'Failed to modify financial remarks, reason:': 'Gagal mengubah pernyataan keuangan, alasan:',
    'Failed to modify financial remarks. Reason: Financial remarks cannot be empty!': 'Gagal mengubah komentar keuangan. Alasan: Ucapan keuangan tidak bisa kosong!',
    'Product information is empty': 'Informasi produk kosong',
    'China Eastern Airlines NDC refund successfully': 'China Eastern Airlines NDC mengembalikan uang dengan sukses',
    'China Eastern Airlines NDC refund failed, reason:': 'Pengembalian dana NDC China Eastern Airlines gagal, alasan:',
    'Parameter error, please resubmit': 'Parameter error, silakan kirim ulang.',
    'Normal refund': 'Pengembalian dana normal',
    'Repeat/Cancel Refund': 'Ulangi / Batalkan Pengembalian Uang',
    'Special operation refund': 'Pengembalian dana operasi khusus',
    'Refund Reissue': 'Pengembalian Dana Reissue',
    'No refund reminder time set': 'Tidak ada pengaturan waktu pengingat pengembalian uang',
    'After flight': 'Setelah penerbangan',
    'Confirm': 'Konfirmasi'
  },
  change: {
    'Pending review': 'Untuk diaudit',
    'Pending ticket issuance': 'Ubah aplikasi',
    'Pending payment': 'Pembayaran tertunda',
    'Completed': 'Perubahan selesai',
    'Exchange Status': 'Status perintah',
    'Exchange Type': 'Ganti tipe',
    'Ticket number': 'Nomor tiket',
    'Exchange No': 'Ubah nomor pesanan',
    'Original PNR': 'PNR asli',
    'Flight number': 'Nomor penerbangan',
    'Passenger': 'Penumpang',
    'Document number': 'Nomor dokumen',
    'Change Start': 'Perubahan tanggal mulai',
    'Change End': 'Ubah tanggal akhir',
    'Auto refresh': 'Minuman otomatis',
    'Query': 'Pertanyaan',
    'Reset': 'Reset',
    'Exchange Time': 'Ubah waktu',
    'New ticket number': 'Nomor tiket baru',
    'Latest Exchange': 'Waktu perubahan terbaru',
    'Change flight information': 'Ubah informasi penerbangan',
    'Exchange Type/Reason': 'Ubah Jenis / Alasan untuk Perubahan',
    'Exchange Amount': 'Jumlah Perubahan',
    'Lock single': 'Kunci tunggal',
    'Unlock': 'Membuka kunci',
    'View': 'Melihat',
    'Handle': 'Tangan',
    'Go to pay': 'Pergi ke pembayaran',
    'Change the signing log': 'Ubah catatan penandatanganan',
    'Order number': 'Nomor pesanan',
    'Operator': 'Operator',
    'Dispatch': 'Pengiriman',
    'Account number': 'Nomor akun',
    'Cancel': 'Membatalkan',
    'Please select the verification type': 'Silahkan pilih tipe verifikasinya',
    'Please select an account': 'Silahkan pilih akun',
    'Unknown': 'Tidak diketahui',
    'Voluntary': 'Sukarela',
    'Involuntary': 'Tidak disengaja',
    'Failed': 'Perubahan gagal',
    'Copied to paste board': 'Disalin ke papan tempel',
    'The order has been changed': 'Urutannya telah diubah.',
    'Lock': 'Kunci',
    'Unlocked successful': 'Sukses tidak terkunci',
    'Unlock failed': 'Buka kunci gagal!',
    'Start and end dates cannot be null': 'Tanggal mulai dan berakhir tidak bisa dibatalkan',
    'The verification end date must be greater than or equal to the start date': 'Tanggal akhir verifikasi harus lebih besar dari atau sama dengan tanggal mulai',
    'Inquire about abnormal employee dispatch orders': 'Tanyakan tentang pesanan pengiriman karyawan yang tidak normal.',
    'Change details': 'Ubah detail',
    'Exchange Order Information': 'Ubah informasi penandatanganan',
    'Please select': 'Silakan pilih',
    'Change PNR': 'Ganti PNR',
    'Modification': 'Modifikasi',
    'Segment Information': 'Informasi segmen penerbangan',
    'Original flight info': 'Informasi segmen penerbangan asli',
    'Segment': 'Segmen',
    'Type': 'Mengetik',
    'Status': 'Pernyataan',
    'Itinerary': 'Itinerary',
    'Flight date': 'Tanggal penerbangan',
    'Cabin': 'Kabin',
    'Adult': 'Dewasa',
    'Children': 'Anak-anak',
    'Operation': 'Operasi',
    'Exchanged flight info': 'Informasi segmen penerbangan baru',
    'Passenger Information': 'Informasi penumpang',
    'Change method': 'Perubahan metode',
    'Not changed': 'Tidak berubah',
    'Normal change': 'Berubah secara normal',
    'Special change': 'Perubahan khusus',
    'Refund return': 'Pengembalian dana kembali',
    'Passenger name': 'Nama penumpang',
    'Price': 'Harga',
    'Taxes and Fees': 'Pajak dan Biaya',
    'Total selling price': 'Total harga jual',
    'Purchase Amount': 'Beli Tante',
    'Original PNR/New PNR': 'Asli PNR / PNR Baru',
    'Please enter a new PNR': 'Silahkan masukkan PNR baru',
    'Original ticket number/new ticket number': 'Nomor tiket asli / nomor tiket baru',
    'Please enter a new ticket number': 'Silakan masukkan nomor tiket baru',
    'Rescheduling Fee': 'Biaya penjadwalan ulang',
    'Please enter rescheduling charge': 'Silakan masukkan biaya penjadwalan ulang',
    'Fare difference': 'Biaya peningkatan',
    'Please enter the fare difference': 'Silahkan masukkan biaya upgrade',
    'Profit': 'Siap',
    'Please enter purchase rebate': 'Silakan masukkan rebat pembelian',
    'Save the change': 'Simpan urutan perubahan',
    'Change Review': 'Perubahan Ulasan',
    'Refuse to change': 'Perubahan Ditolak',
    'Change Information': 'Ubah informasi',
    'Please enter the order number': 'Silahkan masukkan nomor pesanan',
    'Reason for change': 'Alasan untuk perubahan',
    'Total Rescheduling Fee': 'Total biaya penjadwalan ulang',
    'Total fare difference': 'Total biaya upgrade',
    'Change the amount receivable': 'Ubah jumlah penerima',
    'Change the total settlement price': 'Ubah total harga penyelesaian',
    'After adding the purchase record, the payment amount is automatically assigned to this field': 'Setelah menambahkan catatan pembelian, jumlah pembayaran secara otomatis ditugaskan ke lapangan ini',
    'Please enter content': 'Silakan masukkan konten',
    'Change total profit': 'Ubah total keuntungan',
    'Exchange Remarks': 'Perubahan Tidak',
    'Save Exchange Remarks': 'Simpan Perubahan Tidak',
    'Order log': 'Catatan pesanan',
    'Please select a passenger': 'Silakan pilih penumpang',
    'Procurement channels': 'Saluran pengadaan',
    'Please select a purchasing channel': 'Silakan pilih saluran pembelian',
    'Payment Channels': 'Saluran Pembayaran',
    'Please select a payment channel': 'Silahkan pilih saluran pembayaran',
    'Please select a type': 'Silahkan pilih tipe',
    'Expenditure': 'Pengeluaran',
    'Income': 'Masuk',
    'Purchase space': 'Beli ruang',
    'Purchase order number': 'Nomor pesanan pembelian',
    'Purchase account': 'Rekening pembelian',
    'Purchase Password': 'Beli Kata Sandi',
    'Payment Password': 'Kata Sandi Pembayaran',
    'Transaction No': 'Nomor seri transaksi',
    'Purchase Fare': 'Beli harga par',
    'Payment Amount': 'Mode Pembayaran',
    'Offer Type': 'Tawarkan Jenis',
    'Please select offer type': 'Silakan pilih jenis penawaran',
    'Red Packet': 'Paket Merah',
    'Coupon': 'Pasangan',
    'Stored value card': 'Kartu nilai yang tersimpan',
    'Integral': 'Integral',
    'Discount Amount': 'Tantangan Diskon',
    'Offer logo': 'Menawarkan cinta',
    'Purchase Remarks': 'Pameran Pembelian',
    'Agency Fee': 'Biaya Agensi',
    'Agency rates': 'Tingkat agensi',
    'Save': 'Simpan',
    'Product name': 'Nama produk',
    'Policy Type': 'Jenis Kebijakan',
    'Clearance Products': 'Produk Pembersihan',
    'Business travel products': 'Produk perjalanan bisnis',
    'Transit': 'Transit',
    'Transit products': 'Produk transit',
    'Charter airline': 'Maskapai penerbangan charter',
    'Cut position': 'Potong posisi',
    'Airline VIP': 'VIP Maskapai',
    'Special': 'Spesial',
    'General Policy': 'Polisi Umum',
    'Prepayment Policy': 'Polisi Prabayar',
    'Team Policy': 'Tim Polisi',
    'Special Policy': 'Polisi Khusus',
    'K-bit policy': 'Polisi B-bit',
    'Fixed price': 'Harga tetap',
    'Applicable spaces': 'Ruang yang berlaku',
    'Directly connected': 'Terhubung langsung',
    'Type of sale': 'Jenis penjualan',
    'Solid hatch': 'Ttas padat',
    'See hatch': 'Lihat topi',
    'Policy code': 'Kode kebijakan',
    'Policy code format': 'Formulir kode kebijakan',
    'None': 'Tidak ada',
    'Additional airline code': 'Kode maskapai tambahan',
    'Additional delivery time (time and space)': 'Waktu pengiriman tambahan (ruang dan waktu)',
    'Delivery Type': 'Tipe Pengiriman',
    'Total + increment': 'Total + peningkatan',
    'Full quantity only': 'Hanya dalam jumlah penuh',
    'Increment only': 'Hanya tambahan',
    'Delete policy on increment': 'Hapus kebijakan tentang penambahan',
    'Yes': 'Ya',
    'No': 'Tidak',
    'Delete type': 'Hapus tipe',
    'By policy code': 'Dengan kode kebijakan',
    'By delivery time': 'Pada waktu pengiriman',
    'Reimbursement Type': 'Penggantian Jenis',
    'Invoice': 'Faktur',
    'Itinerary + Difference Invoice': 'Itinerary + Perbedaan Faktur',
    'Office number': 'Nomor kantor',
    'IATA number': 'Nomor IATA',
    'Drop in superior cabinet': 'Jatuhkan di kabin superior',
    'Reservation': 'Reservasi',
    'Machine Wine Package': 'Paket Anggur Mesin',
    'Share': 'Bagikan',
    'Support stopping': 'Dukungan berhenti',
    'Support children': 'Dukung anak-anak',
    'Tariff rules': 'Aturan tarif',
    'Return and Change ID': 'Kembali dan Ubah ID',
    'Place a Fare': 'Tempatkan harga par',
    'Price Type': 'Tipe Harga',
    'Official website price': 'Harga situs web resmi',
    'Settlement price': 'Harga penyelesaian',
    'Specify Fare': 'Tentukan harga par',
    'Y cabin discount': 'Y kabin diskon',
    'Special Ticket Instructions': 'Petunjuk Tiket Khusus',
    'Minimum age limit': 'Batasan usia minimum',
    'Maximum age limit': 'Batas usia maksimal',
    'Turn to an appeal': 'Beralih ke banding',
    'Type of appeal': 'Jenis banding',
    'Platform Refund': 'Platform Ulang',
    'Quality inspection': 'Pemeriksaan kualitas',
    'Our company appeals': 'Perusahaan kami mengajukan banding',
    'Appeal Amount': 'Dukungan Banding',
    'Appeal Remarks': 'Pameran Banding',
    'Attachments': 'Lampiran',
    'Click to upload': 'Klik untuk mengunggah',
    'Change Cancel': 'Perubahan Membatalkan',
    'Reject reason': 'Alasan pembatalan',
    'Affirmation': 'Afirmasi',
    'Airlines': 'Maskapai penerbangan',
    'Departure airport code': 'Kode bandara keberangkatan',
    'Arrival airport code': 'Kode bandara kedatangan',
    'Adult cabin': 'Kelas dewasa',
    'Children s Cabin': 'Kabin Anak',
    'Select flight date': 'Pilih tanggal penerbangan',
    'Departure time': 'Waktu keberangkatan',
    'Select departure time': 'Pilih waktu keberangkatan',
    'Arrival time': 'Waktu kedatangan',
    'Select time of arrival': 'Pilih waktu kedatangan',
    'Reason for rejection': 'Alasan penolakan',
    'Verification channel': 'Saluran verifikasi',
    'Where to go': 'Ke mana harus pergi',
    'Ticket number status': 'Statistik nomor tiket',
    'Fare price': 'Harga tarif',
    'Modify the latest change time': 'Ubah waktu perubahan terbaru',
    'Purchase channel cannot be empty': 'Saluran pembelian tidak dapat dikosongkan',
    'Type cannot be null': 'Tipe tidak bisa dibatalkan',
    'Purchase order number cannot be null': 'Nomor pesanan pembelian tidak dapat dibatalkan',
    'The transaction serial number cannot be null': 'Nomor seri transaksi tidak bisa dibatalkan',
    'Payment amount cannot be empty': 'Jumlah pembayaran tidak dapat dikosongkan',
    'The discount amount cannot be empty, it can be 0': 'Jumlah diskon tidak bisa kosong, bisa 0',
    'Please select a refund method': 'Silakan pilih metode pengembalian dana',
    'Please fill in the reason for rejection': 'Tolong isi alasan penolakan',
    'Please select appeal type': 'Silakan pilih tipe banding',
    'Please fill in the appeal amount': 'Silakan isi jumlah banding',
    'Airline cannot be empty': 'Maskapai tidak bisa kosong',
    'Departure airport code cannot be empty': 'Kode bandara keberangkatan tidak bisa kosong',
    'Arrival airport code cannot be empty': 'Kode bandara kedatangan tidak bisa dibatalkan',
    'Flight number cannot be empty': 'Nomor penerbangan tidak bisa dikosongkan',
    'Adult cabin cannot be empty': 'Kelas orang dewasa tidak bisa dikosongkan',
    'Children s cabin cannot be empty': 'Kabin anak tidak bisa dikosongkan',
    'Please select a flight date': 'Silakan pilih tanggal penerbangan',
    'Please select departure time': 'Silahkan pilih waktu keberangkatan',
    'Please select an arrival time': 'Silahkan pilih waktu kedatangan',
    'Please select the latest change time': 'Silahkan pilih waktu perubahan terbaru',
    'Modify the latest change time successfully': 'Ubah waktu perubahan terbaru dengan sukses',
    'Success~': 'Sukses ~',
    'Please enter the correct number': 'Silakan masukkan nomor yang benar',
    'Are you sure you want to close the current page?': 'Apa kamu yakin ingin menutup halaman saat ini?',
    'Tips': 'Tip',
    'Are you sure to unlock and close?': 'Apakah kamu yakin untuk membuka dan menutup?',
    'Flight number cannot be less than three': 'Nomor penerbangan tidak boleh kurang dari tiga',
    'Departure airport code must be three digitals': 'Kode bandara keberangkatan harus tiga digital',
    'Arrival airport code must be three digitals': 'Kode bandara kedatangan harus tiga digital',
    'Selected passengers and flight segments have been changed, please select again': 'Penumpang terpilih dan segmen penerbangan telah diubah, silakan pilih lagi!',
    'New PNR': 'PNR baru',
    'Platform rescheduling fee': 'Platform penjadwalan ulang',
    'Platform Upgrade Fee': 'Biaya Peningkatan Platform',
    'Purchase Rescheduling Fee': 'Biaya Penjadwalan Ulang Pembelian',
    'Purchase fare difference': 'Biaya upgrade pembelian',
    'Purchase refund fee': 'Biaya pengembalian dana pembelian',
    'Purchase recovery': 'Pemulihan pembelian',
    'Please enter the total platform rescheduling fee': 'Silakan masukkan total biaya penjadwalan ulang platform',
    'Please enter the total platform fare difference': 'Silakan masukkan biaya peningkatan platform total',
    'Please enter the change amount receivable': 'Silahkan masukkan piutang jumlah kembalian',
    'Please enter the total settlement price': 'Silakan masukkan total harga penyelesaian',
    'Please enter the total profit of the change': 'Silakan masukkan total keuntungan dari perubahan',
    'Change the signature and save it successfully': 'Ganti tanda tangan dan simpan dengan sukses',
    'Confirm that the review is complete?': 'Konfirmasi bahwa ulasan sudah selesai?',
    'Submit': 'Tunduk',
    'Review completed successfully': 'Review selesai dengan sukses',
    'Audit completion failed, reason:': 'Penyelesaian audit gagal, alasan:',
    'Change rejected successfully': 'Perubahan ditolak dengan sukses',
    'Change rejection failed, reason:': 'Perubahan penolakan gagal, alasan:',
    'The platform refund amount and time cannot be empty': 'Jumlah dan waktu pengembalian platform tidak boleh kosong!',
    'Settlement was abnormally successful': 'Penyelesaian sukses secara tidak normal',
    'Settlement failed abnormally, reason:': 'Penyelesaian gagal secara tidak normal, alasan:',
    'Settlement exception handled successfully': 'Pengecualian penyelesaian ditangani dengan sukses',
    'The settlement exception has been handled and failed. Reason:': 'Pengecualian penyelesaian telah ditangani dan gagal. Alasan:',
    'Audit completed successfully': 'Audit selesai dengan sukses',
    'The verification failed. Reason:': 'Verifikasi gagal. Alasan:',
    'Payment successful': 'Pembayaran berhasil',
    'The refund failed. Reason:': 'Pengembalian dana gagal. Alasan:',
    'Please fill in the reason for cancelation': 'Silakan isi alasan pembatalan',
    'Reject successfully': 'Ubah dan batalkan berhasil',
    'Unable to perform rejection，reason：': 'Perubahan dan pembatalan gagal, alasan:',
    'Converted to appeal form successfully': 'Dikonversi menjadi bentuk banding dengan sukses',
    'Please select the passenger who needs to be rescheduled': 'Silahkan pilih penumpang yang perlu dijadwal ulang',
    'Please enter the rescheduling fee': 'Silahkan masukkan biaya penjadwalan ulang',
    'Please enter the upgrade fee for the selected passenger': 'Silakan masukkan biaya upgrade untuk penumpang yang dipilih',
    'Please select the flight segment to be rebooked': 'Silakan pilih segmen penerbangan yang akan dipesan ulang',
    'Please enter the': 'Silakan masukkan',
    'Flight number to change flight information': 'Nomor penerbangan untuk mengubah informasi penerbangan',
    'Departure point for changing flight information': 'Titik keberangkatan untuk mengubah informasi penerbangan',
    'Arrival place for changing flight information': 'Tempat kedatangan untuk mengubah informasi penerbangan',
    'Flight dates for changing flight information': 'Tanggal penerbangan untuk mengubah informasi penerbangan',
    'Take-off and landing time for changing flight information': 'Waktu lepas landas dan mendarat untuk mengubah informasi penerbangan',
    'Class code for changing flight information': 'Kode kelas untuk mengubah informasi penerbangan',
    'Please enter the change order number': 'Silahkan masukkan nomor pesanan perubahan',
    'Please enter Change PNR': 'Silahkan masukkan Change PNR',
    'Please select a change type': 'Silahkan pilih tipe ganti',
    'Please enter the reason for the change': 'Silakan masukkan alasan perubahan',
    'Please enter the total rescheduling charge': 'Silakan masukkan total biaya penjadwalan ulang',
    'Please enter the total fare difference': 'Silahkan masukkan total biaya upgrade',
    'Please enter the amount receivable': 'Silahkan masukkan jumlah penerima',
    'Please enter the change ticket settlement price': 'Silakan masukkan harga penyelesaian tiket perubahan',
    'Please enter change profit': 'Silakan masukkan uang kembalian',
    'Submit change successfully': 'Menyerahkan perubahan dengan sukses',
    'New purchase record successful': 'Catatan pembelian baru berhasil!',
    'Deleted purchase record successfully': 'Catatan pembelian yang dihapus berhasil',
    'Modify the remarks form successfully': 'Ubah komentar pada formulir pengembalian dana dengan sukses',
    'Failed to modify the remarks on the refund form. Reason:': 'Gagal mengubah pernyataan pada formulir pengembalian dana. Alasan:',
    'The remarks on the refund form cannot be empty': 'Gagal mengubah pernyataan pada formulir pengembalian dana. Alasan: Pernyataan pada formulir pengembalian uang tidak bisa kosong!',
    'Modified Financial Remarks Successfully': 'Modifikasi Keterangan Keuangan Berhasil',
    'Failed to modify financial remarks, reason:': 'Gagal mengubah pernyataan keuangan, alasan:',
    'Failed to modify financial remarks. Reason: Financial remarks cannot be empty': 'Gagal mengubah komentar keuangan. Alasan: Ucapan keuangan tidak bisa kosong!',
    'Modify and change the order status and the order is successful': 'Ubah dan ubah status pesanan dan urutannya berhasil',
    'The order failed to modify and change the signing status. Reason:': 'Perintah gagal mengubah dan mengubah status penandatanganan. Alasan:',
    'Modified segment information successfully': 'Informasi segmen yang dimodifikasi berhasil',
    'Product information is empty': 'Informasi produk kosong',
    'Parameter error, please resubmit': 'Parameter error, silakan kirim ulang',
    'Ticket Change Application': 'Masukkan urutan perubahan',
    'Get change information': 'Dapatkan informasi perubahan',
    'Ticketing segment information': 'Informasi segmen tiket',
    'Original passenger info': 'Informasi Penumpang Tiket',
    'Change passenger info': 'Ubah Informasi Penumpang',
    'Next step': 'Langkah selanjutnya',
    'The passenger cannot be empty': 'Penumpang tidak bisa dikosongkan',
    'Payment channel cannot be empty': 'Saluran pembayaran tidak dapat dikosongkan',
    'Purchase account cannot be empty': 'Akun pembelian tidak dapat dikosongkan',
    'Purchase password cannot be null': 'Kata sandi pembelian tidak bisa dibatalkan',
    'The discount amount cannot be empty': 'Jumlah diskon tidak bisa dikosongkan',
    'Change flight segment cannot be empty': 'Ubah segmen penerbangan tidak bisa dikosongkan',
    'Change the passenger cannot be empty': 'Mengubah penumpang tidak bisa dikosongkan',
    'The new ticket number is incorrect': 'Nomor tiket baru tidak benar',
    'Please enter the total platform change fee': 'Silakan masukkan total platform perubahan biaya',
    'Save and change the order successfully': 'Simpan dan ubah pesanan dengan sukses',
    'Successfully obtained ticketing information': 'Berhasil memperoleh informasi tiket',
    'Get the change information successfully': 'Dapatkan informasi perubahan dengan sukses',
    'Purchase type cannot be empty': 'Jenis pembelian tidak bisa kosong!',
    'The purchasing channel cannot be empty': 'Saluran pembelian tidak bisa kosong!',
    'The payment channel cannot be empty': 'Saluran pembayaran tidak bisa kosong!',
    'The purchase account cannot be empty': 'Rekening pembelian tidak bisa kosong!',
    'Purchase password cannot be empty': 'Kata sandi pembelian tidak boleh kosong!',
    'The purchase order number cannot be empty': 'Nomor pesanan pembelian tidak bisa kosong!',
    'The transaction serial number cannot be empty': 'Nomor seri transaksi tidak bisa kosong!'
  }
}



// WEBPACK FOOTER //
// ./src/language/myId.js